import {
  BarChart3,
  Brain,
  Building2,
  Check,
  CreditCard,
  Eye,
  EyeOff,
  Plus,
  Save,
  Shield,
  Trash2,
  Upload,
  Users,
  User,
  X,
  HelpCircle,
  Lightbulb,
  ShoppingCart,
  TrendingUp,
  Calendar,
  DollarSign,
  Sparkles,
  Zap,
  Crown,
  ArrowDown,
  TrendingDown,
  AlertTriangle,
  X as XIcon,
  FileText,
  Download,
  ArrowUp,
  Settings2,
  Target,
  GanttChartSquare,
  CalendarDays,
  Trophy,
  Bell,
  Layers,
  Target as TargetIcon,
  UserCheck,
  ShieldCheck,
  Workflow,
  Medal,
  ImagePlus,
  Flame,
  Award,
  Clock,
  Info
} from 'lucide-react';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { BILLING_INTERVALS, getIntervalMonths } from '../../utils/pricing';
import { useSearchParams } from 'react-router-dom';
import { useApi } from '../../hooks/useApi';
import { useCurrency } from '../../hooks/useCurrency';
import { getCurrencySymbol } from '../../utils/pricing';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import { useGoalsSettings } from '../../contexts/GoalsSettingsContext';
import { openRazorpayCheckout } from '../../utils/razorpayCheckout';
import { Switch, InputNumber, ConfigProvider } from 'antd';
import { SERVER_URL } from '../../utils/serverConfig';
import { isS5Organisation } from '../../utils/organization';
import PageAnimationWrapper from '../../components/PageAnimationWrapper';
import toast from 'react-hot-toast';
import CardForm from '../../components/CardForm';
import { Modal, Card as AntCard, Statistic, Badge, Typography, Space, Divider, Alert, Button as AntButton, Tag, Spin, Button } from 'antd';
import { motion, AnimatePresence } from 'framer-motion';
import AntDropdown from '../../components/UI/AntDropdown';
import DeleteStructureConfirmModal from './DeleteStructureConfirmModal';
import { cardVariants, fadeInVariants, pageVariants, pageTransition } from '../../utils/animations';
const { Title, Text, Paragraph } = Typography;

// Helper function to get flag emoji from country code (ISO 3166-1 alpha-2)
const getCountryFlag = (countryCode) => {
  if (!countryCode || countryCode.length !== 2) return '🌐';

  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char => 127397 + char.charCodeAt(0));

  return String.fromCodePoint(...codePoints);
};

// Country codes for phone number selection (all countries, sorted alphabetically)
const countryCodes = [
  { code: '+93', country: 'AF', name: 'Afghanistan' },
  { code: '+355', country: 'AL', name: 'Albania' },
  { code: '+213', country: 'DZ', name: 'Algeria' },
  { code: '+1-684', country: 'AS', name: 'American Samoa' },
  { code: '+376', country: 'AD', name: 'Andorra' },
  { code: '+244', country: 'AO', name: 'Angola' },
  { code: '+1-264', country: 'AI', name: 'Anguilla' },
  { code: '+1-268', country: 'AG', name: 'Antigua and Barbuda' },
  { code: '+54', country: 'AR', name: 'Argentina' },
  { code: '+374', country: 'AM', name: 'Armenia' },
  { code: '+297', country: 'AW', name: 'Aruba' },
  { code: '+61', country: 'AU', name: 'Australia' },
  { code: '+43', country: 'AT', name: 'Austria' },
  { code: '+994', country: 'AZ', name: 'Azerbaijan' },
  { code: '+1-242', country: 'BS', name: 'Bahamas' },
  { code: '+973', country: 'BH', name: 'Bahrain' },
  { code: '+880', country: 'BD', name: 'Bangladesh' },
  { code: '+1-246', country: 'BB', name: 'Barbados' },
  { code: '+375', country: 'BY', name: 'Belarus' },
  { code: '+32', country: 'BE', name: 'Belgium' },
  { code: '+501', country: 'BZ', name: 'Belize' },
  { code: '+229', country: 'BJ', name: 'Benin' },
  { code: '+1-441', country: 'BM', name: 'Bermuda' },
  { code: '+975', country: 'BT', name: 'Bhutan' },
  { code: '+591', country: 'BO', name: 'Bolivia' },
  { code: '+387', country: 'BA', name: 'Bosnia and Herzegovina' },
  { code: '+267', country: 'BW', name: 'Botswana' },
  { code: '+55', country: 'BR', name: 'Brazil' },
  { code: '+673', country: 'BN', name: 'Brunei' },
  { code: '+359', country: 'BG', name: 'Bulgaria' },
  { code: '+226', country: 'BF', name: 'Burkina Faso' },
  { code: '+257', country: 'BI', name: 'Burundi' },
  { code: '+855', country: 'KH', name: 'Cambodia' },
  { code: '+237', country: 'CM', name: 'Cameroon' },
  { code: '+1', country: 'CA', name: 'Canada' },
  { code: '+238', country: 'CV', name: 'Cape Verde' },
  { code: '+1-345', country: 'KY', name: 'Cayman Islands' },
  { code: '+236', country: 'CF', name: 'Central African Republic' },
  { code: '+235', country: 'TD', name: 'Chad' },
  { code: '+56', country: 'CL', name: 'Chile' },
  { code: '+86', country: 'CN', name: 'China' },
  { code: '+57', country: 'CO', name: 'Colombia' },
  { code: '+269', country: 'KM', name: 'Comoros' },
  { code: '+242', country: 'CG', name: 'Congo' },
  { code: '+243', country: 'CD', name: 'Congo (DRC)' },
  { code: '+682', country: 'CK', name: 'Cook Islands' },
  { code: '+506', country: 'CR', name: 'Costa Rica' },
  { code: '+385', country: 'HR', name: 'Croatia' },
  { code: '+53', country: 'CU', name: 'Cuba' },
  { code: '+599', country: 'CW', name: 'Curaçao' },
  { code: '+357', country: 'CY', name: 'Cyprus' },
  { code: '+420', country: 'CZ', name: 'Czech Republic' },
  { code: '+225', country: 'CI', name: "Côte d'Ivoire" },
  { code: '+45', country: 'DK', name: 'Denmark' },
  { code: '+253', country: 'DJ', name: 'Djibouti' },
  { code: '+1-767', country: 'DM', name: 'Dominica' },
  { code: '+1-809', country: 'DO', name: 'Dominican Republic' },
  { code: '+593', country: 'EC', name: 'Ecuador' },
  { code: '+20', country: 'EG', name: 'Egypt' },
  { code: '+503', country: 'SV', name: 'El Salvador' },
  { code: '+240', country: 'GQ', name: 'Equatorial Guinea' },
  { code: '+291', country: 'ER', name: 'Eritrea' },
  { code: '+372', country: 'EE', name: 'Estonia' },
  { code: '+268', country: 'SZ', name: 'Eswatini' },
  { code: '+251', country: 'ET', name: 'Ethiopia' },
  { code: '+500', country: 'FK', name: 'Falkland Islands' },
  { code: '+298', country: 'FO', name: 'Faroe Islands' },
  { code: '+679', country: 'FJ', name: 'Fiji' },
  { code: '+358', country: 'FI', name: 'Finland' },
  { code: '+33', country: 'FR', name: 'France' },
  { code: '+594', country: 'GF', name: 'French Guiana' },
  { code: '+689', country: 'PF', name: 'French Polynesia' },
  { code: '+241', country: 'GA', name: 'Gabon' },
  { code: '+220', country: 'GM', name: 'Gambia' },
  { code: '+995', country: 'GE', name: 'Georgia' },
  { code: '+49', country: 'DE', name: 'Germany' },
  { code: '+233', country: 'GH', name: 'Ghana' },
  { code: '+350', country: 'GI', name: 'Gibraltar' },
  { code: '+30', country: 'GR', name: 'Greece' },
  { code: '+299', country: 'GL', name: 'Greenland' },
  { code: '+1-473', country: 'GD', name: 'Grenada' },
  { code: '+590', country: 'GP', name: 'Guadeloupe' },
  { code: '+1-671', country: 'GU', name: 'Guam' },
  { code: '+502', country: 'GT', name: 'Guatemala' },
  { code: '+224', country: 'GN', name: 'Guinea' },
  { code: '+245', country: 'GW', name: 'Guinea-Bissau' },
  { code: '+592', country: 'GY', name: 'Guyana' },
  { code: '+509', country: 'HT', name: 'Haiti' },
  { code: '+504', country: 'HN', name: 'Honduras' },
  { code: '+852', country: 'HK', name: 'Hong Kong' },
  { code: '+36', country: 'HU', name: 'Hungary' },
  { code: '+354', country: 'IS', name: 'Iceland' },
  { code: '+91', country: 'IN', name: 'India' },
  { code: '+62', country: 'ID', name: 'Indonesia' },
  { code: '+98', country: 'IR', name: 'Iran' },
  { code: '+964', country: 'IQ', name: 'Iraq' },
  { code: '+353', country: 'IE', name: 'Ireland' },
  { code: '+972', country: 'IL', name: 'Israel' },
  { code: '+39', country: 'IT', name: 'Italy' },
  { code: '+1-876', country: 'JM', name: 'Jamaica' },
  { code: '+81', country: 'JP', name: 'Japan' },
  { code: '+962', country: 'JO', name: 'Jordan' },
  { code: '+7', country: 'KZ', name: 'Kazakhstan' },
  { code: '+254', country: 'KE', name: 'Kenya' },
  { code: '+686', country: 'KI', name: 'Kiribati' },
  { code: '+383', country: 'XK', name: 'Kosovo' },
  { code: '+965', country: 'KW', name: 'Kuwait' },
  { code: '+996', country: 'KG', name: 'Kyrgyzstan' },
  { code: '+856', country: 'LA', name: 'Laos' },
  { code: '+371', country: 'LV', name: 'Latvia' },
  { code: '+961', country: 'LB', name: 'Lebanon' },
  { code: '+266', country: 'LS', name: 'Lesotho' },
  { code: '+231', country: 'LR', name: 'Liberia' },
  { code: '+218', country: 'LY', name: 'Libya' },
  { code: '+423', country: 'LI', name: 'Liechtenstein' },
  { code: '+370', country: 'LT', name: 'Lithuania' },
  { code: '+352', country: 'LU', name: 'Luxembourg' },
  { code: '+853', country: 'MO', name: 'Macau' },
  { code: '+261', country: 'MG', name: 'Madagascar' },
  { code: '+265', country: 'MW', name: 'Malawi' },
  { code: '+60', country: 'MY', name: 'Malaysia' },
  { code: '+960', country: 'MV', name: 'Maldives' },
  { code: '+223', country: 'ML', name: 'Mali' },
  { code: '+356', country: 'MT', name: 'Malta' },
  { code: '+692', country: 'MH', name: 'Marshall Islands' },
  { code: '+596', country: 'MQ', name: 'Martinique' },
  { code: '+222', country: 'MR', name: 'Mauritania' },
  { code: '+230', country: 'MU', name: 'Mauritius' },
  { code: '+52', country: 'MX', name: 'Mexico' },
  { code: '+691', country: 'FM', name: 'Micronesia' },
  { code: '+373', country: 'MD', name: 'Moldova' },
  { code: '+377', country: 'MC', name: 'Monaco' },
  { code: '+976', country: 'MN', name: 'Mongolia' },
  { code: '+382', country: 'ME', name: 'Montenegro' },
  { code: '+1-664', country: 'MS', name: 'Montserrat' },
  { code: '+212', country: 'MA', name: 'Morocco' },
  { code: '+258', country: 'MZ', name: 'Mozambique' },
  { code: '+95', country: 'MM', name: 'Myanmar' },
  { code: '+264', country: 'NA', name: 'Namibia' },
  { code: '+674', country: 'NR', name: 'Nauru' },
  { code: '+977', country: 'NP', name: 'Nepal' },
  { code: '+31', country: 'NL', name: 'Netherlands' },
  { code: '+687', country: 'NC', name: 'New Caledonia' },
  { code: '+64', country: 'NZ', name: 'New Zealand' },
  { code: '+505', country: 'NI', name: 'Nicaragua' },
  { code: '+227', country: 'NE', name: 'Niger' },
  { code: '+234', country: 'NG', name: 'Nigeria' },
  { code: '+850', country: 'KP', name: 'North Korea' },
  { code: '+389', country: 'MK', name: 'North Macedonia' },
  { code: '+47', country: 'NO', name: 'Norway' },
  { code: '+968', country: 'OM', name: 'Oman' },
  { code: '+92', country: 'PK', name: 'Pakistan' },
  { code: '+680', country: 'PW', name: 'Palau' },
  { code: '+970', country: 'PS', name: 'Palestine' },
  { code: '+507', country: 'PA', name: 'Panama' },
  { code: '+675', country: 'PG', name: 'Papua New Guinea' },
  { code: '+595', country: 'PY', name: 'Paraguay' },
  { code: '+51', country: 'PE', name: 'Peru' },
  { code: '+63', country: 'PH', name: 'Philippines' },
  { code: '+48', country: 'PL', name: 'Poland' },
  { code: '+351', country: 'PT', name: 'Portugal' },
  { code: '+1-787', country: 'PR', name: 'Puerto Rico' },
  { code: '+974', country: 'QA', name: 'Qatar' },
  { code: '+40', country: 'RO', name: 'Romania' },
  { code: '+7', country: 'RU', name: 'Russia' },
  { code: '+250', country: 'RW', name: 'Rwanda' },
  { code: '+262', country: 'RE', name: 'Réunion' },
  { code: '+1-869', country: 'KN', name: 'Saint Kitts and Nevis' },
  { code: '+1-758', country: 'LC', name: 'Saint Lucia' },
  { code: '+508', country: 'PM', name: 'Saint Pierre and Miquelon' },
  { code: '+1-784', country: 'VC', name: 'Saint Vincent and the Grenadines' },
  { code: '+685', country: 'WS', name: 'Samoa' },
  { code: '+378', country: 'SM', name: 'San Marino' },
  { code: '+239', country: 'ST', name: 'São Tomé and Príncipe' },
  { code: '+966', country: 'SA', name: 'Saudi Arabia' },
  { code: '+221', country: 'SN', name: 'Senegal' },
  { code: '+381', country: 'RS', name: 'Serbia' },
  { code: '+248', country: 'SC', name: 'Seychelles' },
  { code: '+232', country: 'SL', name: 'Sierra Leone' },
  { code: '+65', country: 'SG', name: 'Singapore' },
  { code: '+1-721', country: 'SX', name: 'Sint Maarten' },
  { code: '+421', country: 'SK', name: 'Slovakia' },
  { code: '+386', country: 'SI', name: 'Slovenia' },
  { code: '+677', country: 'SB', name: 'Solomon Islands' },
  { code: '+252', country: 'SO', name: 'Somalia' },
  { code: '+27', country: 'ZA', name: 'South Africa' },
  { code: '+82', country: 'KR', name: 'South Korea' },
  { code: '+211', country: 'SS', name: 'South Sudan' },
  { code: '+34', country: 'ES', name: 'Spain' },
  { code: '+94', country: 'LK', name: 'Sri Lanka' },
  { code: '+249', country: 'SD', name: 'Sudan' },
  { code: '+597', country: 'SR', name: 'Suriname' },
  { code: '+46', country: 'SE', name: 'Sweden' },
  { code: '+41', country: 'CH', name: 'Switzerland' },
  { code: '+963', country: 'SY', name: 'Syria' },
  { code: '+886', country: 'TW', name: 'Taiwan' },
  { code: '+992', country: 'TJ', name: 'Tajikistan' },
  { code: '+255', country: 'TZ', name: 'Tanzania' },
  { code: '+66', country: 'TH', name: 'Thailand' },
  { code: '+670', country: 'TL', name: 'Timor-Leste' },
  { code: '+228', country: 'TG', name: 'Togo' },
  { code: '+676', country: 'TO', name: 'Tonga' },
  { code: '+1-868', country: 'TT', name: 'Trinidad and Tobago' },
  { code: '+216', country: 'TN', name: 'Tunisia' },
  { code: '+90', country: 'TR', name: 'Turkey' },
  { code: '+993', country: 'TM', name: 'Turkmenistan' },
  { code: '+1-649', country: 'TC', name: 'Turks and Caicos Islands' },
  { code: '+688', country: 'TV', name: 'Tuvalu' },
  { code: '+256', country: 'UG', name: 'Uganda' },
  { code: '+380', country: 'UA', name: 'Ukraine' },
  { code: '+971', country: 'AE', name: 'United Arab Emirates' },
  { code: '+44', country: 'GB', name: 'United Kingdom' },
  { code: '+1', country: 'US', name: 'United States' },
  { code: '+598', country: 'UY', name: 'Uruguay' },
  { code: '+1-340', country: 'VI', name: 'U.S. Virgin Islands' },
  { code: '+998', country: 'UZ', name: 'Uzbekistan' },
  { code: '+678', country: 'VU', name: 'Vanuatu' },
  { code: '+379', country: 'VA', name: 'Vatican City' },
  { code: '+58', country: 'VE', name: 'Venezuela' },
  { code: '+84', country: 'VN', name: 'Vietnam' },
  { code: '+1-284', country: 'VG', name: 'British Virgin Islands' },
  { code: '+681', country: 'WF', name: 'Wallis and Futuna' },
  { code: '+967', country: 'YE', name: 'Yemen' },
  { code: '+260', country: 'ZM', name: 'Zambia' },
  { code: '+263', country: 'ZW', name: 'Zimbabwe' },
];

const Settings = () => {
  const { user, updateProfile } = useAuth();
  const { mode } = useTheme();
  const isDark = mode === 'dark';
  const [searchParams, setSearchParams] = useSearchParams();
  const api = useApi();
  const [billingCurrency, setBillingCurrency] = useState(null);
  const { symbol, getPrice } = useCurrency({ billingCurrency });
  const { settings: goalsSettings, updateSettings, updateSoftSkill, addSoftSkill, removeSoftSkill, updateBadgeRange, updateScoreRange, saveSettings, uploadIcon, uploadBadgeIcon, uploadStreakIcon, removeIcon, removeBadgeIcon, removeStreakIcon, hasUnsavedChanges, resetToSaved } = useGoalsSettings();

  // Get section from URL parameter, default to 'organization'
  const urlSection = searchParams.get('section');
  const [activeSection, setActiveSection] = useState(urlSection || 'organization');

  // Update activeSection when URL parameter changes
  useEffect(() => {
    const section = searchParams.get('section');
    if (section) {
      setActiveSection(section);
    }
  }, [searchParams]);

  // Redirect non-S5 users away from Goals Settings (e.g. direct URL)
  useEffect(() => {
    if (activeSection === 'goals_settings' && user && !isS5Organisation(user)) {
      setActiveSection('organization');
      setSearchParams({ section: 'organization' }, { replace: true });
    }
  }, [activeSection, user, setSearchParams]);

  /** @type {string} Theme state ('dark' | 'light') */
  const [theme, setTheme] = useState('dark');
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [savingGoalsSettings, setSavingGoalsSettings] = useState(false);

  // Unsaved changes guard state
  const [showUnsavedModal, setShowUnsavedModal] = useState(false);
  const pendingNavRef = useRef(null); // { type: 'section', id } | { type: 'route' }

  // Organization Profile State
  const [orgProfile, setOrgProfile] = useState({
    name: '',
    website: '',
    address: '',
    timezone: 'UTC',
    phoneCountryCode: '+1',
    phone: '',
    industry: '',
    size: ''
  });

  // User Profile State
  const [userProfile, setUserProfile] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });

  // Logo upload state
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [phoneError, setPhoneError] = useState('');

  // Security State
  const [security, setSecurity] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  // Team Structure State
  const [teamStructure, setTeamStructure] = useState([]);
  const [editingSummary, setEditingSummary] = useState(null); // { levelId, positionId }

  // Billing State
  const [billing, setBilling] = useState({
    plan: {
      name: 'No Plan',
      cycle: 'N/A',
      status: 'None',
      price: `${symbol}0/month`,
      features: []
    },
    usage: {
      teamMembers: { current: 0, max: 0 },
      storage: { current: '0GB', max: '0GB' },
      apiCalls: { current: '0', max: '0' }
    },
    payment: {
      cardNumber: 'No payment method',
      expiry: 'N/A',
      address: 'No address on file'
    },
    nextBilling: {
      date: 'N/A',
      amount: `${symbol}0.00`
    },
    subscriptionId: null,
    cancelAtPeriodEnd: false,
    currentPeriodEnd: null,
    trialEnd: null,
    paymentMethods: [],
    defaultPaymentMethod: null,
    paidMembersCount: 0,
    totalUsersCount: 0
  });

  const [billingLoading, setBillingLoading] = useState(false);
  const [upgradeProcessingPlan, setUpgradeProcessingPlan] = useState(null);
  const [upgradeMemberCount, setUpgradeMemberCount] = useState({}); // Store member count per plan: { 'standard': 1, 'premium': 1 }
  const [couponCode, setCouponCode] = useState(''); // Coupon code entered by user
  const [actualCouponId, setActualCouponId] = useState(null); // Actual coupon ID from Stripe
  const [couponValid, setCouponValid] = useState(null); // null = not checked, true = valid, false = invalid
  const [couponVerifying, setCouponVerifying] = useState(false); // Loading state for verification
  const [couponDiscount, setCouponDiscount] = useState(null); // Discount info
  const couponTimeoutRef = useRef(null); // For debouncing coupon verification

  // Invoice State
  const [invoices, setInvoices] = useState([]);
  const [invoicesLoading, setInvoicesLoading] = useState(false);
  const [downgradeProcessingPlan, setDowngradeProcessingPlan] = useState(null);
  const [showDowngradeConfirmModal, setShowDowngradeConfirmModal] = useState(false);
  const [pendingDowngrade, setPendingDowngrade] = useState(null);
  const [deleteStructureConfirm, setDeleteStructureConfirm] = useState({ visible: false, type: null, levelId: null, positionId: null, positionName: '', affectedMembers: [], loading: false });
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [planConfirmed, setPlanConfirmed] = useState(false);
  // Billing term key from utils/pricing (monthly | quarterly | halfyearly | yearly).
  const [billingInterval, setBillingInterval] = useState('monthly');
  const [showTooltip, setShowTooltip] = useState(null);
  const [organization, setOrganization] = useState(null);

  const timezones = [
    { value: 'UTC', label: 'Coordinated Universal Time (UTC)' },
    { value: 'UTC-12', label: 'Baker Island Time (UTC-12)' },
    { value: 'UTC-11', label: 'Samoa Standard Time (UTC-11)' },
    { value: 'UTC-10', label: 'Hawaii-Aleutian Standard Time (UTC-10)' },
    { value: 'UTC-9', label: 'Alaska Standard Time (UTC-9)' },
    { value: 'UTC-8', label: 'Pacific Standard Time (UTC-8)' },
    { value: 'UTC-7', label: 'Mountain Standard Time (UTC-7)' },
    { value: 'UTC-6', label: 'Central Standard Time (UTC-6)' },
    { value: 'UTC-5', label: 'Eastern Standard Time (UTC-5)' },
    { value: 'UTC-4', label: 'Atlantic Standard Time (UTC-4)' },
    { value: 'UTC-3', label: 'Argentina Standard Time (UTC-3)' },
    { value: 'UTC-2', label: 'South Georgia Standard Time (UTC-2)' },
    { value: 'UTC-1', label: 'Azores Standard Time (UTC-1)' },
    { value: 'UTC+0', label: 'Greenwich Mean Time (UTC+0)' },
    { value: 'UTC+1', label: 'Central European Time (UTC+1)' },
    { value: 'UTC+2', label: 'Eastern European Time (UTC+2)' },
    { value: 'UTC+3', label: 'Moscow Standard Time (UTC+3)' },
    { value: 'UTC+3:30', label: 'Iran Standard Time (UTC+3:30)' },
    { value: 'UTC+4', label: 'Gulf Standard Time (UTC+4)' },
    { value: 'UTC+4:30', label: 'Afghanistan Time (UTC+4:30)' },
    { value: 'UTC+5', label: 'Pakistan Standard Time (UTC+5)' },
    { value: 'UTC+5:30', label: 'India Standard Time (UTC+5:30)' },
    { value: 'UTC+5:45', label: 'Nepal Time (UTC+5:45)' },
    { value: 'UTC+6', label: 'Bangladesh Standard Time (UTC+6)' },
    { value: 'UTC+6:30', label: 'Myanmar Time (UTC+6:30)' },
    { value: 'UTC+7', label: 'Indochina Time (UTC+7)' },
    { value: 'UTC+8', label: 'China Standard Time (UTC+8)' },
    { value: 'UTC+8:45', label: 'Australian Central Western Time (UTC+8:45)' },
    { value: 'UTC+9', label: 'Japan Standard Time (UTC+9)' },
    { value: 'UTC+9:30', label: 'Australian Central Standard Time (UTC+9:30)' },
    { value: 'UTC+10', label: 'Australian Eastern Standard Time (UTC+10)' },
    { value: 'UTC+10:30', label: 'Lord Howe Standard Time (UTC+10:30)' },
    { value: 'UTC+11', label: 'Solomon Islands Time (UTC+11)' },
    { value: 'UTC+11:30', label: 'Norfolk Island Time (UTC+11:30)' },
    { value: 'UTC+12', label: 'New Zealand Standard Time (UTC+12)' },
    { value: 'UTC+12:45', label: 'Chatham Standard Time (UTC+12:45)' },
    { value: 'UTC+13', label: 'Phoenix Islands Time (UTC+13)' },
    { value: 'UTC+14', label: 'Line Islands Time (UTC+14)' }
  ];

  const navigation = [
    { id: 'organization', label: 'Profile', icon: Building2 },
    { id: 'security', label: 'Security & Login', icon: Shield },
    // Only show team, billing for admins; Goals Settings only for S5 org admins
    ...(user?.role === 'org_admin' || user?.role === 'main_admin' ? [
      { id: 'team', label: 'Team Structure', icon: Users },
      { id: 'billing', label: 'Billing', icon: CreditCard },
      ...(isS5Organisation(user) ? [{ id: 'goals_settings', label: 'Goals Settings', icon: Settings2 }] : [])
    ] : [])
  ];

  const fetchOrganizationProfile = useCallback(async () => {
    try {
      setLoading(true);
      // Use different endpoint based on user role
      const endpoint = user?.role === 'org_user'
        ? '/api/v1/organizations/basic-info'
        : '/api/v1/organizations/profile';

      const response = await api.get(endpoint);
      const org = response.data.data.organization;

      // Parse phone number to extract country code and number
      let phoneCountryCode = '+1';
      let phoneNumber = '';

      if (org.phone) {
        const phoneMatch = org.phone.match(/^(\+\d+(?:-\d+)?)\s*(.+)$/);
        if (phoneMatch) {
          phoneCountryCode = phoneMatch[1];
          phoneNumber = phoneMatch[2];
        } else {
          phoneNumber = org.phone;
        }
      }

      // Normalize timezone: 'UTC+0' and 'UTC' are the same, use 'UTC' for consistency
      let timezone = org.settings?.timezone || 'UTC';
      if (timezone === 'UTC+0') {
        timezone = 'UTC';
      }

      setOrgProfile({
        name: org.name || '',
        website: org.website || '',
        address: org.address?.street || '',
        timezone: timezone,
        phoneCountryCode: phoneCountryCode,
        phone: phoneNumber,
        industry: org.industry || '',
        size: org.size || ''
      });
    } catch (error) {
      console.error('Error fetching organization profile:', error);
      toast.error('Failed to load organization profile');
    } finally {
      setLoading(false);
    }
  }, [user?.role]); // Add user.role dependency since it's used in the function

  const fetchUserProfile = useCallback(async () => {
    try {
      if (user) {
        setUserProfile({
          firstName: user.firstName || '',
          lastName: user.lastName || '',
          email: user.email || ''
        });
      }
    } catch (error) {
      console.error('Error fetching user profile:', error);
      toast.error('Failed to load user profile');
    }
  }, [user?.id, user?.firstName, user?.lastName, user?.email]); // Only depend on specific user fields

  const handleUserProfileSave = async () => {
    try {
      setSaving(true);

      const result = await updateProfile({
        firstName: userProfile.firstName,
        lastName: userProfile.lastName
      });

      if (result.success) {
        toast.success('User profile updated successfully!');
      }
    } catch (error) {
      console.error('Error updating user profile:', error);
      toast.error('Failed to update user profile');
    } finally {
      setSaving(false);
    }
  };

  // Phone number validation function
  const validatePhoneNumber = (phone) => {
    // Remove all non-digit characters for validation
    const digitsOnly = phone.replace(/\D/g, '');

    // Check minimum length (7 digits for most countries)
    if (digitsOnly.length < 7) {
      return 'Phone number must be at least 7 digits long';
    }

    // Check maximum length (15 digits is the international standard)
    if (digitsOnly.length > 15) {
      return 'Phone number cannot exceed 15 digits';
    }

    // Basic format validation - should contain only digits, spaces, dashes, parentheses, and plus signs
    const phoneRegex = /^[\d\s\-()+\s]+$/;
    if (!phoneRegex.test(phone)) {
      return 'Phone number contains invalid characters';
    }

    return '';
  };

  const handlePhoneChange = (e) => {
    const phoneValue = e.target.value;
    setOrgProfile({ ...orgProfile, phone: phoneValue });

    // Clear error if field is empty (optional field)
    if (!phoneValue.trim()) {
      setPhoneError('');
      return;
    }

    // Validate phone number
    const error = validatePhoneNumber(phoneValue);
    setPhoneError(error);
  };

  const fetchBillingData = useCallback(async () => {
    try {
      setBillingLoading(true);

      const response = await api.get('/api/v1/billing/profile');

      if (response.data.success) {
        const data = response.data.data;

        // Derive correct currency symbol from the org's stored currency
        const resolvedCurrency = data.orgPlanCurrency || (data.paymentGateway === 'razorpay' ? 'INR' : 'USD');
        const billSymbol = getCurrencySymbol(resolvedCurrency);

        // Transform API data to UI format with organization-level subscription data
        const transformedBilling = {
          plan: {
            name: data.orgPlanSelection ? `${data.orgPlanSelection.charAt(0).toUpperCase() + data.orgPlanSelection.slice(1)} Plan` : 'No Plan',
            cycle: 'Monthly',
            status: data.subscriptionStatus ? data.subscriptionStatus.charAt(0).toUpperCase() + data.subscriptionStatus.slice(1) : 'None',
            price: data.orgPlanAmount ? `${billSymbol}${data.orgPlanAmount}/month` : `${billSymbol}0/month`,
            features: getPlanFeatures(data.orgPlanSelection)
          },
          // Organization-level subscription data
          orgPlanSelection: data.orgPlanSelection,
          orgPlanAmount: data.orgPlanAmount,
          subscriptionStatus: data.subscriptionStatus,
          currentPeriodEnd: data.currentPeriodEnd,
          // Slots data
          paidMemberSlots: data.paidMemberSlots || 1,
          usedMemberSlots: data.usedMemberSlots || 1,
          remainingSlots: data.remainingSlots || 0,
          // Gateway data
          paymentGateway: data.paymentGateway || 'stripe',
          stripeCustomerId: data.stripeCustomerId,
          stripeSubscriptionId: data.stripeSubscriptionId,
          razorpayCustomerId: data.razorpayCustomerId,
          razorpaySubscriptionId: data.razorpaySubscriptionId,
          // Legacy fields
          usage: {
            teamMembers: { current: data.paidUsers || 0, max: data.orgPlanSelection ? 'Unlimited' : 0 },
            storage: { current: '0GB', max: data.orgPlanSelection ? '100GB' : '0GB' },
            apiCalls: { current: '0', max: data.orgPlanSelection ? '5M' : '0' }
          },
          payment: {
            cardNumber: data.stripeCustomerId ? '•••• •••• •••• ••••' : 'No payment method',
            expiry: 'N/A',
            address: 'Managed by Stripe'
          },
          nextBilling: {
            date: data.currentPeriodEnd ? new Date(data.currentPeriodEnd).toLocaleDateString() : 'N/A',
            amount: data.orgPlanAmount && data.paidMemberSlots ? `${billSymbol}${(data.orgPlanAmount * data.paidMemberSlots).toFixed(2)}` : `${billSymbol}0.00`
          },
          subscriptionId: data.stripeSubscriptionId,
          cancelAtPeriodEnd: data.cancelAtPeriodEnd || false,
          trialEnd: data.trialEnd,
          userTrialEndDate: data.userTrialEndDate, // For free plan users
          paymentMethods: [], // Preserve payment methods array
          defaultPaymentMethod: null, // Preserve default payment method
          paidMembersCount: 0 // Preserve paid members count
        };

        setBilling(transformedBilling);
        setBillingCurrency(resolvedCurrency);
        // Also update organization state with billing data
        setOrganization(prev => ({
          ...prev,
          ...data
        }));
      }
    } catch (error) {
      console.error('Error fetching billing data:', error);
      toast.error('Failed to load billing information');
    } finally {
      setBillingLoading(false);
    }
  }, []);

  const fetchInvoices = useCallback(async () => {
    try {
      setInvoicesLoading(true);

      if (billing.paymentGateway === 'razorpay' || billing.razorpayCustomerId) {
        const response = await api.get('/api/v1/razorpay-billing/invoices');
        if (response.data.success) {
          const rzpInvoices = (response.data.data || []).map(inv => ({
            id: inv.id,
            number: inv.id ? `RZP-${inv.id.substring(inv.id.length - 8).toUpperCase()}` : null,
            date: inv.createdAt || new Date().toISOString(),
            status: inv.status === 'captured' ? 'paid' : inv.status === 'authorized' ? 'open' : inv.status === 'failed' ? 'uncollectible' : inv.status,
            amountPaid: inv.status === 'captured' ? inv.amount : 0,
            amountDue: inv.status !== 'captured' ? inv.amount : 0,
            currency: (inv.currency || 'INR').toUpperCase(),
            description: inv.description || 'Razorpay Payment',
            invoicePdf: inv.id ? `${SERVER_URL}/api/v1/razorpay-billing/invoices/${inv.id}/download` : null,
            method: inv.method,
            isRazorpay: true,
          }));
          setInvoices(rzpInvoices);
        }
      } else {
        const response = await api.get('/api/v1/billing/invoices');
        if (response.data.success) {
          setInvoices(response.data.data.invoices || []);
        }
      }
    } catch (error) {
      console.error('Error fetching invoices:', error);
      toast.error('Failed to load invoices');
    } finally {
      setInvoicesLoading(false);
    }
  }, [billing.paymentGateway, billing.razorpayCustomerId]);

  const handleDownloadInvoice = async (invoiceId, invoiceNumber) => {
    try {
      const invoice = invoices.find(inv => inv.id === invoiceId);

      // Razorpay invoice: try Razorpay hosted URL, fallback to custom HTML
      if (invoice?.isRazorpay) {
        const response = await api.get(`/api/v1/razorpay-billing/invoices/${invoiceId}/download`);
        if (response.data.success && response.data.data) {
          if (response.data.data.source === 'razorpay' && response.data.data.invoiceUrl) {
            window.open(response.data.data.invoiceUrl, '_blank');
          } else if (response.data.data.source === 'custom' && response.data.data.html) {
            const newWindow = window.open('', '_blank');
            if (newWindow) {
              newWindow.document.write(response.data.data.html);
              newWindow.document.close();
            }
          }
        } else {
          toast.error('Failed to fetch invoice');
        }
        return;
      }

      // Stripe invoice: use PDF URL directly
      if (invoice && invoice.invoicePdf) {
        window.open(invoice.invoicePdf, '_blank');
        return;
      }

      // Fallback: Fetch PDF URL from Stripe API
      try {
        const response = await api.get(`/api/v1/billing/invoices/${invoiceId}/download`, {
          headers: { 'Accept': 'application/json' }
        });
        if (response.data.success && response.data.data.pdfUrl) {
          window.open(response.data.data.pdfUrl, '_blank');
        } else {
          throw new Error('PDF URL not found in response');
        }
      } catch (apiError) {
        const downloadUrl = `${SERVER_URL}/api/v1/billing/invoices/${invoiceId}/download`;
        window.open(downloadUrl, '_blank');
      }
    } catch (error) {
      console.error('Error downloading invoice:', error);
      toast.error('Failed to download invoice');
    }
  };

  const fetchPaymentMethods = useCallback(async () => {
    try {
      const response = await api.get('/api/v1/billing/payment-methods');

      if (response.data.success) {
        setBilling(prev => ({
          ...prev,
          paymentMethods: response.data.data.paymentMethods,
          defaultPaymentMethod: response.data.data.defaultPaymentMethod
        }));
      }
    } catch (error) {
      console.error('Error fetching payment methods:', error);
    }
  }, []);

  const fetchPaidMembersCount = useCallback(async () => {
    try {
      const response = await api.get('/api/v1/billing/paid-members-count');

      if (response.data.success) {
        setBilling(prev => ({
          ...prev,
          paidMembersCount: response.data.data.paidMembersCount
        }));
      }
    } catch (error) {
      console.error('Error fetching paid members count:', error);
    }
  }, []);

  const fetchTotalUsersCount = useCallback(async () => {
    try {
      const response = await api.get('/api/v1/users');

      if (response.data.success) {
        setBilling(prev => ({
          ...prev,
          totalUsersCount: response.data.data.users.length
        }));
      }
    } catch (error) {
      console.error('Error fetching total users count:', error);
    }
  }, []);

  const fetchTeamStructure = useCallback(async () => {
    try {
      const response = await api.get('/api/v1/organizations/team-structure');

      if (response.data.success && response.data.data.teamStructure) {
        // Transform the API data back to our component format
        const fetchedStructure = response.data.data.teamStructure.map(level => ({
          id: level.levelId,
          label: level.levelName,
          positions: level.positions.map(position => ({
            id: position.positionId,
            roleName: position.roleName,
            summary: position.summary || ''
          }))
        }));
        setTeamStructure(fetchedStructure);
      } else {
        setTeamStructure([]);
      }
    } catch (error) {
      console.error('Error fetching team structure:', error);
      setTeamStructure([]);
    }
  }, []);

  const fetchOrganization = useCallback(async () => {
    try {
      const response = await api.get('/api/v1/billing/profile');
      if (response.data.success) {
        setOrganization(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching organization:', error);
    }
  }, []);

  const handleSetDefaultPaymentMethod = async (paymentMethodId) => {
    try {
      const response = await api.post('/api/v1/billing/set-default-payment-method',
        { paymentMethodId }
      );

      if (response.data.success) {
        toast.success('Default payment method updated');
        fetchPaymentMethods(); // Refresh payment methods
      } else {
        toast.error(response.data.message || 'Failed to update default payment method');
      }
    } catch (error) {
      console.error('Error setting default payment method:', error);
      toast.error('Failed to update default payment method');
    }
  };

  const handleRemovePaymentMethod = async (paymentMethodId) => {
    if (!window.confirm('Are you sure you want to remove this payment method?')) {
      return;
    }

    try {
      const response = await api.delete(`/api/v1/billing/payment-methods/${paymentMethodId}`);

      if (response.data.success) {
        toast.success('Payment method removed');
        fetchPaymentMethods(); // Refresh payment methods
      } else {
        toast.error(response.data.message || 'Failed to remove payment method');
      }
    } catch (error) {
      console.error('Error removing payment method:', error);
      toast.error('Failed to remove payment method');
    }
  };

  const handleSelectPlan = (plan) => {
    setSelectedPlan(plan);
    setShowPlanModal(true);
  };

  const handleCreateSubscription = async () => {
    if (!selectedPlan) return;

    // Check if user has payment methods
    if (!billing.paymentMethods || billing.paymentMethods.length === 0) {
      setShowPlanModal(false);
      toast.error('Please add a payment method before starting a plan');

      // Scroll to payment methods section and highlight it
      setTimeout(() => {
        const paymentSection = document.querySelector('[data-section="payment-methods"]');
        if (paymentSection) {
          paymentSection.scrollIntoView({ behavior: 'smooth' });
          paymentSection.classList.add('ring-2', 'ring-blue-500', 'ring-opacity-50');
          setTimeout(() => {
            paymentSection.classList.remove('ring-2', 'ring-blue-500', 'ring-opacity-50');
          }, 3000);
        }
      }, 100);

      return;
    }

    try {
      setBillingLoading(true);

      const response = await api.post('/api/v1/billing/create-subscription', {
        plan: selectedPlan.name.toLowerCase(),
        interval: billingInterval
      });

      if (response.data.success) {
        toast.success(`${selectedPlan.name} plan activated successfully!`);
        setShowPlanModal(false);
        // Refresh billing data to show updated subscription
        fetchBillingData();
        fetchPaymentMethods();
      } else {
        toast.error(response.data.message || 'Failed to create subscription');
      }
    } catch (error) {
      console.error('Error creating subscription:', error);
      const errorMessage = error.response?.data?.message || 'Failed to create subscription';
      toast.error(errorMessage);
    } finally {
      setBillingLoading(false);
    }
  };

  const handleAddPaymentMethod = () => {
    setShowPaymentModal(true);
  };

  const getPlanPriceLocal = (plan, interval) => {
    const base = getPrice(plan);
    if (interval === 'year') return base * 12;
    return base;
  };

  const getPlanFeatures = (plan) => {
    const features = {
      free: ['1 month full AI access'
        // , 'Basic features after trial'
        , 'Up to 5 team members', 'Org Intelligence'],
      standard: ['All features', 'Unlimited team members', 'Advanced analytics', 'No Org Intelligence'],
      premium: ['All features', 'Org Intelligence', 'Priority support', 'Advanced AI']
    };
    return features[plan] || [];
  };

  const getOrganizationStatus = () => {
    // Check if organization has an active subscription
    if (billing.subscriptionId && billing.subscriptionStatus === 'active') {
      return {
        planName: billing.plan.name,
        status: 'Active-Paid',
        statusColor: 'bg-green-600 text-white'
      };
    }

    // Check if organization is in trial
    if (billing.trialEnd && new Date(billing.trialEnd) > new Date()) {
      // If on trial, show the actual plan name, not "Free Trial"
      return {
        planName: billing.plan.name,
        status: 'ProTrial',
        statusColor: 'bg-blue-600 text-white'
      };
    }

    // Check if organization has payment methods but no active subscription
    if (billing.paymentMethods && billing.paymentMethods.length > 0) {
      return {
        planName: billing.plan.name || 'No Plan',
        status: 'Active-Free',
        statusColor: 'bg-yellow-600 text-white'
      };
    }

    // Default: no plan, no payment method
    return {
      planName: 'No Plan',
      status: 'Deactive',
      statusColor: 'bg-gray-600 text-white'
    };
  };

  // Update active section when URL parameter changes
  useEffect(() => {
    if (urlSection) {
      setActiveSection(urlSection);
    }
  }, [urlSection]);

  // Load organization profile and billing data on component mount
  useEffect(() => {
    if (user?.role === 'org_admin' || user?.role === 'main_admin') {
      fetchOrganizationProfile();
      fetchBillingData();
      fetchPaymentMethods();
      fetchPaidMembersCount();
      fetchTotalUsersCount();
      fetchTeamStructure();
      fetchOrganization(); // Add this to get organization data
    }
    // Always fetch user profile regardless of role
    fetchUserProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.role, user?.id]); // Only depend on user.role and user.id - functions are stable via useCallback

  // Fetch billing data when billing section is active
  useEffect(() => {
    if (activeSection === 'billing' && (user?.role === 'org_admin' || user?.role === 'main_admin')) {
      fetchBillingData();
    }
  }, [activeSection, user?.role, fetchBillingData]);

  // Fetch invoices when billing section is active and stripe customer ID is available
  useEffect(() => {
    if (activeSection === 'billing' && (billing.stripeCustomerId || billing.razorpayCustomerId) && (user?.role === 'org_admin' || user?.role === 'main_admin')) {
      fetchInvoices();
    }
  }, [activeSection, billing.stripeCustomerId, billing.razorpayCustomerId, user?.role, fetchInvoices]);

  // --- Goals Settings: unsaved changes guard ---

  // Move handleSave to component level so modal can call it
  const handleGoalsSettingsSave = async () => {
    setSavingGoalsSettings(true);
    try {
      await saveSettings();
    } catch (error) {
      console.error('Failed to save goal policy:', error);
    } finally {
      setSavingGoalsSettings(false);
    }
  };

  // Section switch with unsaved-changes check
  const handleSectionChange = (sectionId) => {
    if (activeSection === 'goals_settings' && hasUnsavedChanges) {
      pendingNavRef.current = { type: 'section', id: sectionId };
      setShowUnsavedModal(true);
    } else {
      setActiveSection(sectionId);
      setSearchParams({ section: sectionId });
    }
  };

  // Warn on browser tab close / refresh
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (activeSection === 'goals_settings' && hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [activeSection, hasUnsavedChanges]);

  const handleUnsavedLeave = () => {
    resetToSaved();
    setShowUnsavedModal(false);
    const target = pendingNavRef.current;
    pendingNavRef.current = null;
    if (target?.type === 'section') {
      setActiveSection(target.id);
      setSearchParams({ section: target.id });
    }
  };

  const handleUnsavedSaveAndLeave = async () => {
    await handleGoalsSettingsSave();
    setShowUnsavedModal(false);
    const target = pendingNavRef.current;
    pendingNavRef.current = null;
    if (target?.type === 'section') {
      setActiveSection(target.id);
      setSearchParams({ section: target.id });
    }
  };

  const handleUnsavedCancel = () => {
    setShowUnsavedModal(false);
    pendingNavRef.current = null;
  };

  // Render unsaved-changes confirmation modal
  const renderUnsavedChangesModal = () => (
    <Modal
      open={showUnsavedModal}
      onCancel={handleUnsavedCancel}
      footer={null}
      centered
      closable={false}
      width={440}
      styles={{
        content: {
          background: isDark ? '#0f1117' : '#ffffff',
          border: isDark ? '1px solid rgba(255,255,255,0.08)' : '1px solid #e5e7eb',
          borderRadius: '20px',
          padding: '0',
          overflow: 'hidden',
          boxShadow: isDark
            ? '0 25px 50px rgba(0,0,0,0.6)'
            : '0 25px 50px rgba(0,0,0,0.12)',
        },
        mask: { backdropFilter: 'blur(4px)', background: 'rgba(0,0,0,0.45)' }
      }}
    >
      {/* Amber top accent bar */}
      <div className="h-1 w-full bg-gradient-to-r from-amber-400 via-orange-400 to-amber-500" />

      <div className="px-7 pt-6 pb-7 flex flex-col gap-5">
        {/* Icon + heading */}
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-11 h-11 rounded-2xl bg-amber-500/10 border border-amber-500/20 flex items-center justify-center">
            <AlertTriangle size={20} className="text-amber-500" strokeWidth={2.2} />
          </div>
          <div className="pt-0.5">
            <h3 className={`text-[15px] font-bold tracking-tight ${isDark ? 'text-white' : 'text-gray-900'}`}>
              You have unsaved changes
            </h3>
            <p className={`text-[13px] mt-1 leading-relaxed ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
              Your Goal Settings edits haven't been saved yet. What would you like to do?
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className={`h-px w-full ${isDark ? 'bg-white/[0.06]' : 'bg-gray-100'}`} />

        {/* Action cards */}
        <div className="flex flex-col gap-2.5">
          <button
            onClick={handleUnsavedSaveAndLeave}
            disabled={savingGoalsSettings}
            className={`group w-full flex items-center gap-3.5 px-4 py-3.5 rounded-xl border text-left transition-all duration-150 ${
              isDark
                ? 'bg-blue-600/10 border-blue-500/25 hover:bg-blue-600/20 hover:border-blue-500/40'
                : 'bg-blue-50 border-blue-200 hover:bg-blue-100 hover:border-blue-300'
            } disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-blue-600 flex items-center justify-center shadow-sm">
              <Save size={14} className="!text-white" strokeWidth={2.5} />
            </div>
            <div>
              <p className={`text-[13px] font-semibold ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>
                {savingGoalsSettings ? 'Saving...' : 'Save changes & leave'}
              </p>
              <p className={`text-[11px] mt-0.5 ${isDark ? 'text-blue-400/60' : 'text-blue-500/70'}`}>
                Save your edits, then navigate away
              </p>
            </div>
          </button>

          <button
            onClick={handleUnsavedLeave}
            className={`group w-full flex items-center gap-3.5 px-4 py-3.5 rounded-xl border text-left transition-all duration-150 ${
              isDark
                ? 'bg-white/[0.03] border-white/[0.07] hover:bg-red-500/10 hover:border-red-500/20'
                : 'bg-gray-50 border-gray-200 hover:bg-red-50 hover:border-red-200'
            }`}
          >
            <div className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center border transition-colors ${
              isDark
                ? 'bg-white/5 border-white/10 group-hover:bg-red-500/20 group-hover:border-red-500/30'
                : 'bg-white border-gray-200 group-hover:bg-red-100 group-hover:border-red-200'
            }`}>
              <X size={14} className={`transition-colors ${isDark ? 'text-gray-400 group-hover:text-red-400' : 'text-gray-400 group-hover:text-red-500'}`} strokeWidth={2.5} />
            </div>
            <div>
              <p className={`text-[13px] font-semibold transition-colors ${isDark ? 'text-gray-300 group-hover:text-red-400' : 'text-gray-700 group-hover:text-red-600'}`}>
                Discard changes & leave
              </p>
              <p className={`text-[11px] mt-0.5 ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
                Your unsaved edits will be lost
              </p>
            </div>
          </button>
        </div>

        {/* Cancel button */}
        <button
          onClick={handleUnsavedCancel}
          className={`w-full py-2.5 rounded-xl text-[13px] font-medium border transition-all duration-150 ${
            isDark
              ? 'bg-transparent border-white/10 text-gray-400 hover:bg-white/5 hover:text-gray-200 hover:border-white/20'
              : 'bg-transparent border-gray-200 text-gray-500 hover:bg-gray-50 hover:text-gray-700 hover:border-gray-300'
          }`}
        >
          Keep editing
        </button>
      </div>
    </Modal>
  );

  // -------------------------------------------

  const handleChangePlan = async () => {
    // Open the plan selection modal
    setShowPlanModal(true);
  };

  const handleCancelSubscription = async () => {
    if (!window.confirm('Are you sure you want to cancel your subscription? You will retain access until the end of your current billing period.')) {
      return;
    }

    try {
      setBillingLoading(true);

      const cancelEndpoint = billing.paymentGateway === 'razorpay'
        ? '/api/v1/razorpay-billing/cancel'
        : '/api/v1/billing/cancel';

      const response = await api.post(cancelEndpoint);

      if (response.data.success) {
        toast.success('Subscription will be canceled at the end of your billing period');
        fetchBillingData();
      } else {
        toast.error(response.data.message || 'Failed to cancel subscription');
      }
    } catch (error) {
      console.error('Error canceling subscription:', error);
      toast.error('Failed to cancel subscription');
    } finally {
      setBillingLoading(false);
    }
  };

  const handleResumeSubscription = async () => {
    try {
      setBillingLoading(true);

      if (billing.paymentGateway === 'razorpay') {
        const response = await api.post('/api/v1/razorpay-billing/resume');
        if (response.data.success) {
          if (response.data.data.requiresPayment) {
            // Razorpay resume requires a new subscription + payment
            const rzpData = response.data.data;
            openRazorpayCheckout({
              razorpayKeyId: rzpData.razorpayKeyId,
              subscriptionId: rzpData.subscriptionId,
              orderId: rzpData.orderId,
              amount: rzpData.amount,
              currency: rzpData.currency,
              customerName: user?.firstName + ' ' + user?.lastName,
              customerEmail: user?.email,
              description: 'TeamGrid Subscription Resume',
              onSuccess: async (paymentResponse) => {
                try {
                  await api.post('/api/v1/razorpay-billing/verify-payment', {
                    razorpay_order_id: paymentResponse.razorpay_order_id,
                    razorpay_subscription_id: paymentResponse.razorpay_subscription_id,
                    razorpay_payment_id: paymentResponse.razorpay_payment_id,
                    razorpay_signature: paymentResponse.razorpay_signature,
                    plan: billing.orgPlanSelection,
                    totalSeats: billing.paidMemberSlots,
                    type: rzpData.billingType === 'one_time' ? 'one_time_payment' : 'resume_subscription',
                  });
                  toast.success('Subscription resumed!');
                  fetchBillingData();
                } catch { toast.error('Payment verification failed'); }
              },
              onFailure: () => toast.error('Payment failed'),
              onDismiss: () => setBillingLoading(false),
            });
            return;
          }
          toast.success('Subscription resumed successfully');
          fetchBillingData();
        } else {
          toast.error(response.data.message || 'Failed to resume subscription');
        }
      } else {
        const response = await api.post('/api/v1/billing/resume');
        if (response.data.success) {
          toast.success('Subscription resumed successfully');
          fetchBillingData();
        } else {
          toast.error(response.data.message || 'Failed to resume subscription');
        }
      }
    } catch (error) {
      console.error('Error resuming subscription:', error);
      toast.error('Failed to resume subscription');
    } finally {
      setBillingLoading(false);
    }
  };

  const toggleTooltip = (planName) => {
    setShowTooltip(showTooltip === planName ? null : planName);
  };

  // Close tooltip when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showTooltip && !event.target.closest('.tooltip-container')) {
        setShowTooltip(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showTooltip]);

  const handleOrgProfileSave = async () => {
    try {
      // Validate phone number before saving (only if phone is provided)
      if (orgProfile.phone && orgProfile.phone.trim()) {
        const phoneError = validatePhoneNumber(orgProfile.phone);
        if (phoneError) {
          toast.error(phoneError);
          return;
        }
      }

      setSaving(true);

      // Prepare the data to send as JSON (not FormData)
      // Backend expects JSON in req.body, not FormData
      // Send all fields including empty strings so backend can clear them
      // Timezone field removed - let original/organization default timezone remain unchanged
      const profileData = {
        name: orgProfile.name || '',
        website: orgProfile.website || '',
        address: orgProfile.address || '',
        // timezone: not sending - keeps original organization timezone
        phone: orgProfile.phone ? `${orgProfile.phoneCountryCode} ${orgProfile.phone}` : '',
        industry: orgProfile.industry || '',
        size: orgProfile.size || '',
      };

      // Send profile data as JSON (all fields included, even if empty)
      await api.put('/api/v1/organizations/profile', profileData);

      // Handle logo upload separately if logo file exists
      if (logoFile) {
        try {
          // Convert file to base64 and send to logo endpoint
          const reader = new FileReader();
          reader.onloadend = async () => {
            const base64String = reader.result;
            await api.post('/api/v1/organizations/logo', { logoUrl: base64String });
          };
          reader.readAsDataURL(logoFile);
        } catch (logoError) {
          console.error('Error uploading logo:', logoError);
          // Don't fail the entire save if logo upload fails
          toast.error('Profile saved but logo upload failed');
        }
      }

      toast.success('Organization profile updated successfully');

      // Refresh organization profile to get updated data
      await fetchOrganizationProfile();

      // Clear the logo file after successful upload
      if (logoFile) {
        setLogoFile(null);
        setLogoPreview(null);
      }
    } catch (error) {
      console.error('Error updating organization profile:', error);
      toast.error(error.response?.data?.error?.message || error.response?.data?.message || 'Failed to update organization profile');
    } finally {
      setSaving(false);
    }
  };

  const handlePasswordUpdate = async () => {
    if (security.newPassword !== security.confirmPassword) {
      toast.error('New passwords do not match');
      return;
    }

    if (security.newPassword.length < 8) {
      toast.error('New password must be at least 8 characters long');
      return;
    }

    try {
      setSaving(true);
      const res = await api.put('/api/v1/auth/password', {
        currentPassword: security.currentPassword,
        newPassword: security.newPassword
      });

      // Save new tokens so user stays logged in (backend invalidates old token after password change)
      const newToken = res?.data?.data?.token || res?.data?.token;
      const newRefreshToken = res?.data?.data?.refreshToken || res?.data?.refreshToken;
      if (newToken) {
        localStorage.setItem('token', newToken);
        api.updateToken(newToken);
      }
      if (newRefreshToken) {
        localStorage.setItem('refreshToken', newRefreshToken);
      }

      toast.success('Password updated successfully');
      setSecurity({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      });
    } catch (error) {
      console.error('Error updating password:', error);
      toast.error(error.response?.data?.error?.message || error.response?.data?.message || 'Failed to update password');
    } finally {
      setSaving(false);
    }
  };



  const addTeamLevel = () => {
    const newLevel = {
      id: teamStructure.length + 1,
      label: `Top Level ${teamStructure.length + 1} (position)`,
      positions: [
        { id: 1, roleName: '', summary: '' }
      ]
    };
    setTeamStructure([...teamStructure, newLevel]);
  };

  const insertTeamLevelAt = (insertIndex) => {
    // Create new level with temporary id (will be renumbered)
    const newLevel = {
      id: insertIndex + 1,
      label: `Top Level ${insertIndex + 1} (position)`,
      positions: [
        { id: 1, roleName: '', summary: '' }
      ]
    };

    // Insert the new level at the specified index
    const updated = [
      ...teamStructure.slice(0, insertIndex),
      newLevel,
      ...teamStructure.slice(insertIndex)
    ];

    // Renumber all levels based on their new positions
    const renumbered = updated.map((level, index) => ({
      ...level,
      id: index + 1,
      label: `Top Level ${index + 1} (position)`
    }));

    setTeamStructure(renumbered);
  };

  const removeTeamLevel = (id) => {
    const updated = teamStructure.filter(level => level.id !== id);
    // Renumber levels
    const renumbered = updated.map((level, index) => ({
      ...level,
      id: index + 1,
      label: `Top Level ${index + 1} (position)`
    }));
    setTeamStructure(renumbered);
  };

  const updateTeamRole = (levelId, positionId, roleName) => {
    setTeamStructure(teamStructure.map(level =>
      level.id === levelId ? {
        ...level,
        positions: level.positions.map(position =>
          position.id === positionId ? { ...position, roleName } : position
        )
      } : level
    ));
  };

  const updateTeamPosition = (levelId, positionId, field, value) => {
    setTeamStructure(teamStructure.map(level =>
      level.id === levelId ? {
        ...level,
        positions: level.positions.map(position =>
          position.id === positionId ? { ...position, [field]: value } : position
        )
      } : level
    ));
  };

  const addPositionToLevel = (levelId) => {
    setTeamStructure(teamStructure.map(level =>
      level.id === levelId ? {
        ...level,
        positions: [
          ...level.positions,
          { id: Math.max(...level.positions.map(p => p.id)) + 1, roleName: '', summary: '' }
        ]
      } : level
    ));
  };

  const removePositionFromLevel = (levelId, positionId) => {
    setTeamStructure(teamStructure.map(level =>
      level.id === levelId ? {
        ...level,
        positions: level.positions.filter(position => position.id !== positionId)
      } : level
    ));
  };

  const handleDeletePositionClick = async (levelId, positionId) => {
    const level = teamStructure.find(l => l.id === levelId);
    const position = level?.positions.find(p => p.id === positionId);
    const positionName = position?.roleName || 'this position';

    setDeleteStructureConfirm({ visible: true, type: 'position', levelId, positionId, positionName, affectedMembers: [], loading: true });

    try {
      const response = await api.get('/api/v1/users');
      const allUsers = response.data?.data?.users || [];
      const affected = allUsers.filter(u => u.position && u.position.trim().toLowerCase() === positionName.trim().toLowerCase());
      setDeleteStructureConfirm(prev => ({ ...prev, affectedMembers: affected, loading: false }));
    } catch {
      setDeleteStructureConfirm(prev => ({ ...prev, loading: false }));
    }
  };

  const handleDeleteLevelClick = async (levelId) => {
    const level = teamStructure.find(l => l.id === levelId);
    const positionNames = level?.positions.map(p => p.roleName).filter(Boolean) || [];
    const displayName = positionNames.length > 0 ? positionNames.join(', ') : `Level ${levelId}`;

    setDeleteStructureConfirm({ visible: true, type: 'level', levelId, positionId: null, positionName: displayName, affectedMembers: [], loading: true });

    try {
      const response = await api.get('/api/v1/users');
      const allUsers = response.data?.data?.users || [];
      const lowerNames = positionNames.map(n => n.trim().toLowerCase());
      const affected = allUsers.filter(u => u.position && lowerNames.includes(u.position.trim().toLowerCase()));
      setDeleteStructureConfirm(prev => ({ ...prev, affectedMembers: affected, loading: false }));
    } catch {
      setDeleteStructureConfirm(prev => ({ ...prev, loading: false }));
    }
  };

  const confirmDeleteStructure = async () => {
    const { type, levelId, positionId, affectedMembers: affected } = deleteStructureConfirm;

    // 1. Update local state
    let updatedStructure;
    if (type === 'position') {
      updatedStructure = teamStructure.map(level =>
        level.id === levelId ? {
          ...level,
          positions: level.positions.filter(position => position.id !== positionId)
        } : level
      );
      setTeamStructure(updatedStructure);
    } else if (type === 'level') {
      const filtered = teamStructure.filter(level => level.id !== levelId);
      updatedStructure = filtered.map((level, index) => ({
        ...level,
        id: index + 1,
        label: `Top Level ${index + 1} (position)`
      }));
      setTeamStructure(updatedStructure);
    }

    setDeleteStructureConfirm({ visible: false, type: null, levelId: null, positionId: null, positionName: '', affectedMembers: [], loading: false });

    // 2. Auto-save updated structure to backend
    if (updatedStructure) {
      try {
        setSaving(true);
        const teamStructureData = updatedStructure.map(level => ({
          levelId: level.id,
          levelName: level.label,
          positions: level.positions.map(position => ({
            positionId: position.id,
            roleName: position.roleName,
            summary: position.summary
          }))
        }));
        await api.put('/api/v1/organizations/team-structure', {
          teamStructure: teamStructureData
        });
        toast.success('Structure deleted and saved successfully');
      } catch (error) {
        console.error('Error saving team structure after delete:', error);
        toast.error('Structure deleted locally but failed to save');
      } finally {
        setSaving(false);
      }
    }

    // 3. Clear position of affected members
    if (affected && affected.length > 0) {
      try {
        await Promise.all(
          affected.map(member =>
            api.put(`/api/v1/users/${member._id}`, { position: '' })
          )
        );
        toast.success(`Removed position from ${affected.length} ${affected.length === 1 ? 'member' : 'members'}`);
      } catch (error) {
        console.error('Error clearing member positions:', error);
        toast.error('Failed to clear position from some members');
      }
    }
  };

  const resetTeamStructure = () => {
    setTeamStructure([
      {
        id: 1,
        label: 'Top Level 1 (position)',
        positions: [
          { id: 1, roleName: 'Chief Executive Officer', summary: '' }
        ]
      },
      {
        id: 2,
        label: 'Top Level 2 (position)',
        positions: [
          { id: 1, roleName: 'Vice President', summary: '' }
        ]
      },
      {
        id: 3,
        label: 'Top Level 3 (position)',
        positions: [
          { id: 1, roleName: 'Director', summary: '' }
        ]
      }
    ]);
  };

  const saveTeamStructure = async () => {
    try {
      setSaving(true);

      // Transform the team structure to a format suitable for the API
      const teamStructureData = teamStructure.map(level => ({
        levelId: level.id,
        levelName: level.label,
        positions: level.positions.map(position => ({
          positionId: position.id,
          roleName: position.roleName,
          summary: position.summary
        }))
      }));

      await api.put('/api/v1/organizations/team-structure', {
        teamStructure: teamStructureData
      });

      toast.success('Team structure saved successfully');
    } catch (error) {
      console.error('Error saving team structure:', error);
      toast.error(error.response?.data?.message || 'Failed to save team structure');
    } finally {
      setSaving(false);
    }
  };



  const renderOrganizationProfile = () => (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-white mb-4">Profile</h2>

        {/* User Profile Section */}
        <div className="mb-8">
          <h3 className="text-lg font-medium text-white mb-4">Personal Information</h3>
          <div className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-white mb-2">
                  First Name *
                </label>
                <input
                  type="text"
                  value={userProfile.firstName}
                  onChange={(e) => setUserProfile({ ...userProfile, firstName: e.target.value })}
                  className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-white/20 text-white"
                  placeholder="Enter your first name"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-white mb-2">
                  Last Name *
                </label>
                <input
                  type="text"
                  value={userProfile.lastName}
                  onChange={(e) => setUserProfile({ ...userProfile, lastName: e.target.value })}
                  className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-white/20 text-white"
                  placeholder="Enter your last name"
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-white mb-2">
                Email Address
              </label>
              <input
                type="email"
                value={userProfile.email}
                disabled
                className="w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md text-gray-400 cursor-not-allowed"
                placeholder="Email address"
              />
              <p className="text-xs text-gray-400 mt-1">
                Email address cannot be changed
              </p>
            </div>
          </div>
          <div className="flex space-x-3 mt-6">
            <button
              onClick={handleUserProfileSave}
              disabled={saving || loading}
              className="px-4 py-2 bg-white/10 text-white rounded-md hover:bg-white/20 border border-white/20 flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {saving ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  <span>Saving...</span>
                </>
              ) : (
                <>
                  <Save className="h-4 w-4" />
                  <span>Save Personal Info</span>
                </>
              )}
            </button>
          </div>
        </div>

        {/* Organization Profile Section */}
        <div>
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-lg font-medium text-white">Organization Information</h3>
            {user?.role === 'org_user' && (
              <div className="flex items-center gap-2 text-xs text-yellow-400 bg-yellow-400/10 border border-yellow-400/20 px-3 py-1 rounded-full">
                <Lightbulb size={14} />
                <span>View Only - Contact Admin to Edit</span>
              </div>
            )}
          </div>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-white mb-2">
                Organization Name *
              </label>
              <input
                type="text"
                value={orgProfile.name}
                onChange={(e) => setOrgProfile({ ...orgProfile, name: e.target.value })}
                disabled={user?.role === 'org_user'}
                className={`w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-white/20 text-white ${user?.role === 'org_user' ? 'opacity-60 cursor-not-allowed' : ''
                  }`}
                placeholder="Enter organization name"
              />
            </div>

            {/* <div>
            <label className="block text-sm font-medium text-white mb-2">
              Logo Upload
            </label>
            <div className="flex items-start space-x-4">
              <div className="relative">
                <div className="w-20 h-20 bg-white/5 border border-white/10 rounded-md flex items-center justify-center overflow-hidden">
                  {logoPreview ? (
                    <img 
                      src={logoPreview} 
                      alt="Logo preview" 
                      className="w-full h-full object-contain"
                    />
                  ) : (
                    <Upload className="h-8 w-8 text-gray-400" />
                  )}
                </div>
                {logoPreview && user?.role !== 'org_user' && (
                  <button
                    onClick={() => {
                      setLogoFile(null);
                      setLogoPreview(null);
                    }}
                    className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center text-white text-xs hover:bg-red-600"
                  >
                    ×
                  </button>
                )}
              </div>
              <div className="flex-1">
                <input
                  type="file"
                  id="logo-upload"
                  accept="image/svg+xml,image/png,image/jpeg,image/jpg"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      if (file.size > 5 * 1024 * 1024) {
                        toast.error('File size must be less than 5MB');
                        return;
                      }
                      setLogoFile(file);
                      const reader = new FileReader();
                      reader.onload = (e) => setLogoPreview(e.target.result);
                      reader.readAsDataURL(file);
                    }
                  }}
                  className="hidden"
                  disabled={user?.role === 'org_user'}
                />
                <label
                  htmlFor="logo-upload"
                  className={`px-4 py-2 bg-white/10 text-white rounded-md border border-white/20 text-sm inline-block ${
                    user?.role === 'org_user' ? 'opacity-60 cursor-not-allowed' : 'hover:bg-white/20 cursor-pointer'
                  }`}
                >
                  {logoPreview ? 'Change Logo' : 'Upload Logo'}
                </label>
                <p className="text-xs text-gray-400 mt-1">
                  SVG, PNG, JPG up to 5MB
                </p>
              </div>
            </div>
          </div> */}

            <div>
              <label className="block text-sm font-medium text-white mb-2">
                Website
              </label>
              <input
                type="url"
                value={orgProfile.website}
                onChange={(e) => setOrgProfile({ ...orgProfile, website: e.target.value })}
                disabled={user?.role === 'org_user'}
                className={`w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-white/20 text-white ${user?.role === 'org_user' ? 'opacity-60 cursor-not-allowed' : ''
                  }`}
                placeholder="https://example.com"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-white mb-2">
                Address
              </label>
              <textarea
                value={orgProfile.address}
                onChange={(e) => setOrgProfile({ ...orgProfile, address: e.target.value })}
                disabled={user?.role === 'org_user'}
                rows={3}
                className={`w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-white/20 text-white ${user?.role === 'org_user' ? 'opacity-60 cursor-not-allowed' : ''
                  }`}
                placeholder="Enter organization address"
              />
            </div>

            {/* Timezone field commented out - using original/organization default timezone */}
            {/* <div>
            <label className="block text-sm font-medium text-white mb-2">
              Default Timezone *
            </label>
            <AntDropdown
              value={orgProfile.timezone}
              onChange={(value) => setOrgProfile({ ...orgProfile, timezone: value })}
              disabled={user?.role === 'org_user'}
              placeholder="Select timezone"
              showSearch={true}
              allowClear={false}
              options={timezones.map(tz => ({ label: tz.label, value: tz.value }))}
            />
          </div> */}

            <div>
              <label className="block text-sm font-medium text-white mb-2">
                Phone Number
              </label>
              <div className="flex space-x-2">
                <div className="w-40">
                  <AntDropdown
                    value={orgProfile.phoneCountryCode}
                    onChange={(value) => setOrgProfile({ ...orgProfile, phoneCountryCode: value })}
                    disabled={user?.role === 'org_user'}
                    placeholder="Code"
                    showSearch={true}
                    allowClear={false}
                    options={countryCodes
                      .sort((a, b) => a.name.localeCompare(b.name))
                      .filter((country, index, self) =>
                        index === self.findIndex(c => c.code === country.code)
                      )
                      .map(country => {
                        const flag = getCountryFlag(country.country);
                        return {
                          label: `${flag} ${country.name} (${country.code})`,
                          value: country.code
                        };
                      })}
                  />
                </div>
                <input
                  type="tel"
                  value={orgProfile.phone}
                  onChange={handlePhoneChange}
                  disabled={user?.role === 'org_user'}
                  className={`flex-1 px-3 py-2 bg-white/5 border rounded-md focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-white/20 text-white ${phoneError ? 'border-red-500' : 'border-white/10'
                    } ${user?.role === 'org_user' ? 'opacity-60 cursor-not-allowed' : ''}`}
                  placeholder="(555) 123-4567"
                />
              </div>
              {phoneError && (
                <p className="text-red-400 text-xs mt-1">{phoneError}</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-white mb-2">
                Industry
              </label>
              <input
                type="text"
                value={orgProfile.industry}
                onChange={(e) => setOrgProfile({ ...orgProfile, industry: e.target.value })}
                disabled={user?.role === 'org_user'}
                className={`w-full px-3 py-2 bg-white/5 border border-white/10 rounded-md focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-white/20 text-white ${user?.role === 'org_user' ? 'opacity-60 cursor-not-allowed' : ''
                  }`}
                placeholder="e.g., Technology, Healthcare, Finance"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-white mb-2">
                Company Size
              </label>
              <AntDropdown
                value={orgProfile.size || undefined}
                onChange={(value) => setOrgProfile({ ...orgProfile, size: value || '' })}
                disabled={user?.role === 'org_user'}
                placeholder="Select company size"
                showSearch={false}
                allowClear={true}
                options={[
                  { label: '1-10 employees', value: '1-10' },
                  { label: '11-50 employees', value: '11-50' },
                  { label: '51-200 employees', value: '51-200' },
                  { label: '201-500 employees', value: '201-500' },
                  { label: '501-1000 employees', value: '501-1000' },
                  { label: '1000+ employees', value: '1000+' },
                ]}
              />
            </div>
          </div>
        </div>

        {user?.role !== 'org_user' && (
          <div className="flex space-x-3 mt-6">
            <button
              onClick={handleOrgProfileSave}
              disabled={saving || loading}
              className="px-4 py-2 bg-white/10 text-white rounded-md hover:bg-white/20 border border-white/20 flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {saving ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  <span>Saving...</span>
                </>
              ) : (
                <>
                  <Save className="h-4 w-4" />
                  <span>Save Organization Info</span>
                </>
              )}
            </button>
            <button className="px-4 py-2 bg-white/5 text-gray-400 rounded-md hover:bg-white/10 border border-white/10 flex items-center space-x-2">
              <X className="h-4 w-4" />
              <span>Cancel</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );

  const renderSecurityLogin = () => (
    <div className="space-y-8">
      <div>
        <h2 className="text-xl font-semibold text-white mb-4">Security & Login</h2>

        {/* Password Section */}
        <div className="space-y-4 mb-8">
          <h3 className="text-lg font-medium text-white">Password</h3>

          <div>
            <label className="block text-sm font-medium text-white mb-2">
              Current Password *
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={security.currentPassword}
                onChange={(e) => setSecurity({ ...security, currentPassword: e.target.value })}
                className="w-full px-3 py-2 pr-10 bg-white/5 border border-white/10 rounded-md focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-white/20 text-white"
                placeholder="Enter current password"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                {showPassword ? <EyeOff className="h-4 w-4 text-gray-400" /> : <Eye className="h-4 w-4 text-gray-400" />}
              </button>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-white mb-2">
              New Password *
            </label>
            <div className="relative">
              <input
                type={showNewPassword ? "text" : "password"}
                value={security.newPassword}
                onChange={(e) => setSecurity({ ...security, newPassword: e.target.value })}
                className="w-full px-3 py-2 pr-10 bg-white/5 border border-white/10 rounded-md focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-white/20 text-white"
                placeholder="Enter new password"
              />
              <button
                type="button"
                onClick={() => setShowNewPassword(!showNewPassword)}
                className="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                {showNewPassword ? <EyeOff className="h-4 w-4 text-gray-400" /> : <Eye className="h-4 w-4 text-gray-400" />}
              </button>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-white mb-2">
              Confirm New Password *
            </label>
            <div className="relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                value={security.confirmPassword}
                onChange={(e) => setSecurity({ ...security, confirmPassword: e.target.value })}
                className="w-full px-3 py-2 pr-10 bg-white/5 border border-white/10 rounded-md focus:outline-none focus:ring-2 focus:ring-white/20 focus:border-white/20 text-white"
                placeholder="Confirm new password"
              />
              <button
                type="button"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                className="absolute inset-y-0 right-0 pr-3 flex items-center"
              >
                {showConfirmPassword ? <EyeOff className="h-4 w-4 text-gray-400" /> : <Eye className="h-4 w-4 text-gray-400" />}
              </button>
            </div>
          </div>

          <button
            onClick={handlePasswordUpdate}
            disabled={saving}
            className="px-4 py-2 bg-white/10 text-white rounded-md hover:bg-white/20 border border-white/20 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
          >
            {saving ? (
              <>
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                <span>Updating...</span>
              </>
            ) : (
              <>
                <Shield className="h-4 w-4" />
                <span>Update Password</span>
              </>
            )}
          </button>
        </div>


      </div>
    </div>
  );

  const renderTeamStructure = () => (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={pageTransition}
      className="space-y-8"
    >
      {/* Header Section */}
      <motion.div
        variants={fadeInVariants}
        initial="hidden"
        animate="visible"
        className="border-b border-white/10 pb-6"
      >
        <div className="flex items-center gap-3 mb-3">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-xl flex items-center justify-center border border-blue-500/30">
            <Users className="h-5 w-5 text-blue-400" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-white">Team Structure</h2>
            <p className="text-gray-400 text-sm mt-1">
              Define your organization's hierarchy and roles
            </p>
          </div>
        </div>
      </motion.div>

      {/* Structure Overview */}
      <motion.div
        variants={fadeInVariants}
        initial="hidden"
        animate="visible"
        transition={{ delay: 0.1 }}
      >
        <AntCard
          className={isDark ? "border-blue-500/20 bg-gradient-to-br from-blue-500/10 via-purple-500/10 to-blue-500/10 backdrop-blur-xl" : "border-blue-200 bg-gradient-to-br from-blue-50 via-purple-50 to-blue-50"}
          style={{
            borderRadius: '16px',
            border: isDark ? '1px solid rgba(59, 130, 246, 0.2)' : '1px solid rgba(59, 130, 246, 0.15)',
            boxShadow: isDark ? '0 8px 32px rgba(59, 130, 246, 0.1)' : '0 4px 12px rgba(59, 130, 246, 0.08)',
          }}
        >
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <div className="w-12 h-12 bg-gradient-to-br from-blue-500/30 to-purple-500/30 rounded-xl flex items-center justify-center border border-blue-400/30">
                <BarChart3 className="h-6 w-6 text-blue-400" />
              </div>
              <div>
                <Text className={isDark ? "text-white font-semibold text-base" : "text-slate-900 font-semibold text-base"}>
                  Structure Overview
                </Text>
                <div className="flex items-center gap-4 mt-1">
                  <Tag color="blue" className="!m-0">
                    {teamStructure.length} Level{teamStructure.length !== 1 ? 's' : ''}
                  </Tag>
                  <Tag color="purple" className="!m-0">
                    {teamStructure.reduce((total, level) => total + level.positions.length, 0)} Position{teamStructure.reduce((total, level) => total + level.positions.length, 0) !== 1 ? 's' : ''}
                  </Tag>
                </div>
              </div>
            </div>
          </div>
        </AntCard>
      </motion.div>

      {/* Team Structure Levels */}
      <AnimatePresence mode="wait">
        {teamStructure.length === 0 ? (
          <motion.div
            key="empty"
            variants={fadeInVariants}
            initial="hidden"
            animate="visible"
            exit="hidden"
            className="text-center py-16"
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ delay: 0.2 }}
              className="w-20 h-20 bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6 border border-blue-500/30"
            >
              <Users className="h-10 w-10 text-blue-400" />
            </motion.div>
            <h3 className="text-white font-semibold text-lg mb-2">No Team Structure Defined</h3>
            <p className="text-gray-400 text-sm mb-8 max-w-md mx-auto">
              Start by adding your first organizational level to define your company hierarchy
            </p>
            <motion.div
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <button
                onClick={addTeamLevel}
                className="px-8 py-3 bg-gradient-to-r from-blue-600 to-blue-700 !text-white rounded-xl hover:from-blue-700 hover:to-blue-800 border border-blue-600 flex items-center space-x-2 mx-auto shadow-lg shadow-blue-500/20 transition-all"
              >
                <Plus className="h-5 w-5" />
                <span className="font-medium">Create First Level</span>
              </button>
            </motion.div>
          </motion.div>
        ) : (
          teamStructure.map((level, levelIndex) => (
            <motion.div
              key={level.id}
              variants={cardVariants}
              initial="hidden"
              animate="visible"
              custom={levelIndex}
              whileHover={{ y: -2 }}
              transition={{ duration: 0.3 }}
            >
              <AntCard
                className={isDark ? "border-white/10 bg-gradient-to-br from-zinc-900/95 to-zinc-800/95 backdrop-blur-xl" : "border-slate-200 bg-white"}
                style={{
                  borderRadius: '16px',
                  border: isDark ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid rgba(15, 23, 42, 0.12)',
                  boxShadow: isDark ? '0 8px 32px rgba(0, 0, 0, 0.3)' : '0 4px 12px rgba(15, 23, 42, 0.08)',
                  marginBottom: '24px',
                }}
                bodyStyle={{ padding: 0 }}
              >
                {/* Level Header */}
                <div className={`px-6 py-5 border-b ${isDark ? 'bg-gradient-to-r from-blue-500/10 to-purple-500/10 border-white/10' : 'bg-gradient-to-r from-blue-50 to-purple-50 border-slate-200'}`}>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-4">
                      <motion.div
                        whileHover={{ scale: 1.1, rotate: 5 }}
                        className={`w-12 h-12 ${isDark ? 'bg-gradient-to-br from-blue-500/30 to-purple-500/30 border border-blue-400/40' : 'bg-gradient-to-br from-blue-100 to-purple-100 border border-blue-200'} rounded-xl flex items-center justify-center shadow-lg`}
                      >
                        <span className={`${isDark ? 'text-blue-400' : 'text-blue-600'} font-bold text-lg`}>{levelIndex + 1}</span>
                      </motion.div>
                      <div>
                        <h3 className={`${isDark ? 'text-white' : 'text-slate-900'} font-bold text-lg mb-1`}>{level.label}</h3>
                        <Tag color={isDark ? 'blue' : 'default'} className="!m-0">
                          {level.positions.length} position{level.positions.length !== 1 ? 's' : ''}
                        </Tag>
                      </div>
                    </div>
                    <div className="flex items-center space-x-2">
                      <motion.button
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        onClick={() => insertTeamLevelAt(levelIndex)}
                        className={`p-2.5 ${isDark ? 'text-green-400 hover:text-green-300 hover:bg-green-400/20' : 'text-green-600 hover:text-green-700 hover:bg-green-50'} rounded-lg transition-all`}
                        title="Insert level above this one"
                      >
                        <ArrowUp className="h-5 w-5" />
                      </motion.button>
                      <motion.button
                        whileHover={{ scale: 1.1 }}
                        whileTap={{ scale: 0.9 }}
                        onClick={() => addPositionToLevel(level.id)}
                        className={`p-2.5 ${isDark ? 'text-blue-400 hover:text-blue-300 hover:bg-blue-400/20' : 'text-blue-600 hover:text-blue-700 hover:bg-blue-50'} rounded-lg transition-all`}
                        title="Add position to this level"
                      >
                        <Plus className="h-5 w-5" />
                      </motion.button>
                      {teamStructure.length > 1 && (
                        <motion.button
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          onClick={() => handleDeleteLevelClick(level.id)}
                          className={`p-2.5 ${isDark ? 'text-red-400 hover:text-red-300 hover:bg-red-400/20' : 'text-red-600 hover:text-red-700 hover:bg-red-50'} rounded-lg transition-all`}
                          title="Remove this level"
                        >
                          <Trash2 className="h-5 w-5" />
                        </motion.button>
                      )}
                    </div>
                  </div>
                </div>

                {/* Positions */}
                <div className="p-6">
                  {level.positions.length === 0 ? (
                    <motion.div
                      initial={{ opacity: 0, y: 10 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="text-center py-10"
                    >
                      <div className={`w-16 h-16 ${isDark ? 'bg-gray-500/20' : 'bg-slate-100'} rounded-xl flex items-center justify-center mx-auto mb-4`}>
                        <User className={`h-8 w-8 ${isDark ? 'text-gray-400' : 'text-slate-400'}`} />
                      </div>
                      <p className={`${isDark ? 'text-gray-400' : 'text-slate-600'} text-sm mb-5`}>No positions defined for this level</p>
                      <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={() => addPositionToLevel(level.id)}
                        className={`px-5 py-2.5 ${isDark ? 'bg-blue-500/20 text-blue-400 hover:bg-blue-500/30 border border-blue-500/30' : 'bg-blue-50 text-blue-600 hover:bg-blue-100 border border-blue-200'} rounded-lg flex items-center space-x-2 mx-auto transition-all`}
                      >
                        <Plus className="h-4 w-4" />
                        <span className="font-medium">Add First Position</span>
                      </motion.button>
                    </motion.div>
                  ) : (
                    <div className="space-y-4">
                      <AnimatePresence>
                        {level.positions.map((position, positionIndex) => (
                          <motion.div
                            key={position.id}
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: 20 }}
                            transition={{ delay: positionIndex * 0.05 }}
                            className="group"
                          >
                            <div className={`p-4 rounded-xl border ${isDark ? 'bg-white/5 border-white/10 hover:bg-white/10 hover:border-blue-500/30' : 'bg-slate-50 border-slate-200 hover:bg-slate-100 hover:border-blue-300'} transition-all duration-300`}>
                              <div className="flex items-start space-x-4">
                                <motion.div
                                  whileHover={{ scale: 1.1, rotate: 5 }}
                                  className={`w-10 h-10 ${isDark ? 'bg-gradient-to-br from-blue-500/20 to-purple-500/20 border border-blue-400/30' : 'bg-gradient-to-br from-blue-100 to-purple-100 border border-blue-200'} rounded-lg flex items-center justify-center flex-shrink-0 shadow-md`}
                                >
                                  <span className={`${isDark ? 'text-blue-400' : 'text-blue-600'} font-bold text-sm`}>{positionIndex + 1}</span>
                                </motion.div>
                                <div className="flex-1 space-y-3">
                                  <input
                                    type="text"
                                    value={position.roleName}
                                    onChange={(e) => updateTeamPosition(level.id, position.id, 'roleName', e.target.value)}
                                    className={`w-full px-4 py-3 ${isDark ? 'bg-white/5 border-white/10 text-white focus:ring-blue-500/50 focus:border-blue-500/50' : 'bg-white border-slate-200 text-slate-900 focus:ring-blue-500 focus:border-blue-500'} rounded-lg focus:outline-none focus:ring-2 transition-all font-medium`}
                                    placeholder="Enter position name (e.g., CEO, Manager, Developer)"
                                  />
                                  {editingSummary && editingSummary.levelId === level.id && editingSummary.positionId === position.id ? (
                                    <textarea
                                      value={position.summary}
                                      onChange={(e) => updateTeamPosition(level.id, position.id, 'summary', e.target.value)}
                                      onBlur={() => setEditingSummary(null)}
                                      autoFocus
                                      className={`w-full px-4 py-3 ${isDark ? 'bg-white/5 border-white/10 text-gray-300 placeholder-gray-500 focus:ring-blue-500/50 focus:border-blue-500/50' : 'bg-white border-slate-200 text-slate-700 placeholder-slate-400 focus:ring-blue-500 focus:border-blue-500'} rounded-lg focus:outline-none focus:ring-2 transition-all resize-none`}
                                      placeholder="Short two-line summary of what this position does."
                                      rows="3"
                                    />
                                  ) : (
                                    <div
                                      onClick={() => setEditingSummary({ levelId: level.id, positionId: position.id })}
                                      className={`w-full px-4 py-3 ${isDark ? position.summary ? 'text-gray-300 hover:bg-white/5' : 'text-gray-500 italic hover:bg-white/5' : position.summary ? 'text-slate-600 hover:bg-slate-50' : 'text-slate-400 italic hover:bg-slate-50'} rounded-lg cursor-pointer transition-all min-h-[60px] flex items-center`}
                                    >
                                      <p className="text-sm leading-relaxed">
                                        {position.summary || "Click to add a summary..."}
                                      </p>
                                    </div>
                                  )}
                                </div>
                                {level.positions.length > 1 && (
                                  <motion.button
                                    whileHover={{ scale: 1.1 }}
                                    whileTap={{ scale: 0.9 }}
                                    onClick={() => handleDeletePositionClick(level.id, position.id)}
                                    className={`p-2.5 ${isDark ? 'text-red-400 hover:text-red-300 hover:bg-red-400/20' : 'text-red-600 hover:text-red-700 hover:bg-red-50'} rounded-lg transition-all opacity-0 group-hover:opacity-100`}
                                    title="Remove this position"
                                  >
                                    <Trash2 className="h-5 w-5" />
                                  </motion.button>
                                )}
                              </div>
                            </div>
                          </motion.div>
                        ))}
                      </AnimatePresence>
                    </div>
                  )}
                </div>
              </AntCard>
            </motion.div>
          ))
        )}
      </AnimatePresence>

      {/* Action Buttons */}
      <motion.div
        variants={fadeInVariants}
        initial="hidden"
        animate="visible"
        transition={{ delay: 0.3 }}
        className={`border-t ${isDark ? 'border-white/10' : 'border-slate-200'} pt-6`}
      >
        <div className="flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center space-x-3">
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={addTeamLevel}
              className={`px-6 py-3 ${isDark ? 'bg-white/10 text-white hover:bg-white/20 border-white/20' : 'bg-slate-100 text-slate-700 hover:bg-slate-200 border-slate-200'} rounded-xl border flex items-center space-x-2 transition-all shadow-md`}
            >
              <Plus className="h-5 w-5" />
              <span className="font-medium">Add New Level</span>
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={resetTeamStructure}
              className={`px-6 py-3 ${isDark ? 'bg-white/5 text-gray-400 hover:bg-white/10 border-white/10' : 'bg-slate-50 text-slate-600 hover:bg-slate-100 border-slate-200'} rounded-xl border transition-all`}
            >
              Reset to Default
            </motion.button>
          </div>

          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={saveTeamStructure}
            disabled={saving || teamStructure.length === 0}
            className="px-8 py-3 bg-gradient-to-r from-blue-600 to-blue-700 !text-white rounded-xl hover:from-blue-700 hover:to-blue-800 border border-blue-600 flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-lg shadow-blue-500/20 font-medium"
          >
            {saving ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                <span>Saving Structure...</span>
              </>
            ) : (
              <>
                <Save className="h-5 w-5" />
                <span>Save Structure</span>
              </>
            )}
          </motion.button>
        </div>

        {/* Save Status */}
        {teamStructure.length > 0 && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className={`mt-6 p-4 ${isDark ? 'bg-green-500/10 border-green-500/20' : 'bg-green-50 border-green-200'} border rounded-xl`}
          >
            <div className="flex items-center space-x-3">
              <motion.div
                animate={{ scale: [1, 1.2, 1] }}
                transition={{ duration: 2, repeat: Infinity }}
                className="w-3 h-3 bg-green-400 rounded-full"
              />
              <p className={`${isDark ? 'text-green-300' : 'text-green-700'} text-sm font-medium`}>
                Ready to save. Your team structure will be used for organizational hierarchy and reporting.
              </p>
            </div>
          </motion.div>
        )}
      </motion.div>
    </motion.div>
  );

  // Verify coupon code
  const verifyCouponCode = async (code) => {
    if (!code || code.trim() === '') {
      setActualCouponId(null);
      setCouponValid(null);
      setCouponDiscount(null);
      return;
    }

    setCouponVerifying(true);
    try {
      const verifyUrl = billing.paymentGateway === 'razorpay'
        ? '/api/v1/public/razorpay-billing/verify-coupon'
        : '/api/v1/public/billing/verify-coupon';

      const response = await api.post(verifyUrl, {
        couponCode: code.trim()
      });

      if (response.data.success && response.data.data.valid) {
        setCouponValid(true);
        setCouponDiscount(response.data.data.discount);
        setActualCouponId(response.data.data.couponCode);
        toast.success(`Coupon applied! ${response.data.data.discount}`);
      } else {
        setCouponValid(false);
        setCouponDiscount(null);
        setActualCouponId(null);
        toast.error(response.data.message || 'Invalid coupon code');
      }
    } catch (error) {
      setCouponValid(false);
      setCouponDiscount(null);
      setActualCouponId(null);
      toast.error(error.response?.data?.message || 'Failed to verify coupon');
    } finally {
      setCouponVerifying(false);
    }
  };

  const renderBilling = () => (
    <div className="space-y-8">
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
        >
          <div className="flex items-center justify-between mb-6">
            <div>
              <Title level={2} className={`!mb-0 !text-3xl !font-bold ${isDark ? '!text-white' : '!text-slate-900'}`}>Billing</Title>
              <Paragraph className={`!text-base !mb-0 !mt-2 ${isDark ? '!text-gray-400' : '!text-slate-600'}`}>
                Manage your organization subscription and billing information
              </Paragraph>
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={`mb-6 rounded-xl border p-4 flex items-start gap-3 ${
              isDark
                ? 'bg-amber-500/10 border-amber-500/30'
                : 'bg-amber-50 border-amber-200'
            }`}
            role="note"
            aria-label="Payment refund notice"
          >
            <div className={`shrink-0 w-9 h-9 rounded-full flex items-center justify-center ${
              isDark ? 'bg-amber-500/20' : 'bg-amber-100'
            }`}>
              <Info className={`w-5 h-5 ${isDark ? 'text-amber-300' : 'text-amber-600'}`} />
            </div>
            <div className="flex-1 min-w-0">
              <Text strong className={`block text-sm mb-1 ${isDark ? '!text-amber-200' : '!text-amber-800'}`}>
                Payment Refund Notice
              </Text>
              <Text className={`text-sm leading-relaxed ${isDark ? '!text-amber-100/80' : '!text-amber-900/80'}`}>
                If a payment is deducted from your account in error, please allow up to{' '}
                <span className="font-semibold">72 working hours</span> for the amount to be refunded back to your account.
              </Text>
            </div>
          </motion.div>

          {billingLoading && (
            <div className="flex items-center justify-center py-12">
              <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
            </div>
          )}

          {!billingLoading && (
            <div className="space-y-6">

              {/* Organization Subscription Status Card */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 }}
              >
                <AntCard
                  className={isDark ? "border-white/10 bg-gradient-to-br from-zinc-900/95 to-zinc-800/95 backdrop-blur-xl" : "border-slate-200 bg-white"}
                  style={isDark ? { borderRadius: '16px', border: '1px solid rgba(255, 255, 255, 0.1)' } : { borderRadius: '16px', border: '1px solid rgba(15, 23, 42, 0.12)', boxShadow: '0 4px 6px rgba(15, 23, 42, 0.08)' }}
                >
                  <div className="flex items-center justify-between mb-6">
                    <div className="flex items-center space-x-3">
                      <div className={`w-12 h-12 rounded-full flex items-center justify-center ${isDark ? 'bg-blue-500/20' : 'bg-blue-100'}`}>
                        <CreditCard className={`w-6 h-6 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
                      </div>
                      <div>
                        <Title level={4} className={`!mb-0 !text-xl ${isDark ? '!text-white' : '!text-slate-900'}`}>Organization Subscription</Title>
                        <Text className={isDark ? "text-gray-400 text-sm" : "text-slate-600 text-sm"}>
                          {billing.orgPlanSelection ? `${billing.orgPlanSelection.charAt(0).toUpperCase() + billing.orgPlanSelection.slice(1)} Plan` : 'No Plan'}
                        </Text>
                      </div>
                    </div>
                    <Badge
                      status={
                        billing.subscriptionStatus === 'active' ? 'success' :
                          billing.subscriptionStatus === 'trialing' ? 'processing' :
                            billing.subscriptionStatus === 'past_due' ? 'warning' :
                              'error'
                      }
                      text={
                        <Text className={isDark ? "text-white font-semibold" : "text-slate-900 font-semibold"}>
                          {billing.subscriptionStatus ? billing.subscriptionStatus.charAt(0).toUpperCase() + billing.subscriptionStatus.slice(1).replace('_', ' ') : 'Inactive'}
                        </Text>
                      }
                    />
                  </div>

                  <Divider className={isDark ? "!border-white/10 !my-4" : "!border-slate-200 !my-4"} />

                  <Space direction="vertical" size="large" className="w-full">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                      <Statistic
                        title={<span className={isDark ? "text-gray-400 text-sm" : "text-slate-600 text-sm"}>Plan Type</span>}
                        value={billing.orgPlanSelection === 'free' ? 'Free' :
                          billing.orgPlanSelection === 'standard' ? 'Standard' :
                            billing.orgPlanSelection === 'premium' ? 'Premium' : 'N/A'}
                        valueStyle={{ color: isDark ? '#ffffff' : '#0f172a', fontSize: '18px', fontWeight: 'bold' }}
                      />
                      <Statistic
                        title={<span className={isDark ? "text-gray-400 text-sm" : "text-slate-600 text-sm"}>Cost per Slot</span>}
                        value={`${symbol}${billing.orgPlanAmount || 0}/month`}
                        valueStyle={{ color: isDark ? '#ffffff' : '#0f172a', fontSize: '18px', fontWeight: 'bold' }}
                      />
                      <Statistic
                        title={<span className={isDark ? "text-gray-400 text-sm" : "text-slate-600 text-sm"}>Total Slots</span>}
                        value={billing.paidMemberSlots || 1}
                        valueStyle={{ color: isDark ? '#ffffff' : '#0f172a', fontSize: '18px', fontWeight: 'bold' }}
                      />
                      <Statistic
                        title={<span className={isDark ? "text-gray-400 text-sm" : "text-slate-600 text-sm"}>Monthly Total</span>}
                        value={`${symbol}${billing.orgPlanAmount && billing.paidMemberSlots ? (billing.orgPlanAmount * billing.paidMemberSlots).toFixed(2) : '0.00'}`}
                        valueStyle={{ color: isDark ? '#60a5fa' : '#4f46e5', fontSize: '18px', fontWeight: 'bold' }}
                      />
                    </div>
                  </Space>

                  {billing.stripeCustomerId && (
                    <>
                      <Divider className={isDark ? "!border-white/10 !my-4" : "!border-slate-200 !my-4"} />
                      <div className="flex items-center justify-between">
                        <Text className={isDark ? "text-gray-400 text-sm" : "text-slate-600 text-sm"}>Stripe Customer ID:</Text>
                        <Text className={isDark ? "text-blue-400 font-mono text-xs bg-blue-400/10 px-2 py-1 rounded" : "text-blue-600 font-mono text-xs bg-blue-100 px-2 py-1 rounded"}>
                          {billing.stripeCustomerId.substring(0, 20)}...
                        </Text>
                      </div>
                    </>
                  )}
                </AntCard>
              </motion.div>

              {/* Invoices Section */}
              {(billing.stripeCustomerId || billing.razorpayCustomerId) && (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2 }}
                >
                  <AntCard
                    className={isDark ? "border-blue-500/20 bg-gradient-to-br from-zinc-900/95 via-zinc-800/95 to-zinc-900/95 backdrop-blur-xl" : "border-blue-200 bg-white"}
                    style={isDark ? { borderRadius: '16px', border: '1px solid rgba(59, 130, 246, 0.25)' } : { borderRadius: '16px', border: '1px solid rgba(191, 219, 254, 0.5)', boxShadow: '0 4px 6px rgba(15, 23, 42, 0.08)' }}
                  >
                    <div className="flex items-center justify-between mb-4">
                      <div className="flex items-center">
                        <FileText className={`w-4 h-4 mr-2 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
                        <Title level={5} className={`!mb-0 !text-base !font-bold ${isDark ? '!text-white' : '!text-slate-900'}`}>
                          Invoices
                        </Title>
                      </div>
                      {invoicesLoading && <Spin size="small" />}
                    </div>

                    {invoicesLoading ? (
                      <div className="flex justify-center py-8">
                        <Spin size="large" />
                      </div>
                    ) : invoices.length === 0 ? (
                      <div className={`text-center py-8 ${isDark ? 'text-gray-400' : 'text-slate-600'}`}>
                        <FileText className={`w-12 h-12 mx-auto mb-2 ${isDark ? 'text-gray-600' : 'text-slate-400'}`} />
                        <Text>No invoices found</Text>
                      </div>
                    ) : (
                      <div className="space-y-3">
                        {invoices.map((invoice) => (
                          <div
                            key={invoice.id}
                            className={`p-4 rounded-lg border ${isDark
                              ? 'bg-white/5 border-white/10 hover:bg-white/10'
                              : 'bg-gray-50 border-gray-200 hover:bg-gray-100'
                              } transition-colors`}
                          >
                            <div className="flex items-center justify-between">
                              <div className="flex-1">
                                <div className="flex items-center gap-2 mb-1">
                                  <Text className={`font-semibold ${isDark ? 'text-white' : 'text-slate-900'}`}>
                                    {invoice.number || `Invoice #${invoice.id.substring(0, 8)}`}
                                  </Text>
                                  <Badge
                                    color={
                                      invoice.status === 'paid' || (invoice.amountPaid > 0 && invoice.amountDue === 0) ? 'green' :
                                        invoice.status === 'open' ? 'orange' :
                                          invoice.status === 'draft' ? 'default' :
                                            invoice.status === 'void' ? 'default' : 'red'
                                    }
                                    text={
                                      invoice.status === 'paid' || (invoice.amountPaid > 0 && invoice.amountDue === 0) ? 'Paid' :
                                        invoice.status === 'open' ? 'Due' :
                                          invoice.status === 'draft' ? 'Draft' :
                                            invoice.status === 'void' ? 'Void' :
                                              invoice.status === 'uncollectible' ? 'Uncollectible' :
                                                invoice.status.charAt(0).toUpperCase() + invoice.status.slice(1)
                                    }
                                  />
                                </div>
                                <Text className={`text-xs ${isDark ? 'text-gray-400' : 'text-slate-600'}`}>
                                  {new Date(invoice.date).toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                  })}
                                </Text>
                                <Text className={`text-sm mt-1 ml-5 ${isDark ? 'text-gray-300' : 'text-slate-700'}`}>
                                  {invoice.description}
                                </Text>
                              </div>
                              <div className="flex items-center gap-4">
                                <div className="text-right">
                                  {invoice.status === 'paid' || (invoice.amountPaid > 0 && invoice.amountDue === 0) ? (
                                    <>
                                      <Text className={`text-xs ${isDark ? 'text-gray-400' : 'text-slate-600'} block mb-1`}>
                                        Amount Paid
                                      </Text>
                                      <Text className={`font-bold text-lg ${isDark ? 'text-green-400' : 'text-green-600'}`}>
                                        {invoice.currency} {invoice.amountPaid.toFixed(2)}
                                      </Text>
                                    </>
                                  ) : invoice.amountDue > 0 ? (
                                    <>
                                      <Text className={`text-xs ${isDark ? 'text-gray-400' : 'text-slate-600'} block mb-1`}>
                                        Amount Due
                                      </Text>
                                      <Text className={`font-bold text-lg ${isDark ? 'text-orange-400' : 'text-orange-600'}`}>
                                        {invoice.currency} {invoice.amountDue.toFixed(2)}
                                      </Text>
                                      {invoice.amountPaid > 0 && (
                                        <Text className={`text-xs ${isDark ? 'text-gray-500' : 'text-slate-500'} mt-1`}>
                                          Paid: {invoice.currency} {invoice.amountPaid.toFixed(2)}
                                        </Text>
                                      )}
                                    </>
                                  ) : (
                                    <Text className={`font-bold text-lg ${isDark ? 'text-white' : 'text-slate-900'}`}>
                                      {invoice.currency} {invoice.amountPaid.toFixed(2)}
                                    </Text>
                                  )}
                                </div>
                                {invoice.invoicePdf && (
                                  <Button
                                    type="primary"
                                    size="small"
                                    icon={<Download className="w-4 h-4" />}
                                    onClick={() => handleDownloadInvoice(invoice.id, invoice.number)}
                                  >
                                    Download
                                  </Button>
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </AntCard>
                </motion.div>
              )}

              {/* Upgrade Plan Card - Show for Free/Standard */}
              {billing.orgPlanSelection && (billing.orgPlanSelection === 'free' || billing.orgPlanSelection === 'standard') && (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.15 }}
                >
                  <AntCard
                    className={isDark ? "border-purple-500/20 bg-gradient-to-br from-zinc-900/95 via-zinc-800/95 to-zinc-900/95 backdrop-blur-xl" : "border-purple-200 bg-white"}
                    style={isDark ? { borderRadius: '16px', border: '1px solid rgba(168, 85, 247, 0.25)' } : { borderRadius: '16px', border: '1px solid rgba(196, 181, 253, 0.5)', boxShadow: '0 4px 6px rgba(15, 23, 42, 0.08)' }}
                  >
                    <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center">
                        <Sparkles className={`w-4 h-4 mr-2 ${isDark ? 'text-purple-400' : 'text-purple-600'}`} />
                        <Title level={5} className={`!mb-0 !text-base !font-bold ${isDark ? '!text-white' : '!text-slate-900'}`}>Upgrade Your Plan</Title>
                      </div>
                      <Badge
                        color="purple"
                        text={<span className={isDark ? "text-white text-xs" : "text-slate-900 text-xs"}>Upgrade Available</span>}
                      />
                    </div>

                    <Paragraph className={`!mb-3 !text-xs ${isDark ? '!text-gray-400' : '!text-slate-600'}`}>
                      Unlock more features and capabilities by upgrading to a higher plan.
                    </Paragraph>

                    {/* Coupon Code Section */}
                    <div className={`mb-4 p-3 rounded-lg border ${isDark ? 'bg-white/5 border-white/10' : 'bg-gray-50 border-gray-200'
                      }`}>
                      <label className={`block text-xs font-medium mb-2 ${isDark ? 'text-gray-300' : 'text-gray-700'
                        }`}>
                        Have a coupon or promotion code? (Optional)
                      </label>
                      <div className="flex gap-2">
                        <div className="flex-1 relative">
                          <input
                            type="text"
                            value={couponCode}
                            onChange={(e) => {
                              const value = e.target.value.toUpperCase();
                              setCouponCode(value);

                              // Clear previous timeout
                              if (couponTimeoutRef.current) {
                                clearTimeout(couponTimeoutRef.current);
                              }

                              // Verify after user stops typing (debounce)
                              if (value.trim() === '') {
                                setActualCouponId(null);
                                setCouponValid(null);
                                setCouponDiscount(null);
                              } else {
                                // Debounce verification - wait 800ms after user stops typing
                                couponTimeoutRef.current = setTimeout(() => {
                                  verifyCouponCode(value);
                                }, 800);
                              }
                            }}
                            onBlur={() => {
                              if (couponCode.trim() !== '') {
                                verifyCouponCode(couponCode);
                              }
                            }}
                            placeholder="Enter coupon or promotion code"
                            className={`w-full px-3 py-2 text-sm rounded-lg border focus:outline-none focus:ring-2 ${couponValid === true
                              ? isDark
                                ? 'bg-green-500/10 border-green-500/50 text-white focus:ring-green-500/50 focus:border-green-500/50'
                                : 'bg-green-50 border-green-500 text-gray-900 focus:ring-green-500 focus:border-green-500'
                              : couponValid === false
                                ? isDark
                                  ? 'bg-red-500/10 border-red-500/50 text-white focus:ring-red-500/50 focus:border-red-500/50'
                                  : 'bg-red-50 border-red-500 text-gray-900 focus:ring-red-500 focus:border-red-500'
                                : isDark
                                  ? 'bg-white/5 border-white/20 text-white placeholder-gray-500 focus:ring-blue-500/50 focus:border-blue-500/50'
                                  : 'bg-white border-gray-300 text-gray-900 placeholder-gray-400 focus:ring-blue-500 focus:border-blue-500'
                              }`}
                            style={{ height: '36px' }}
                            disabled={couponVerifying}
                          />
                          {couponVerifying && (
                            <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                              <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-blue-500"></div>
                            </div>
                          )}
                          {couponValid === true && !couponVerifying && (
                            <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                              <Check className="h-4 w-4 text-green-500" />
                            </div>
                          )}
                          {couponValid === false && !couponVerifying && (
                            <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
                              <X className="h-4 w-4 text-red-500" />
                            </div>
                          )}
                        </div>
                        {couponCode && (
                          <button
                            type="button"
                            onClick={() => {
                              setCouponCode('');
                              setActualCouponId(null);
                              setCouponValid(null);
                              setCouponDiscount(null);
                            }}
                            className={`px-2 py-2 text-xs rounded-lg border transition-colors ${isDark
                              ? 'bg-white/10 border-white/20 text-gray-300 hover:bg-white/20'
                              : 'bg-gray-100 border-gray-300 text-gray-700 hover:bg-gray-200'
                              }`}
                          >
                            Clear
                          </button>
                        )}
                      </div>
                      {couponValid === true && couponDiscount && (
                        <Text className={`text-xs mt-1.5 block font-medium ${isDark ? 'text-green-400' : 'text-green-600'
                          }`}>
                          ✅ Valid! {couponDiscount} will be applied at checkout
                        </Text>
                      )}
                      {couponValid === false && (
                        <Text className={`text-xs mt-1.5 block ${isDark ? 'text-red-400' : 'text-red-600'
                          }`}>
                          ❌ Invalid coupon code. Please check and try again.
                        </Text>
                      )}
                    </div>

                    <div className="flex flex-wrap gap-2 items-stretch">
                      {(() => {
                        if (!billing.orgPlanSelection) return [];
                        switch (billing.orgPlanSelection) {
                          case 'free':
                            return [
                              { plan: 'standard', name: 'Standard', price: getPrice('standard'), features: ['All features', 'Unlimited team members', 'Advanced analytics'] },
                              { plan: 'premium', name: 'Premium', price: getPrice('premium'), features: ['All features', 'Org Intelligence', 'Priority support', 'Advanced AI'] }
                            ];
                          case 'standard':
                            return [
                              { plan: 'premium', name: 'Premium', price: getPrice('premium'), features: ['Org Intelligence', 'Priority support', 'Advanced AI'] }
                            ];
                        default:
                          return [];
                      }
                      })().map((upgradeOption) => {
                        // Calculate minimum member count (current used - 1 for admin)
                        const isFreePlan = billing.orgPlanSelection === 'free';
                        const currentSlots = isFreePlan 
                          ? (billing.usedMemberSlots || 1) // Free plan: use usedMemberSlots
                          : (billing.paidMemberSlots || 1); // Paid plan: use paidMemberSlots
                        const minMemberCount = Math.max(1, currentSlots - 1); // Minimum = current used - 1 (admin excluded)
                        
                        // Get member count for this plan (default to minimum if not set)
                        const memberCount = upgradeMemberCount[upgradeOption.plan] || minMemberCount;
                        
                        // Calculate total seats and price
                        const totalSeats = memberCount + 1; // +1 for admin
                        const monthlyPrice = totalSeats * upgradeOption.price;
                        
                        return (
                        <motion.div
                          key={upgradeOption.plan}
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          whileHover={{ scale: 1.02 }}
                          className="flex-1 min-w-[280px]"
                        >
                          <AntCard
                            className={`${isDark ? "border-purple-500/20 bg-gradient-to-br from-purple-500/8 to-purple-600/4 hover:bg-purple-500/12 transition-all" : "border-purple-200 bg-purple-50 hover:bg-purple-100 transition-all"} h-full flex flex-col`}
                            style={isDark ? { borderRadius: '12px', border: '1px solid rgba(168, 85, 247, 0.25)' } : { borderRadius: '12px', border: '1px solid rgba(196, 181, 253, 0.5)', boxShadow: '0 2px 4px rgba(15, 23, 42, 0.06)' }}
                            bodyStyle={{ display: 'flex', flexDirection: 'column', height: '100%', padding: '16px' }}
                          >
                            <div className="text-center flex flex-col h-full">
                              <div className={`w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-2 border ${isDark ? 'bg-gradient-to-br from-purple-500/20 to-purple-600/15 border-purple-400/25' : 'bg-purple-100 border-purple-300'}`}>
                                {upgradeOption.plan === 'premium' ? (
                                  <Crown className={`w-5 h-5 ${isDark ? 'text-purple-300' : 'text-purple-600'}`} />
                                ) : (
                                  <Zap className={`w-5 h-5 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
                                )}
                              </div>
                              <Title level={5} className={`!mb-1 !text-sm !font-bold ${isDark ? '!text-white' : '!text-slate-900'}`}>
                                Upgrade to {upgradeOption.name}
                              </Title>
                              <div className="mb-3">
                                <span className={`text-xl font-bold ${isDark ? 'text-white' : 'text-slate-900'}`}>{symbol}{upgradeOption.price}</span>
                                <span className={`text-xs ml-1 ${isDark ? 'text-gray-400' : 'text-slate-600'}`}>/month per slot</span>
                              </div>
                              <div className="space-y-1.5 mb-3 text-left flex-grow">
                                {upgradeOption.features.map((feature, idx) => (
                                  <div key={idx} className={`flex items-center text-xs ${isDark ? 'text-gray-400' : 'text-slate-600'}`}>
                                    <Check className={`w-3 h-3 mr-2 flex-shrink-0 ${isDark ? 'text-green-400' : 'text-green-600'}`} />
                                    <span>{feature}</span>
                                  </div>
                                ))}
                              </div>
                              
                              {/* Member Count Input Section */}
                              <div className={`mb-3 p-3 rounded-lg ${isDark ? 'bg-white/5 border border-white/10' : 'bg-gray-50 border border-gray-200'}`}>
                                <div className="mb-2">
                                  <Text className={`text-xs block mb-1.5 font-medium ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
                                    Number of Team Members
                                  </Text>
                                  <InputNumber
                                    min={minMemberCount}
                                    max={1000}
                                    value={memberCount}
                                    onChange={(value) => {
                                      setUpgradeMemberCount(prev => ({
                                        ...prev,
                                        [upgradeOption.plan]: value || minMemberCount
                                      }));
                                    }}
                                    controls={true}
                                    className="w-full"
                                    style={{ width: '100%' }}
                                    size="small"
                                  />
                                  <Text className={`text-xs block mt-1.5 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                    Currently using: {currentSlots} slots (1 admin + {currentSlots - 1} members)
                                  </Text>
                                  <Text className={`text-xs block mt-0.5 ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                    Total seats: {totalSeats} (1 admin + {memberCount} members)
                                  </Text>
                                </div>
                                <Divider className="!my-2 !border-gray-300/50" />
                                <div className="text-center">
                                  <Text className={`text-xs block ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                                    Monthly Total
                                  </Text>
                                  <Text className={`text-lg font-bold block ${isDark ? 'text-white' : 'text-slate-900'}`}>
                                    {symbol}{monthlyPrice.toFixed(2)}/month
                                  </Text>
                                </div>
                              </div>
                              
                              <AntButton
                                type="primary"
                                size="small"
                                loading={upgradeProcessingPlan === upgradeOption.plan}
                                disabled={!!upgradeProcessingPlan && upgradeProcessingPlan !== upgradeOption.plan}
                                className="bg-purple-600 hover:bg-purple-700 border-purple-600 !text-white mt-auto"
                                style={{ borderRadius: '8px', width: '100%', height: '36px' }}
                                icon={<Sparkles className="w-3 h-3" />}
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  if (upgradeProcessingPlan) return;
                                  try {
                                    setUpgradeProcessingPlan(upgradeOption.plan);
                                    toast.loading(`Upgrading to ${upgradeOption.name}...`, { id: 'upgrade-loading' });
                                    
                                    // Try Razorpay first for Indian users
                                    if (billing.paymentGateway === 'razorpay') {
                                      try {
                                        const rzpRes = await api.post('/api/v1/public/razorpay-billing/organization-subscription-checkout', {
                                          userId: user?.id, plan: upgradeOption.plan, memberCount,
                                          ...(actualCouponId && { couponCode: actualCouponId })
                                        });
                                        if (rzpRes.data?.success && (rzpRes.data?.data?.subscriptionId || rzpRes.data?.data?.orderId)) {
                                          toast.dismiss('upgrade-loading');
                                          const rzpData = rzpRes.data.data;
                                          openRazorpayCheckout({
                                            razorpayKeyId: rzpData.razorpayKeyId, amount: rzpData.amount,
                                            currency: rzpData.currency, orderId: rzpData.orderId,
                                            subscriptionId: rzpData.subscriptionId,
                                            customerName: rzpData.customerName, customerEmail: rzpData.customerEmail,
                                            notes: rzpData.notes, description: `TeamGrid ${upgradeOption.name} Upgrade`,
                                            onSuccess: async (pr) => {
                                              try {
                                                await api.post('/api/v1/public/razorpay-billing/verify-payment', {
                                                  razorpay_order_id: pr.razorpay_order_id, razorpay_payment_id: pr.razorpay_payment_id,
                                                  razorpay_signature: pr.razorpay_signature, razorpay_subscription_id: pr.razorpay_subscription_id,
                                                  userId: user?.id,
                                                  organizationId: rzpData.notes.organizationId, plan: upgradeOption.plan,
                                                  memberCount, totalSeats: rzpData.totalSeats, type: rzpData.billingType === 'one_time' ? 'one_time_payment' : 'organization_subscription',
                                                });
                                                toast.success('Upgrade successful!');
                                                setTimeout(() => { window.location.href = '/dashboard/settings?section=billing&payment=success'; }, 100);
                                              } catch { toast.error('Payment verification failed'); setUpgradeProcessingPlan(null); }
                                            },
                                            onFailure: () => { toast.error('Payment failed'); setUpgradeProcessingPlan(null); },
                                            onDismiss: () => { setUpgradeProcessingPlan(null); },
                                          });
                                          return;
                                        }
                                      } catch { /* fall through to Stripe */ }
                                    }

                                    const response = await api.post('/api/v1/public/billing/organization-subscription-checkout', {
                                      userId: user?.id,
                                      plan: upgradeOption.plan,
                                      memberCount: memberCount,
                                      ...(actualCouponId && { couponCode: actualCouponId })
                                    });
                                    
                                    if (response.data.success) {
                                      toast.dismiss('upgrade-loading');
                                      window.location.href = response.data.data.url;
                                    } else {
                                      toast.error(response.data.message || 'Failed to start upgrade');
                                      setUpgradeProcessingPlan(null);
                                    }
                                  } catch (error) {
                                    toast.dismiss('upgrade-loading');
                                    toast.error(error.response?.data?.message || 'Failed to upgrade plan');
                                    setUpgradeProcessingPlan(null);
                                  }
                                }}
                              >
                                {upgradeProcessingPlan === upgradeOption.plan ? 'Processing...' : `Upgrade to ${upgradeOption.name}`}
                              </AntButton>
                            </div>
                          </AntCard>
                        </motion.div>
                        );
                      })}
                </div>
                  </AntCard>
                </motion.div>
              )}

              {/* Downgrade Plan Card - Show only for Premium users (can downgrade to Standard) */}
              {billing.orgPlanSelection && billing.orgPlanSelection === 'premium' && (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.15 }}
                >
                  <AntCard
                    className={isDark ? "border-orange-500/20 bg-gradient-to-br from-zinc-900/95 via-zinc-800/95 to-zinc-900/95 backdrop-blur-xl" : "border-orange-200 bg-white"}
                    style={isDark ? { borderRadius: '16px', border: '1px solid rgba(251, 146, 60, 0.25)' } : { borderRadius: '16px', border: '1px solid rgba(251, 146, 60, 0.3)', boxShadow: '0 4px 6px rgba(15, 23, 42, 0.08)' }}
                  >
                    <div className="flex items-center justify-between mb-3">
                      <div className="flex items-center">
                        <TrendingDown className={`w-4 h-4 mr-2 ${isDark ? 'text-orange-400' : 'text-orange-600'}`} />
                        <Title level={5} className={`!mb-0 !text-base !font-bold ${isDark ? '!text-white' : '!text-slate-900'}`}>Downgrade Your Plan</Title>
                      </div>
                      <Badge
                        color="orange"
                        text={<span className={`text-xs ${isDark ? 'text-white' : 'text-slate-900'}`}>Downgrade Available</span>}
                      />
                    </div>

                    <Paragraph className={`!mb-3 !text-xs ${isDark ? '!text-gray-400' : '!text-slate-600'}`}>
                      Switch to a lower plan to reduce costs. Same number of slots will be maintained.
                    </Paragraph>

                    <div className="flex flex-wrap gap-2">
                      {(() => {
                        if (!billing.orgPlanSelection) return [];
                        switch (billing.orgPlanSelection) {
                          case 'premium':
                            return [
                              { plan: 'standard', name: 'Standard', price: getPrice('standard'), features: ['All features', 'Unlimited team members', 'Advanced analytics'], note: 'No Org Intelligence' }
                            ];
                          case 'standard':
                            // Standard plan cannot downgrade to Free
                            return [];
                          default:
                            return [];
                        }
                      })().map((downgradeOption) => (
                        <motion.div
                          key={downgradeOption.plan}
                          initial={{ opacity: 0, scale: 0.95 }}
                          animate={{ opacity: 1, scale: 1 }}
                          whileHover={{ scale: 1.02 }}
                          className="flex-1 min-w-[180px]"
                        >
                          <AntCard
                            className={isDark ? "border-orange-500/20 bg-gradient-to-br from-orange-500/8 to-orange-600/4 hover:bg-orange-500/12 cursor-pointer transition-all" : "border-orange-200 bg-orange-50 hover:bg-orange-100 cursor-pointer transition-all"}
                            style={isDark ? { borderRadius: '12px', border: '1px solid rgba(251, 146, 60, 0.25)' } : { borderRadius: '12px', border: '1px solid rgba(251, 146, 60, 0.3)', boxShadow: '0 2px 4px rgba(15, 23, 42, 0.06)' }}
                            onClick={() => {
                              if (downgradeProcessingPlan) return;
                              // Show confirmation modal
                              setPendingDowngrade(downgradeOption);
                              setShowDowngradeConfirmModal(true);
                            }}
                          >
                            <div className="text-center">
                              <div className={`w-10 h-10 rounded-full flex items-center justify-center mx-auto mb-2 border ${isDark ? 'bg-gradient-to-br from-orange-500/20 to-orange-600/15 border-orange-400/25' : 'bg-orange-100 border-orange-300'
                                }`}>
                                {downgradeOption.plan === 'free' ? (
                                  <ArrowDown className={`w-5 h-5 ${isDark ? 'text-orange-300' : 'text-orange-600'}`} />
                                ) : (
                                  <Zap className={`w-5 h-5 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
                                )}
                              </div>
                              <Title level={5} className={`!mb-1 !text-sm !font-bold ${isDark ? '!text-white' : '!text-slate-900'}`}>
                                Downgrade to {downgradeOption.name}
                              </Title>
                              <div className="mb-3">
                                <span className={`text-xl font-bold ${isDark ? 'text-white' : 'text-slate-900'}`}>{symbol}{downgradeOption.price}</span>
                                <span className={`text-xs ml-1 ${isDark ? 'text-gray-400' : 'text-slate-600'}`}>/month per slot</span>
                              </div>
                              <div className="space-y-1.5 mb-3 text-left">
                                {downgradeOption.features.map((feature, idx) => (
                                  <div key={idx} className={`flex items-center text-xs ${isDark ? 'text-gray-400' : 'text-slate-600'}`}>
                                    <Check className={`w-3 h-3 mr-2 flex-shrink-0 ${isDark ? 'text-green-400' : 'text-green-600'}`} />
                                    <span>{feature}</span>
                                  </div>
                                ))}
                                {downgradeOption.note && (
                                  <div className={`flex items-center text-xs mt-2 ${isDark ? 'text-orange-400' : 'text-orange-600'}`}>
                                    <ArrowDown className={`w-3 h-3 mr-2 flex-shrink-0 ${isDark ? 'text-orange-400' : 'text-orange-600'}`} />
                                    <span>{downgradeOption.note}</span>
                                  </div>
                                )}
                              </div>
                              <AntButton
                                type="default"
                                size="small"
                                loading={downgradeProcessingPlan === downgradeOption.plan}
                                disabled={!!downgradeProcessingPlan && downgradeProcessingPlan !== downgradeOption.plan}
                                className="bg-orange-600 hover:bg-orange-700 border-orange-600 !text-white"
                                style={{ borderRadius: '8px', width: '100%', height: '36px', color: '#ffffff' }}
                                icon={<TrendingDown className="w-3 h-3 text-white" />}
                              >
                                {downgradeProcessingPlan === downgradeOption.plan ? 'Processing...' : `Downgrade to ${downgradeOption.name}`}
                              </AntButton>
                            </div>
                          </AntCard>
                        </motion.div>
                      ))}
                    </div>
                  </AntCard>
                </motion.div>
              )}

              {/* Premium Plan Status Card - Show for Premium users */}
              {billing.orgPlanSelection === 'premium' && (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.15 }}
                  className="relative"
                >
                  {/* Animated Background Glow */}
                  <motion.div
                    animate={{
                      background: [
                        'radial-gradient(circle at 20% 50%, rgba(168, 85, 247, 0.08), transparent 50%)',
                        'radial-gradient(circle at 80% 50%, rgba(168, 85, 247, 0.08), transparent 50%)',
                        'radial-gradient(circle at 20% 50%, rgba(168, 85, 247, 0.08), transparent 50%)'
                      ]
                    }}
                    transition={{ duration: 4, repeat: Infinity }}
                    className="absolute inset-0 rounded-xl pointer-events-none"
                  />

                  <AntCard
                    className={isDark ? "border-purple-500/20 bg-gradient-to-br from-zinc-900/95 via-zinc-800/95 to-zinc-900/95 backdrop-blur-xl relative overflow-hidden" : "border-purple-200 bg-white relative overflow-hidden"}
                    style={isDark ? {
                      borderRadius: '16px',
                      border: '1px solid rgba(168, 85, 247, 0.25)',
                      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(168, 85, 247, 0.1) inset'
                    } : {
                      borderRadius: '16px',
                      border: '1px solid rgba(196, 181, 253, 0.5)',
                      boxShadow: '0 4px 16px rgba(15, 23, 42, 0.1), 0 0 0 1px rgba(196, 181, 253, 0.2) inset'
                    }}
                  >
                    {/* Decorative Sparkles */}
                    <div className="absolute top-3 right-3 opacity-20">
                      <motion.div
                        animate={{ rotate: 360, scale: [1, 1.1, 1] }}
                        transition={{ duration: 3, repeat: Infinity }}
                      >
                        <Sparkles className="w-6 h-6 text-purple-400" />
                      </motion.div>
                    </div>

                    {/* Header Section - Compact */}
                    <div className="relative z-10 mb-4">
                      <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center space-x-3">
                          <motion.div
                            animate={{
                              scale: [1, 1.05, 1],
                              rotate: [0, 3, -3, 0]
                            }}
                            transition={{ duration: 2, repeat: Infinity }}
                            className={`w-12 h-12 rounded-full flex items-center justify-center border ${isDark ? 'bg-gradient-to-br from-purple-500/20 to-purple-600/15 border-purple-400/30' : 'bg-purple-100 border-purple-300'
                              }`}
                          >
                            <Crown className={`w-6 h-6 ${isDark ? 'text-purple-300' : 'text-purple-600'}`} />
                          </motion.div>
                          <div>
                            <Title level={4} className={`!mb-0 !text-lg !font-bold ${isDark ? '!text-white' : '!text-slate-900'}`}>
                              Premium Plan Active
                            </Title>
                            <Text className={`!text-xs !font-normal ${isDark ? '!text-gray-400' : '!text-slate-600'}`}>
                              You're on the best plan available
                            </Text>
                          </div>
                        </div>
                        <motion.div
                          initial={{ scale: 0 }}
                          animate={{ scale: 1 }}
                          transition={{ delay: 0.3, type: 'spring' }}
                        >
                          <Badge.Ribbon
                            text="Maximum Features"
                            color="purple"
                            style={{ fontSize: '11px', fontWeight: '600' }}
                          />
                        </motion.div>
                      </div>

                      {/* Premium Stats Row - Compact */}
                      <div className="grid grid-cols-3 gap-3 mb-4">
                        <motion.div
                          initial={{ opacity: 0, x: -20 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ delay: 0.4 }}
                          className={`p-3 rounded-lg border text-center ${isDark ? 'bg-gradient-to-br from-purple-500/10 to-purple-600/5 border-purple-500/20' : 'bg-purple-50 border-purple-200'
                            }`}
                        >
                          <Text className={`!text-xs !font-medium !mb-1 block ${isDark ? '!text-gray-400' : '!text-slate-600'}`}>Premium Features</Text>
                          <Text className={`!text-xl !font-bold ${isDark ? '!text-white' : '!text-slate-900'}`}>Unlimited</Text>
                        </motion.div>
                        <motion.div
                          initial={{ opacity: 0, y: -20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ delay: 0.5 }}
                          className={`p-3 rounded-lg border text-center ${isDark ? 'bg-gradient-to-br from-purple-500/10 to-purple-600/5 border-purple-500/20' : 'bg-purple-50 border-purple-200'
                            }`}
                        >
                          <Text className={`!text-xs !font-medium !mb-1 block ${isDark ? '!text-gray-400' : '!text-slate-600'}`}>Support Level</Text>
                          <Text className={`!text-xl !font-bold ${isDark ? '!text-white' : '!text-slate-900'}`}>24/7</Text>
                        </motion.div>
                        <motion.div
                          initial={{ opacity: 0, x: 20 }}
                          animate={{ opacity: 1, x: 0 }}
                          transition={{ delay: 0.6 }}
                          className={`p-3 rounded-lg border text-center ${isDark ? 'bg-gradient-to-br from-purple-500/10 to-purple-600/5 border-purple-500/20' : 'bg-purple-50 border-purple-200'
                            }`}
                        >
                          <Text className={`!text-xs !font-medium !mb-1 block ${isDark ? '!text-gray-400' : '!text-slate-600'}`}>AI Access</Text>
                          <Text className={`!text-xl !font-bold ${isDark ? '!text-white' : '!text-slate-900'}`}>Advanced</Text>
                        </motion.div>
                      </div>
                    </div>

                    {/* Feature Cards with Staggered Animation - Compact */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-4 relative z-10">
                      {[
                        { icon: Brain, title: 'Org Intelligence', desc: 'Advanced organizational insights & analytics', delay: 0.7 },
                        { icon: Sparkles, title: 'Priority Support', desc: '24/7 dedicated support team', delay: 0.8 },
                        { icon: Zap, title: 'Advanced AI', desc: 'Cutting-edge AI features & automation', delay: 0.9 }
                      ].map((feature, idx) => {
                        const IconComponent = feature.icon;
                        return (
                          <motion.div
                            key={idx}
                            initial={{ opacity: 0, y: 20, scale: 0.9 }}
                            animate={{ opacity: 1, y: 0, scale: 1 }}
                            transition={{ delay: feature.delay, type: 'spring', stiffness: 100 }}
                            whileHover={{ scale: 1.02, y: -2 }}
                            className="group"
                          >
                            <div className={`p-3 rounded-lg border transition-all duration-300 h-full ${isDark ? 'bg-gradient-to-br from-purple-500/8 to-purple-600/4 border-purple-500/15 hover:border-purple-400/30 backdrop-blur-sm' : 'bg-purple-50 border-purple-200 hover:border-purple-300'
                              }`}>
                              <div className="flex items-center mb-2">
                                <div className={`w-8 h-8 rounded-lg flex items-center justify-center mr-2 border group-hover:scale-110 transition-transform ${isDark ? 'bg-gradient-to-br from-purple-500/20 to-purple-600/15 border-purple-400/25' : 'bg-purple-100 border-purple-300'
                                  }`}>
                                  <IconComponent className={`w-4 h-4 ${isDark ? 'text-purple-300' : 'text-purple-600'}`} />
                                </div>
                                <Text className={`!text-xs !font-semibold !mb-0 ${isDark ? '!text-white' : '!text-slate-900'}`}>
                                  {feature.title}
                                </Text>
                              </div>
                              <Text className={`!text-xs !leading-relaxed ${isDark ? '!text-gray-400' : '!text-slate-600'}`}>
                                {feature.desc}
                              </Text>
                            </div>
                          </motion.div>
                        );
                      })}
                    </div>

                    {/* Success Message - Compact */}
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: 1 }}
                      className={`relative z-10 mt-4 p-3 rounded-lg border text-center ${isDark ? 'bg-gradient-to-r from-purple-500/10 via-purple-600/10 to-purple-500/10 border-purple-400/20' : 'bg-purple-50 border-purple-200'
                        }`}
                    >
                      <div className="flex items-center justify-center space-x-2 mb-1">
                        <motion.div
                          animate={{ rotate: [0, 360] }}
                          transition={{ duration: 2, repeat: Infinity, ease: 'linear' }}
                        >
                          <Sparkles className={`w-4 h-4 ${isDark ? 'text-yellow-400' : 'text-yellow-600'}`} />
                        </motion.div>
                        <Text className={`!text-sm !font-semibold !mb-0 ${isDark ? '!text-white' : '!text-slate-900'}`}>
                          You have access to all premium features
                        </Text>
                      </div>
                      <Text className={`!text-xs !mb-0 ${isDark ? '!text-gray-400' : '!text-slate-600'}`}>
                        Enjoy the full power of Team Grid with unlimited capabilities!
                      </Text>
                    </motion.div>
                  </AntCard>
                </motion.div>
              )}

              {/* Slots Information Card */}
              {billing.orgPlanSelection && (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2 }}
                >
                  <AntCard
                    className={isDark ? "border-blue-500/20 bg-blue-500/10 backdrop-blur-xl" : "border-blue-200 bg-blue-50"}
                    style={isDark ? { borderRadius: '16px', border: '1px solid rgba(59, 130, 246, 0.2)' } : { borderRadius: '16px', border: '1px solid rgba(191, 219, 254, 0.5)', boxShadow: '0 4px 6px rgba(15, 23, 42, 0.08)' }}
                  >
                    <div className="flex items-center mb-6">
                      <TrendingUp className={`w-5 h-5 mr-2 ${isDark ? 'text-blue-400' : 'text-blue-600'}`} />
                      <Title level={4} className={`!mb-0 !text-xl ${isDark ? '!text-blue-300' : '!text-blue-700'}`}>Member Slots</Title>
                    </div>

                    <div className="grid grid-cols-3 gap-6">
                      <Statistic
                        title={<span className={isDark ? "text-blue-200 text-sm" : "text-blue-700 text-sm"}>Paid Slots</span>}
                        value={billing.paidMemberSlots || 1}
                        valueStyle={{ color: isDark ? '#ffffff' : '#0f172a', fontSize: '24px', fontWeight: 'bold' }}
                      />
                      <Statistic
                        title={<span className={isDark ? "text-blue-200 text-sm" : "text-blue-700 text-sm"}>Used Slots</span>}
                        value={billing.usedMemberSlots || 1}
                        valueStyle={{ color: isDark ? '#ffffff' : '#0f172a', fontSize: '24px', fontWeight: 'bold' }}
                      />
                      <Statistic
                        title={<span className={isDark ? "text-green-400 text-sm" : "text-green-600 text-sm"}>Remaining Slots</span>}
                        value={billing.remainingSlots || 0}
                        valueStyle={{ color: isDark ? '#4ade80' : '#16a34a', fontSize: '24px', fontWeight: 'bold' }}
                      />
                    </div>

                    {billing.remainingSlots <= 0 && (
                      <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.3 }}
                        className="mt-6"
                      >
                        <div className={`p-5 rounded-xl border-2 ${isDark ? 'bg-gradient-to-r from-orange-900/40 to-yellow-900/40 border-orange-500/50 backdrop-blur-sm' : 'bg-orange-50 border-orange-300'}`}>
                          <div className="flex items-start space-x-3">
                            <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 ${isDark ? 'bg-orange-500/20' : 'bg-orange-100'}`}>
                              <ShoppingCart className={`w-5 h-5 ${isDark ? 'text-orange-400' : 'text-orange-600'}`} />
                            </div>
                            <div className="flex-1">
                              <h4 className={`font-bold text-lg mb-2 ${isDark ? 'text-orange-300' : 'text-orange-700'}`}>⚠️ All Slots Are Exhausted</h4>
                              <p className={`text-sm mb-4 leading-relaxed ${isDark ? 'text-gray-200' : 'text-slate-700'}`}>
                                You have used all <span className={`font-bold ${isDark ? 'text-orange-300' : 'text-orange-600'}`}>{billing.paidMemberSlots || 1}</span> available member slots. To add more team members, please purchase additional slots.
                              </p>
                              <AntButton
                                type="primary"
                                size="middle"
                                icon={<ShoppingCart className="w-4 h-4" />}
                                onClick={() => window.location.href = '/dashboard/team'}
                                className="bg-orange-500 hover:bg-orange-600 border-orange-500 !text-white"
                                style={{ borderRadius: '8px' }}
                              >
                                Purchase Additional Slots
                              </AntButton>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    )}
                  </AntCard>
                </motion.div>
              )}

              {/* Trial End Date Card - For Free Plan Users */}
              {billing.orgPlanSelection === 'free' && billing.userTrialEndDate && (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.25 }}
                >
                  <AntCard
                    className={isDark ? "border-white/10 bg-gradient-to-br from-zinc-900/95 to-zinc-800/95 backdrop-blur-xl" : "border-slate-200 bg-white"}
                    style={isDark ? { borderRadius: '16px', border: '1px solid rgba(255, 255, 255, 0.1)' } : { borderRadius: '16px', border: '1px solid rgba(15, 23, 42, 0.12)', boxShadow: '0 4px 6px rgba(15, 23, 42, 0.08)' }}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <AlertTriangle className={`w-5 h-5 ${isDark ? 'text-yellow-400' : 'text-yellow-600'}`} />
                        <div>
                          <Title level={5} className={`!mb-1 !text-base ${isDark ? '!text-white' : '!text-slate-900'}`}>Free Plan Trial End Date</Title>
                          <Text className={isDark ? "text-gray-400 text-sm" : "text-slate-600 text-sm"}>
                            {billing.userTrialEndDate
                              ? new Date(billing.userTrialEndDate).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                              })
                              : 'N/A'}
                          </Text>
                          {billing.userTrialEndDate && (
                            <Text className={`text-xs mt-1 block ${isDark ? "text-yellow-400" : "text-yellow-600"}`}>
                              {(() => {
                                const now = new Date();
                                const trialEnd = new Date(billing.userTrialEndDate);
                                const daysRemaining = Math.ceil((trialEnd - now) / (1000 * 60 * 60 * 24));
                                if (daysRemaining < 0) {
                                  return 'Trial expired';
                                } else if (daysRemaining === 0) {
                                  return 'Trial ends today';
                                } else if (daysRemaining === 1) {
                                  return '1 day remaining';
                                } else {
                                  return `${daysRemaining} days remaining`;
                                }
                              })()}
                            </Text>
                          )}
                        </div>
                      </div>
                    </div>
                  </AntCard>
                </motion.div>
              )}

              {/* Next Billing Date Card */}
              {billing.currentPeriodEnd && (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.3 }}
                >
                  <AntCard
                    className={isDark ? "border-white/10 bg-gradient-to-br from-zinc-900/95 to-zinc-800/95 backdrop-blur-xl" : "border-slate-200 bg-white"}
                    style={isDark ? { borderRadius: '16px', border: '1px solid rgba(255, 255, 255, 0.1)' } : { borderRadius: '16px', border: '1px solid rgba(15, 23, 42, 0.12)', boxShadow: '0 4px 6px rgba(15, 23, 42, 0.08)' }}
                  >
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-3">
                        <Calendar className={`w-5 h-5 ${isDark ? 'text-green-400' : 'text-green-600'}`} />
                        <div>
                          <Title level={5} className={`!mb-1 !text-base ${isDark ? '!text-white' : '!text-slate-900'}`}>Next Billing Date</Title>
                          <Text className={isDark ? "text-gray-400 text-sm" : "text-slate-600 text-sm"}>
                            {billing.currentPeriodEnd
                              ? new Date(billing.currentPeriodEnd).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                              })
                              : 'N/A'}
                          </Text>
                        </div>
                      </div>
                      <div className="text-right">
                        <DollarSign className={`w-5 h-5 mb-1 ${isDark ? 'text-green-400' : 'text-green-600'}`} />
                        <Text className={`font-bold text-xl block ${isDark ? 'text-white' : 'text-slate-900'}`}>
                          {billing.nextBilling?.amount || `${symbol}0.00`}
                        </Text>
                        <Text className={isDark ? "text-gray-400 text-xs" : "text-slate-600 text-xs"}>per month</Text>
                      </div>
                    </div>
                  </AntCard>
                </motion.div>
              )}

              {/* Quick Actions */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
              >
                <AntCard
                  className={isDark ? "border-white/10 bg-gradient-to-br from-zinc-900/95 to-zinc-800/95 backdrop-blur-xl" : "border-slate-200 bg-white"}
                  style={isDark ? { borderRadius: '16px', border: '1px solid rgba(255, 255, 255, 0.1)' } : { borderRadius: '16px', border: '1px solid rgba(15, 23, 42, 0.12)', boxShadow: '0 4px 6px rgba(15, 23, 42, 0.08)' }}
                >
                  <Title level={4} className={`!mb-4 !text-xl ${isDark ? '!text-white' : '!text-slate-900'}`}>Quick Actions</Title>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {(billing.stripeSubscriptionId || billing.razorpaySubscriptionId || billing.paymentGateway === 'razorpay') && (
                      <AntButton
                        type="primary"
                        size="large"
                        icon={<CreditCard className="w-4 h-4" />}
                        onClick={async () => {
                          try {
                            if (billing.paymentGateway === 'razorpay') {
                              await handleResumeSubscription();
                              return;
                            }
                            if (billing.subscriptionStatus === 'canceled') {
                              const response = await api.post('/api/v1/billing/reactivate');
                              if (response.data.success) {
                                window.location.href = response.data.data.sessionUrl;
                              } else {
                                toast.error('Failed to create reactivation session');
                              }
                            } else {
                              const response = await api.post('/api/v1/billing/portal-session');
                              if (response.data.success) {
                                window.location.href = response.data.data.sessionUrl;
                              } else {
                                toast.error('Failed to create billing portal session');
                              }
                            }
                          } catch (error) {
                            toast.error('Failed to open billing portal');
                          }
                        }}
                        className="bg-blue-600 hover:bg-blue-700 border-blue-600 !text-white"
                        style={{ height: '48px', borderRadius: '8px' }}
                      >
                        {billing.subscriptionStatus === 'canceled' ? 'Resubscribe' : 'Manage Billing'}
                      </AntButton>
                    )}
                    <AntButton
                      size="large"
                      icon={<ShoppingCart className="w-4 h-4" />}
                      onClick={() => window.location.href = '/dashboard/team'}
                      className={isDark ? "bg-white/10 hover:bg-white/20 border-white/20 text-white" : "bg-slate-100 hover:bg-slate-200 border-slate-200 text-slate-900"}
                      style={{ height: '48px', borderRadius: '8px' }}
                    >
                      Purchase Additional Slots
                    </AntButton>
                  </div>
                </AntCard>
              </motion.div>
            </div>
          )}
        </motion.div>
      </AnimatePresence>
    </div>
  );

  // Setting Item Helper Component
  const SettingItem = ({ icon: Icon, title, description, enabled, onToggle }) => (
    <div className={`group flex items-center justify-between p-4 rounded-xl transition-all duration-300 ${isDark
      ? 'bg-white/[0.03] border-white/[0.05] hover:bg-white/[0.06] hover:border-white/10'
      : 'bg-slate-50 border-slate-200 hover:bg-slate-100'
      } border`}>
      <div className="flex items-center gap-4">
        <div className={`w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-300 ${enabled
          ? isDark
            ? 'bg-blue-600/20 text-blue-400 ring-1 ring-blue-500/20'
            : 'bg-blue-100 text-blue-600 ring-1 ring-blue-200'
          : isDark
            ? 'bg-white/5 text-slate-500'
            : 'bg-slate-100 text-slate-400'
          }`}>
          <Icon size={18} strokeWidth={2.5} />
        </div>
        <div className="flex flex-col text-left">
          <p className={`text-[14px] font-bold transition-colors ${isDark
            ? 'text-white group-hover:text-blue-400'
            : 'text-slate-900 group-hover:text-blue-600'
            }`}>{title}</p>
          <p className={`text-[10px] font-black uppercase tracking-widest mt-0.5 ${isDark ? 'text-slate-500' : 'text-slate-400'
            }`}>{description}</p>
        </div>
      </div>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#3b82f6',
          },
        }}
      >
        <Switch
          checked={enabled}
          onChange={onToggle}
          className="ml-4"
        />
      </ConfigProvider>
    </div>
  );

  // Goals Settings Render Function
  const renderGoalsSettings = () => {
    const handleSave = handleGoalsSettingsSave;

    return (
      <div className="animate-in fade-in slide-in-from-bottom-2 duration-500 text-left min-w-0 overflow-visible px-2 md:px-0">
        {/* SECTION 1: CORE POLICY & MODULES */}
        <div className="space-y-6">
          <div className="flex items-center gap-2 px-1">
            <GanttChartSquare size={16} className={isDark ? 'text-blue-500' : 'text-blue-600'} />
            <h3 className={`text-[11px] font-black uppercase tracking-[0.25em] ${isDark ? 'text-slate-500' : 'text-slate-400'
              }`}>1. Core Policy & Modules</h3>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            {/* Modules Management */}
            <div className={`p-4 md:p-6 rounded-xl md:rounded-[2rem] border space-y-3 md:space-y-4 shadow-xl ${isDark
              ? 'bg-[#0a0a0a] border-white/[0.05]'
              : 'bg-white border-slate-200'
              }`}>
              <div className="flex items-center gap-3 mb-2">
                <div className={`w-9 h-9 rounded-xl flex items-center justify-center border ${isDark
                  ? 'bg-blue-500/10 text-blue-500 border-blue-500/20'
                  : 'bg-blue-100 text-blue-600 border-blue-200'
                  }`}>
                  <Layers size={18} />
                </div>
                <p className={`text-[13px] font-black uppercase tracking-wider ${isDark ? 'text-white' : 'text-slate-900'
                  }`}>Module Visibility</p>
              </div>
              <div className="space-y-3">
                <div className={`flex items-center justify-between p-3.5 rounded-2xl border transition-colors ${isDark
                  ? 'bg-white/[0.02] border-white/[0.03] hover:bg-white/[0.04]'
                  : 'bg-slate-50 border-slate-100 hover:bg-slate-100'
                  }`}>
                  <div className="flex flex-col">
                    <span className={`text-xs font-bold ${isDark ? 'text-white' : 'text-slate-900'
                      }`}>My Goals</span>
                    <span className={`text-[9px] font-black uppercase ${isDark ? 'text-slate-600' : 'text-slate-400'
                      }`}>Enable target tracking</span>
                  </div>
                  <ConfigProvider
                    theme={{
                      token: {
                        colorPrimary: '#3b82f6',
                      },
                    }}
                  >
                    <Switch
                      checked={goalsSettings.myGoalsEnabled}
                      onChange={(checked) => updateSettings({ myGoalsEnabled: checked })}
                    />
                  </ConfigProvider>
                </div>
                <div className={`flex items-center justify-between p-3.5 rounded-2xl border transition-colors ${isDark
                  ? 'bg-white/[0.02] border-white/[0.03] hover:bg-white/[0.04]'
                  : 'bg-slate-50 border-slate-100 hover:bg-slate-100'
                  }`}>
                  <div className="flex flex-col">
                    <span className={`text-xs font-bold ${isDark ? 'text-white' : 'text-slate-900'
                      }`}>My Tasks</span>
                    <span className={`text-[9px] font-black uppercase ${isDark ? 'text-slate-600' : 'text-slate-400'
                      }`}>Task sync integrations</span>
                  </div>
                  <ConfigProvider
                    theme={{
                      token: {
                        colorPrimary: '#3b82f6',
                      },
                    }}
                  >
                    <Switch
                      checked={goalsSettings.myTasksEnabled}
                      onChange={(checked) => updateSettings({ myTasksEnabled: checked })}
                    />
                  </ConfigProvider>
                </div>
              </div>
            </div>

            {/* Frequency & Constraints */}
            <div className={`p-6 rounded-[2rem] border space-y-5 shadow-xl ${isDark
              ? 'bg-[#0a0a0a] border-white/[0.05]'
              : 'bg-white border-slate-200'
              }`}>
              <div className="flex items-center gap-3">
                <div className={`w-9 h-9 rounded-xl flex items-center justify-center border ${isDark
                  ? 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20'
                  : 'bg-emerald-100 text-emerald-600 border-emerald-200'
                  }`}>
                  <TargetIcon size={18} />
                </div>
                <p className={`text-[13px] font-black uppercase tracking-wider ${isDark ? 'text-white' : 'text-slate-900'
                  }`}>Cycle Constraints</p>
              </div>
              <div className="space-y-4">
                <div className={`flex gap-2 p-1 rounded-[1.25rem] border ${isDark
                  ? 'bg-black border-white/[0.05]'
                  : 'bg-slate-100 border-slate-200'
                  }`}>
                  <button
                    onClick={() => updateSettings({ cycleType: 'monthly' })}
                    className={`flex-1 py-2 text-[10px] font-black uppercase tracking-widest rounded-xl transition-all ${goalsSettings.cycleType === 'monthly'
                      ? isDark
                        ? 'bg-blue-600 !text-white shadow-lg'
                        : 'bg-blue-600 !text-white shadow-lg'
                      : isDark
                        ? 'text-slate-500 hover:text-slate-300'
                        : 'text-slate-500 hover:text-slate-700'
                      }`}
                  >
                    Monthly
                  </button>
                  {/* <button
                    onClick={() => updateSettings({ cycleType: 'weekly' })}
                    className={`flex-1 py-2 text-[10px] font-black uppercase tracking-widest rounded-xl transition-all ${
                      goalsSettings.cycleType === 'weekly'
                        ? isDark
                          ? 'bg-blue-600 !text-white shadow-lg'
                          : 'bg-blue-600 !text-white shadow-lg'
                        : isDark
                          ? 'text-slate-500 hover:text-slate-300'
                          : 'text-slate-500 hover:text-slate-700'
                    }`}
                  >
                    Weekly
                  </button> */}
                </div>
                <div className="grid grid-cols-3 gap-3">
                  <div className="space-y-1.5">
                    <label className={`text-[8px] font-black uppercase tracking-widest text-center block ${isDark ? 'text-slate-500' : 'text-slate-400'
                      }`}>Min Goals</label>
                    <ConfigProvider
                      theme={{
                        token: {
                          borderRadius: 12,
                          controlHeight: 40,
                          colorBgContainer: isDark ? '#000000' : '#ffffff',
                          colorBorder: isDark ? 'rgba(255, 255, 255, 0.05)' : '#e2e8f0',
                          colorText: isDark ? '#ffffff' : '#1e293b',
                          fontSize: 13,
                          fontFamily: 'inherit',
                          fontWeight: 900,
                        },
                      }}
                    >
                      <InputNumber
                        value={goalsSettings.minGoals}
                        onChange={(value) => updateSettings({ minGoals: value || 1 })}
                        min={1}
                        max={goalsSettings.maxGoals}
                        className="w-full text-center"
                        controls={false}
                        parser={(value) => value.replace(/\D/g, '')}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </ConfigProvider>
                  </div>
                  <div className="space-y-1.5">
                    <label className={`text-[8px] font-black uppercase tracking-widest text-center block ${isDark ? 'text-slate-500' : 'text-slate-400'
                      }`}>Max Goals</label>
                    <ConfigProvider
                      theme={{
                        token: {
                          borderRadius: 12,
                          controlHeight: 40,
                          colorBgContainer: isDark ? '#000000' : '#ffffff',
                          colorBorder: isDark ? 'rgba(255, 255, 255, 0.05)' : '#e2e8f0',
                          colorText: isDark ? '#ffffff' : '#1e293b',
                          fontSize: 13,
                          fontFamily: 'inherit',
                          fontWeight: 900,
                        },
                      }}
                    >
                      <InputNumber
                        value={goalsSettings.maxGoals}
                        onChange={(value) => updateSettings({ maxGoals: value || goalsSettings.minGoals })}
                        min={goalsSettings.minGoals}
                        className="w-full text-center"
                        controls={false}
                        parser={(value) => value.replace(/\D/g, '')}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </ConfigProvider>
                  </div>
                  <div className="space-y-1.5">
                    <label className={`text-[8px] font-black uppercase tracking-widest text-center block ${isDark ? 'text-slate-500' : 'text-slate-400'
                      }`}>Critical Req</label>
                    <ConfigProvider
                      theme={{
                        token: {
                          borderRadius: 12,
                          controlHeight: 40,
                          colorBgContainer: isDark ? '#000000' : '#ffffff',
                          colorBorder: isDark ? 'rgba(255, 255, 255, 0.05)' : '#e2e8f0',
                          colorText: isDark ? '#ffffff' : '#1e293b',
                          fontSize: 13,
                          fontFamily: 'inherit',
                          fontWeight: 900,
                        },
                      }}
                    >
                      <InputNumber
                        value={goalsSettings.criticalRequired}
                        onChange={(value) => updateSettings({ criticalRequired: value || 0 })}
                        min={0}
                        max={goalsSettings.minGoals}
                        className="w-full text-center"
                        controls={false}
                        parser={(value) => value.replace(/\D/g, '')}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </ConfigProvider>
                  </div>
                </div>

                {/* Goals Weightage Config */}
                <div className="grid grid-cols-2 gap-3 pt-2 border-t border-slate-100 dark:border-white/10">
                  <div className="space-y-1.5">
                    <label className={`text-[8px] font-black uppercase tracking-widest text-center block ${isDark ? 'text-slate-500' : 'text-slate-400'
                      }`}>Min Weightage %</label>
                    <ConfigProvider
                      theme={{
                        token: {
                          borderRadius: 12,
                          controlHeight: 40,
                          colorBgContainer: isDark ? '#000000' : '#ffffff',
                          colorBorder: isDark ? 'rgba(255, 255, 255, 0.05)' : '#e2e8f0',
                          colorText: isDark ? '#ffffff' : '#1e293b',
                          fontSize: 13,
                          fontFamily: 'inherit',
                          fontWeight: 900,
                        },
                      }}
                    >
                      <InputNumber
                        value={goalsSettings.minWeightage}
                        onChange={(value) => updateSettings({ minWeightage: value != null ? value : 10 })}
                        onBlur={(e) => {
                          const raw = goalsSettings.minWeightage;
                          if (raw == null || isNaN(raw)) return;
                          const maxW = goalsSettings.maxWeightage ?? 100;
                          const normalized = Math.round(Number(raw) / 10) * 10;
                          const clamped = Math.max(10, Math.min(maxW, normalized));
                          if (clamped !== goalsSettings.minWeightage) {
                            updateSettings({ minWeightage: clamped });
                          }
                        }}
                        min={10}
                        max={goalsSettings.maxWeightage ?? 100}
                        step={10}
                        className="w-full text-center"
                        controls={false}
                        formatter={(value) => value != null ? `${value}` : ''}
                        parser={(value) => {
                          const n = parseInt(String(value).replace(/\D/g, ''), 10);
                          if (isNaN(n)) return 10;
                          return Math.max(0, Math.min(100, n));
                        }}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </ConfigProvider>
                  </div>
                  <div className="space-y-1.5">
                    <label className={`text-[8px] font-black uppercase tracking-widest text-center block ${isDark ? 'text-slate-500' : 'text-slate-400'
                      }`}>Max Weightage %</label>
                    <ConfigProvider
                      theme={{
                        token: {
                          borderRadius: 12,
                          controlHeight: 40,
                          colorBgContainer: isDark ? '#000000' : '#ffffff',
                          colorBorder: isDark ? 'rgba(255, 255, 255, 0.05)' : '#e2e8f0',
                          colorText: isDark ? '#ffffff' : '#1e293b',
                          fontSize: 13,
                          fontFamily: 'inherit',
                          fontWeight: 900,
                        },
                      }}
                    >
                      <InputNumber
                        value={goalsSettings.maxWeightage}
                        onChange={(value) => updateSettings({ maxWeightage: value != null ? value : 100 })}
                        onBlur={(e) => {
                          const raw = goalsSettings.maxWeightage;
                          if (raw == null || isNaN(raw)) return;
                          const minW = goalsSettings.minWeightage ?? 10;
                          const normalized = Math.round(Number(raw) / 10) * 10;
                          const clamped = Math.max(minW, Math.min(100, normalized));
                          if (clamped !== goalsSettings.maxWeightage) {
                            updateSettings({ maxWeightage: clamped });
                          }
                        }}
                        min={goalsSettings.minWeightage ?? 10}
                        max={100}
                        step={10}
                        className="w-full text-center"
                        controls={false}
                        formatter={(value) => value != null ? `${value}` : ''}
                        parser={(value) => {
                          const n = parseInt(String(value).replace(/\D/g, ''), 10);
                          if (isNaN(n)) return 100;
                          return Math.max(0, Math.min(100, n));
                        }}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </ConfigProvider>
                  </div>
                </div>
                <p className={`text-[10px] leading-relaxed pt-1 ${isDark ? 'text-white/60' : 'text-slate-500'
                  }`}>
                  Per-goal weightage must be a multiple of 10. Sum of non-critical goals must equal 100%.
                </p>

                {/* Goal Requirements Explanation */}
                <div className="space-y-2 pt-2 border-t border-slate-100 dark:border-white/10">
                  <h4 className={`text-sm font-black ${isDark ? '!text-white' : 'text-slate-900'
                    }`}>
                    Goal Requirements:
                  </h4>
                  <p className={`text-xs leading-relaxed ${isDark ? 'text-white/80' : 'text-slate-600'
                    }`}>
                    You must add at least the minimum number of goals and no more than the maximum per cycle.
                  </p>
                  <p className={`text-xs leading-relaxed ${isDark ? 'text-white/80' : 'text-slate-600'
                    }`}>
                    Critical goals count toward the maximum. For example, if the maximum is {goalsSettings.maxGoals} and {goalsSettings.criticalRequired} critical goal{goalsSettings.criticalRequired !== 1 ? 's are' : ' is'} required, you must include at least {goalsSettings.criticalRequired} critical goal{goalsSettings.criticalRequired !== 1 ? 's' : ''}, and your total goals must be between the minimum and {goalsSettings.maxGoals}.
                  </p>
                </div>
              </div>
            </div>

            {/* Score From Achieved % */}
            <div className={`col-span-full p-6 rounded-[2rem] border space-y-5 shadow-xl ${isDark
              ? 'bg-[#0a0a0a] border-white/[0.05]'
              : 'bg-white border-slate-200'
              }`}>
              <div className="flex items-center gap-3 mb-2">
                <div className={`w-9 h-9 rounded-xl flex items-center justify-center border ${isDark
                  ? 'bg-blue-500/10 text-blue-500 border-blue-500/20'
                  : 'bg-blue-100 text-blue-600 border-blue-200'
                  }`}>
                  <BarChart3 size={18} />
                </div>
                <div className="flex flex-col">
                  <h3 className={`text-[13px] font-black uppercase tracking-wider ${isDark ? 'text-white' : 'text-slate-900'
                    }`}>
                    SCORE FROM ACHIEVED %
                  </h3>
                  <p className={`text-[10px] font-medium mt-0.5 ${isDark ? 'text-white/60' : 'text-slate-500'
                    }`}>
                    Edit ranges below. Manager review uses these to auto-fill score (1-10).
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-5 gap-4">
                {(goalsSettings.scoreRanges || [
                  { min: 0, max: 10, score: 1 },
                  { min: 11, max: 20, score: 2 },
                  { min: 21, max: 30, score: 3 },
                  { min: 31, max: 40, score: 4 },
                  { min: 41, max: 50, score: 5 },
                  { min: 51, max: 60, score: 6 },
                  { min: 61, max: 70, score: 7 },
                  { min: 71, max: 80, score: 8 },
                  { min: 81, max: 90, score: 9 },
                  { min: 91, max: 100, score: 10 }
                ]).map((range, idx) => (
                  <div
                    key={idx}
                    className={`p-4 rounded-2xl border transition-all ${isDark
                      ? 'bg-white/[0.02] border-white/[0.03] hover:bg-white/[0.04]'
                      : 'bg-white border-slate-100 hover:border-slate-200 shadow-sm'
                      }`}
                  >
                    <div className="flex flex-col items-center space-y-3">
                      {/* Range Label */}
                      <span className={`text-[10px] font-black uppercase tracking-wider ${isDark ? 'text-white' : 'text-slate-900'
                        }`}>
                        RANGE {idx + 1}
                      </span>

                      {/* Score Badge */}
                      <div className={`w-8 h-8 rounded-full flex items-center justify-center ${isDark
                        ? 'bg-blue-500/20 border border-blue-500/30'
                        : 'bg-blue-600 !text-white'
                        }`}>
                        <span className={`text-xs font-black ${isDark ? 'text-blue-400' : '!text-white'
                          }`}>
                          {range.score}
                        </span>
                      </div>

                      {/* Percentage Input Fields */}
                      <div className="flex items-center gap-2 w-full">
                        <ConfigProvider
                          theme={{
                            token: {
                              borderRadius: 8,
                              controlHeight: 36,
                              colorBgContainer: isDark ? '#000000' : '#ffffff',
                              colorBorder: isDark ? 'rgba(255, 255, 255, 0.1)' : '#e2e8f0',
                              colorText: isDark ? '#ffffff' : '#1e293b',
                              fontSize: 12,
                              fontFamily: 'inherit',
                              fontWeight: 700,
                            },
                          }}
                        >
                          <InputNumber
                            value={range.min}
                            onChange={(value) => updateScoreRange(idx, { min: value || 0 })}
                            min={0}
                            max={range.max}
                            className="flex-1"
                            controls={false}
                            formatter={(value) => `${value} %`}
                            parser={(value) => value.replace(/\s*%\s*/g, '').replace(/[^0-9.]/g, '')}
                            onKeyPress={(event) => {
                              if (!/[0-9.]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            style={{ textAlign: 'center' }}
                          />
                        </ConfigProvider>
                        <span className={`text-xs font-bold ${isDark ? 'text-white/40' : 'text-slate-400'
                          }`}>-</span>
                        <ConfigProvider
                          theme={{
                            token: {
                              borderRadius: 8,
                              controlHeight: 36,
                              colorBgContainer: isDark ? '#000000' : '#ffffff',
                              colorBorder: isDark ? 'rgba(255, 255, 255, 0.1)' : '#e2e8f0',
                              colorText: isDark ? '#ffffff' : '#1e293b',
                              fontSize: 12,
                              fontFamily: 'inherit',
                              fontWeight: 700,
                            },
                          }}
                        >
                          <InputNumber
                            value={range.max}
                            onChange={(value) => updateScoreRange(idx, { max: value || 100 })}
                            min={range.min}
                            max={100}
                            className="flex-1"
                            controls={false}
                            formatter={(value) => `${value} %`}
                            parser={(value) => value.replace(/\s*%\s*/g, '').replace(/[^0-9.]/g, '')}
                            onKeyPress={(event) => {
                              if (!/[0-9.]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            style={{ textAlign: 'center' }}
                          />
                        </ConfigProvider>
                      </div>

                      {/* Score Output Indicator */}
                      <div className="flex items-center gap-1.5">
                        <span className={`text-[10px] font-black ${isDark ? 'text-blue-400' : 'text-blue-600'
                          }`}>→</span>
                        <span className={`text-[10px] font-black uppercase ${isDark ? 'text-white/80' : 'text-slate-700'
                          }`}>
                          Score {range.score}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* Footer */}
              <div className={`pt-4 border-t ${isDark ? 'border-white/10' : 'border-slate-100'
                }`}>
                <p className={`text-[10px] font-medium text-center ${isDark ? 'text-white/60' : 'text-slate-500'
                  }`}>
                  Score is auto-filled in manager review from the range that contains the entered Achieved %.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 2: TIMING & SCHEDULE */}
        <div className="space-y-6 mt-12">
          <div className="flex items-center gap-2 px-1">
            <CalendarDays size={16} className={isDark ? 'text-blue-500' : 'text-blue-600'} />
            <h3 className={`text-[11px] font-black uppercase tracking-[0.25em] ${isDark ? 'text-slate-500' : 'text-slate-400'
              }`}>2. Timing & Schedule</h3>
          </div>

          {/* Allow overlapping windows toggle: ON = overlap allowed, OFF = sequential only (default, existing behaviour) */}
          <div className={`flex items-center justify-between gap-4 p-4 rounded-2xl border ${isDark ? 'bg-[#0a0a0a] border-white/[0.05]' : 'bg-white border-slate-200'}`}>
            <div className="flex items-center gap-2">
              <Layers size={18} className={isDark ? 'text-slate-400' : 'text-slate-500'} />
              <span className={`text-sm font-semibold ${isDark ? 'text-slate-200' : 'text-slate-700'}`}>Allow overlapping windows</span>
              <span className={`text-xs ${isDark ? 'text-slate-500' : 'text-slate-400'}`}>(Submission, Review, Evaluation can overlap)</span>
            </div>
            <Switch
              checked={goalsSettings.allowWindowOverlap === true}
              onChange={(checked) => updateSettings({ allowWindowOverlap: checked })}
              className={goalsSettings.allowWindowOverlap ? 'ant-switch-checked' : ''}
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {/* Submission Window */}
            <div className={`p-4 md:p-6 lg:p-7 rounded-2xl md:rounded-[2.5rem] border space-y-4 md:space-y-6 shadow-xl ${isDark
              ? 'bg-[#0a0a0a] border-white/[0.05]'
              : 'bg-white border-slate-200'
              }`}>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 rounded-2xl flex items-center justify-center border relative overflow-hidden group ${isDark
                    ? 'bg-indigo-500/10 text-indigo-400 border-indigo-500/20'
                    : 'bg-indigo-100 text-indigo-600 border-indigo-200'
                    }`}>
                    {goalsSettings.icons?.submissionIcon?.url ? (
                      <>
                        <img
                          src={goalsSettings.icons.submissionIcon.url}
                          alt="Submission Icon"
                          className="w-full h-full object-cover"
                        />
                        <button
                          onClick={() => removeIcon('submission')}
                          className="absolute inset-0 bg-black/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity z-10"
                          title="Remove Icon"
                        >
                          <X size={16} className="text-white" strokeWidth={3} />
                        </button>
                      </>
                    ) : (
                      <UserCheck size={20} />
                    )}
                  </div>
                  <p className={`text-xs md:text-sm lg:text-[14px] font-black uppercase tracking-wider ${isDark ? 'text-white' : 'text-slate-900'
                    }`}>Submission Window</p>
                </div>
                {/* <label className={`cursor-pointer w-8 h-8 rounded-lg flex items-center justify-center border transition-colors ${isDark
                  ? 'bg-white/5 border-white/10 hover:bg-white/10 text-white/60'
                  : 'bg-slate-50 border-slate-200 hover:bg-slate-100 text-slate-600'
                  }`}>
                  <ImagePlus size={16} />
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={async (e) => {
                      const file = e.target.files[0];
                      if (file) {
                        try {
                          await uploadIcon('submission', file);
                        } catch (error) {
                          console.error('Error uploading icon:', error);
                        }
                      }
                    }}
                  />
                </label> */}
              </div>
              <div className="grid grid-cols-2 gap-3 md:gap-4 lg:gap-5">
                <div className="space-y-2">
                  <label className={`text-[9px] font-black uppercase tracking-widest ml-1 ${isDark ? 'text-slate-500' : 'text-slate-400'
                    }`}>Start Day</label>
                  <div className="relative">
                    <ConfigProvider
                      theme={{
                        token: {
                          borderRadius: 16,
                          controlHeight: 48,
                          colorBgContainer: isDark ? '#000000' : '#ffffff',
                          colorBorder: isDark ? 'rgba(255, 255, 255, 0.05)' : '#e2e8f0',
                          colorText: isDark ? '#ffffff' : '#1e293b',
                          fontSize: 16,
                          fontFamily: 'inherit',
                          fontWeight: 900,
                        },
                      }}
                    >
                      <InputNumber
                        value={goalsSettings.submissionWindow.startDay}
                        onChange={(value) => updateSettings({
                          submissionWindow: {
                            ...goalsSettings.submissionWindow,
                            startDay: value
                          }
                        })}
                        onBlur={() => {
                          if (!goalsSettings.submissionWindow.startDay) {
                            updateSettings({
                              submissionWindow: {
                                ...goalsSettings.submissionWindow,
                                startDay: 1
                              }
                            });
                          }
                        }}
                        min={1}
                        max={31}
                        className="w-full text-center"
                        controls={false}
                        parser={(value) => value.replace(/\D/g, '')}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </ConfigProvider>
                    <span className={`absolute inset-y-0 right-4 flex items-center text-[9px] font-black uppercase pointer-events-none ${isDark ? 'text-slate-800' : 'text-slate-400'
                      }`}>Day</span>
                  </div>
                </div>
                <div className="space-y-2">
                  <label className={`text-[9px] font-black uppercase tracking-widest ml-1 ${isDark ? 'text-slate-500' : 'text-slate-400'
                    }`}>Duration</label>
                  <div className="relative">
                    <ConfigProvider
                      theme={{
                        token: {
                          borderRadius: 16,
                          controlHeight: 48,
                          colorBgContainer: isDark ? '#000000' : '#ffffff',
                          colorBorder: isDark ? 'rgba(255, 255, 255, 0.05)' : '#e2e8f0',
                          colorText: isDark ? '#ffffff' : '#1e293b',
                          fontSize: 16,
                          fontFamily: 'inherit',
                          fontWeight: 900,
                        },
                      }}
                    >
                      <InputNumber
                        value={goalsSettings.submissionWindow.duration}
                        onChange={(value) => updateSettings({
                          submissionWindow: {
                            ...goalsSettings.submissionWindow,
                            duration: value
                          }
                        })}
                        onBlur={() => {
                          if (!goalsSettings.submissionWindow.duration) {
                            updateSettings({
                              submissionWindow: {
                                ...goalsSettings.submissionWindow,
                                duration: 15
                              }
                            });
                          }
                        }}
                        min={1}
                        max={31}
                        className="w-full text-center"
                        controls={false}
                        parser={(value) => value.replace(/\D/g, '')}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </ConfigProvider>
                    <span className={`absolute inset-y-0 right-4 flex items-center text-[9px] font-black uppercase pointer-events-none ${isDark ? 'text-slate-800' : 'text-slate-400'
                      }`}>Days</span>
                  </div>
                </div>
              </div>
              <p className={`text-[8px] md:text-[9px] leading-relaxed italic ${isDark ? 'text-white/50' : 'text-slate-400'
                }`}>
                Applies every month. Set once; no need to change monthly.
              </p>
            </div>

            {/* Review Window */}
            <div className={`p-4 md:p-6 lg:p-7 rounded-2xl md:rounded-[2.5rem] border space-y-4 md:space-y-6 shadow-xl ${isDark
              ? 'bg-[#0a0a0a] border-white/[0.05]'
              : 'bg-white border-slate-200'
              }`}>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 rounded-2xl flex items-center justify-center border relative overflow-hidden group ${isDark
                    ? 'bg-[#c5a452]/10 text-[#c5a452] border-[#c5a452]/20'
                    : 'bg-amber-100 text-amber-600 border-amber-200'
                    }`}>
                    {goalsSettings.icons?.reviewIcon?.url ? (
                      <>
                        <img
                          src={goalsSettings.icons.reviewIcon.url}
                          alt="Review Icon"
                          className="w-full h-full object-cover"
                        />
                        <button
                          onClick={() => removeIcon('review')}
                          className="absolute inset-0 bg-black/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity z-10"
                          title="Remove Icon"
                        >
                          <X size={16} className="text-white" strokeWidth={3} />
                        </button>
                      </>
                    ) : (
                      <ShieldCheck size={20} />
                    )}
                  </div>
                  <p className={`text-xs md:text-sm lg:text-[14px] font-black uppercase tracking-wider ${isDark ? 'text-white' : 'text-slate-900'
                    }`}>Review Window</p>
                </div>
                {/* <label className={`cursor-pointer w-8 h-8 rounded-lg flex items-center justify-center border transition-colors ${isDark
                  ? 'bg-white/5 border-white/10 hover:bg-white/10 text-white/60'
                  : 'bg-slate-50 border-slate-200 hover:bg-slate-100 text-slate-600'
                  }`}>
                  <ImagePlus size={16} />
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={async (e) => {
                      const file = e.target.files[0];
                      if (file) {
                        try {
                          await uploadIcon('review', file);
                        } catch (error) {
                          console.error('Error uploading icon:', error);
                        }
                      }
                    }}
                  />
                </label> */}
              </div>
              <div className="grid grid-cols-2 gap-3 md:gap-4 lg:gap-5">
                <div className="space-y-2">
                  <label className={`text-[9px] font-black uppercase tracking-widest ml-1 ${isDark ? 'text-slate-500' : 'text-slate-400'
                    }`}>Start Day</label>
                  <div className="relative">
                    <ConfigProvider
                      theme={{
                        token: {
                          borderRadius: 16,
                          controlHeight: 48,
                          colorBgContainer: isDark ? '#000000' : '#ffffff',
                          colorBorder: isDark ? 'rgba(255, 255, 255, 0.05)' : '#e2e8f0',
                          colorText: isDark ? '#ffffff' : '#1e293b',
                          fontSize: 16,
                          fontFamily: 'inherit',
                          fontWeight: 900,
                        },
                      }}
                    >
                      <InputNumber
                        value={goalsSettings.reviewWindow.startDay}
                        onChange={(value) => updateSettings({
                          reviewWindow: {
                            ...goalsSettings.reviewWindow,
                            startDay: value
                          }
                        })}
                        onBlur={() => {
                          if (!goalsSettings.reviewWindow.startDay) {
                            updateSettings({
                              reviewWindow: {
                                ...goalsSettings.reviewWindow,
                                startDay: 16
                              }
                            });
                          }
                        }}
                        min={1}
                        max={31}
                        className="w-full text-center"
                        controls={false}
                        parser={(value) => value.replace(/\D/g, '')}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </ConfigProvider>
                    <span className={`absolute inset-y-0 right-4 flex items-center text-[9px] font-black uppercase pointer-events-none ${isDark ? 'text-slate-800' : 'text-slate-400'
                      }`}>Day</span>
                  </div>
                </div>
                <div className="space-y-2">
                  <label className={`text-[9px] font-black uppercase tracking-widest ml-1 ${isDark ? 'text-slate-500' : 'text-slate-400'
                    }`}>Duration</label>
                  <div className="relative">
                    <ConfigProvider
                      theme={{
                        token: {
                          borderRadius: 16,
                          controlHeight: 48,
                          colorBgContainer: isDark ? '#000000' : '#ffffff',
                          colorBorder: isDark ? 'rgba(255, 255, 255, 0.05)' : '#e2e8f0',
                          colorText: isDark ? '#ffffff' : '#1e293b',
                          fontSize: 16,
                          fontFamily: 'inherit',
                          fontWeight: 900,
                        },
                      }}
                    >
                      <InputNumber
                        value={goalsSettings.reviewWindow.duration}
                        onChange={(value) => updateSettings({
                          reviewWindow: {
                            ...goalsSettings.reviewWindow,
                            duration: value
                          }
                        })}
                        onBlur={() => {
                          if (!goalsSettings.reviewWindow.duration) {
                            updateSettings({
                              reviewWindow: {
                                ...goalsSettings.reviewWindow,
                                duration: 14
                              }
                            });
                          }
                        }}
                        min={1}
                        max={31}
                        className="w-full text-center"
                        controls={false}
                        parser={(value) => value.replace(/\D/g, '')}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </ConfigProvider>
                    <span className={`absolute inset-y-0 right-4 flex items-center text-[9px] font-black uppercase pointer-events-none ${isDark ? 'text-slate-800' : 'text-slate-400'
                      }`}>Days</span>
                  </div>
                </div>
              </div>
              <p className={`text-[8px] md:text-[9px] leading-relaxed italic ${isDark ? 'text-white/50' : 'text-slate-400'
                }`}>
                Applies every month. Set once; no need to change monthly.
              </p>
            </div>

            {/* Evaluation Window */}
            <div className={`p-4 md:p-6 lg:p-7 rounded-2xl md:rounded-[2.5rem] border space-y-4 md:space-y-6 shadow-xl ${isDark
              ? 'bg-[#0a0a0a] border-white/[0.05]'
              : 'bg-white border-slate-200'
              }`}>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 rounded-2xl flex items-center justify-center border relative overflow-hidden group ${isDark
                    ? 'bg-green-500/10 text-green-400 border-green-500/20'
                    : 'bg-green-100 text-green-600 border-green-200'
                    }`}>
                    {goalsSettings.icons?.evaluationIcon?.url ? (
                      <>
                        <img
                          src={goalsSettings.icons.evaluationIcon.url}
                          alt="Evaluation Icon"
                          className="w-full h-full object-cover"
                        />
                        <button
                          onClick={() => removeIcon('evaluation')}
                          className="absolute inset-0 bg-black/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity z-10"
                          title="Remove Icon"
                        >
                          <X size={16} className="text-white" strokeWidth={3} />
                        </button>
                      </>
                    ) : (
                      <Trophy size={20} />
                    )}
                  </div>
                  <p className={`text-xs md:text-sm lg:text-[14px] font-black uppercase tracking-wider ${isDark ? 'text-white' : 'text-slate-900'
                    }`}>Goal Evaluation Period</p>
                </div>
                {/* <label className={`cursor-pointer w-8 h-8 rounded-lg flex items-center justify-center border transition-colors ${isDark
                  ? 'bg-white/5 border-white/10 hover:bg-white/10 text-white/60'
                  : 'bg-slate-50 border-slate-200 hover:bg-slate-100 text-slate-600'
                  }`}>
                  <ImagePlus size={16} />
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    onChange={async (e) => {
                      const file = e.target.files[0];
                      if (file) {
                        try {
                          await uploadIcon('evaluation', file);
                        } catch (error) {
                          console.error('Error uploading icon:', error);
                        }
                      }
                    }}
                  />
                </label> */}
              </div>
              <div className="grid grid-cols-2 gap-3 md:gap-4 lg:gap-5">
                <div className="space-y-2">
                  <label className={`text-[9px] font-black uppercase tracking-widest ml-1 ${isDark ? 'text-slate-500' : 'text-slate-400'
                    }`}>Start Day</label>
                  <div className="relative">
                    <ConfigProvider
                      theme={{
                        token: {
                          borderRadius: 16,
                          controlHeight: 48,
                          colorBgContainer: isDark ? '#000000' : '#ffffff',
                          colorBorder: isDark ? 'rgba(255, 255, 255, 0.05)' : '#e2e8f0',
                          colorText: isDark ? '#ffffff' : '#1e293b',
                          fontSize: 16,
                          fontFamily: 'inherit',
                          fontWeight: 900,
                        },
                      }}
                    >
                      <InputNumber
                        value={goalsSettings.evaluationWindow?.startDay}
                        onChange={(value) => updateSettings({
                          evaluationWindow: {
                            ...(goalsSettings.evaluationWindow || { startDay: 1, duration: 30 }),
                            startDay: value
                          }
                        })}
                        onBlur={() => {
                          if (!goalsSettings.evaluationWindow?.startDay) {
                            updateSettings({
                              evaluationWindow: {
                                ...(goalsSettings.evaluationWindow || { startDay: 1, duration: 30 }),
                                startDay: 1
                              }
                            });
                          }
                        }}
                        min={1}
                        max={31}
                        className="w-full text-center"
                        controls={false}
                        parser={(value) => value.replace(/\D/g, '')}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </ConfigProvider>
                    <span className={`absolute inset-y-0 right-4 flex items-center text-[9px] font-black uppercase pointer-events-none ${isDark ? 'text-slate-800' : 'text-slate-400'
                      }`}>Day</span>
                  </div>
                </div>
                <div className="space-y-2">
                  <label className={`text-[9px] font-black uppercase tracking-widest ml-1 ${isDark ? 'text-slate-500' : 'text-slate-400'
                    }`}>Duration</label>
                  <div className="relative">
                    <ConfigProvider
                      theme={{
                        token: {
                          borderRadius: 16,
                          controlHeight: 48,
                          colorBgContainer: isDark ? '#000000' : '#ffffff',
                          colorBorder: isDark ? 'rgba(255, 255, 255, 0.05)' : '#e2e8f0',
                          colorText: isDark ? '#ffffff' : '#1e293b',
                          fontSize: 16,
                          fontFamily: 'inherit',
                          fontWeight: 900,
                        },
                      }}
                    >
                      <InputNumber
                        value={goalsSettings.evaluationWindow?.duration}
                        onChange={(value) => updateSettings({
                          evaluationWindow: {
                            ...(goalsSettings.evaluationWindow || { startDay: 1, duration: 30 }),
                            duration: value
                          }
                        })}
                        onBlur={() => {
                          if (!goalsSettings.evaluationWindow?.duration) {
                            updateSettings({
                              evaluationWindow: {
                                ...(goalsSettings.evaluationWindow || { startDay: 1, duration: 30 }),
                                duration: 30
                              }
                            });
                          }
                        }}
                        min={1}
                        max={45}
                        className="w-full text-center"
                        controls={false}
                        parser={(value) => value.replace(/\D/g, '')}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </ConfigProvider>
                    <span className={`absolute inset-y-0 right-4 flex items-center text-[9px] font-black uppercase pointer-events-none ${isDark ? 'text-slate-800' : 'text-slate-400'
                      }`}>Days</span>
                  </div>
                </div>
              </div>
              <p className={`text-[8px] md:text-[9px] leading-relaxed italic ${isDark ? 'text-white/50' : 'text-slate-400'
                }`}>
                Applies every month. Duration can extend into next month (e.g. Day 30 + 5 days = 30th to 4th of next month).
              </p>
            </div>
          </div>
        </div>

        {/* SECTION 3: PERFORMANCE WORKFLOW */}
        <div className="space-y-6 mt-12 min-w-0">
          <div className="flex items-center gap-2 px-1">
            <Sparkles size={16} className={isDark ? 'text-blue-500' : 'text-blue-600'} />
            <h3 className={`text-[11px] font-black uppercase tracking-[0.25em] ${isDark ? 'text-slate-500' : 'text-slate-400'
              }`}>3. Performance Workflow</h3>
          </div>

          <div className="space-y-6 min-w-0">
            <div className={`p-4 rounded-[2.5rem] border shadow-xl overflow-visible ${isDark
              ? 'bg-[#0a0a0a] border-white/[0.05]'
              : 'bg-white border-slate-200'
              }`}>
              <SettingItem
                icon={Workflow}
                title="Soft Skills Evaluation & Competencies"
                description="Include behavioral metrics in performance scorecards"
                enabled={goalsSettings.softSkillsEnabled}
                onToggle={(checked) => updateSettings({ softSkillsEnabled: checked })}
              />

              <div className={`p-8 pt-4 border-t grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 min-w-0 max-w-full ${isDark ? 'border-white/[0.05]' : 'border-slate-200'
                }`}>
                {goalsSettings.softSkills.map((skill) => (
                  <div key={skill.id} className="space-y-4 min-w-0 max-w-full relative group">
                    <button
                      onClick={() => removeSoftSkill(skill.id)}
                      className={`absolute -top-2 -right-2 w-6 h-6 rounded-full border flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity z-10 ${isDark
                        ? 'bg-red-500/20 border-red-500/30 text-red-400 hover:bg-red-500/30'
                        : 'bg-red-50 border-red-200 text-red-600 hover:bg-red-100'
                        }`}
                      title="Remove metric"
                    >
                      <X size={12} strokeWidth={3} />
                    </button>
                    <div className="space-y-1.5">
                      <label className={`text-[9px] font-black uppercase tracking-widest ml-1 ${isDark ? 'text-slate-600' : 'text-slate-400'
                        }`}>Metric Title</label>
                      <input
                        type="text"
                        value={skill.label}
                        onChange={(e) => updateSoftSkill(skill.id, { label: e.target.value })}
                        className={`w-full border rounded-xl px-4 py-2.5 text-xs font-bold focus:outline-none focus:ring-1 ${isDark
                          ? 'bg-black border-white/5 text-white focus:ring-blue-500/30'
                          : 'bg-white border-slate-200 text-slate-900 focus:ring-blue-500/30'
                          }`}
                      />
                    </div>
                    <div className="space-y-1.5">
                      <label className={`text-[9px] font-black uppercase tracking-widest ml-1 ${isDark ? 'text-slate-600' : 'text-slate-400'
                        }`}>Definition Subtext</label>
                      <textarea
                        value={skill.desc}
                        onChange={(e) => updateSoftSkill(skill.id, { desc: e.target.value })}
                        rows={2}
                        className={`w-full border rounded-xl px-4 py-2.5 text-[10px] font-medium focus:outline-none resize-none ${isDark
                          ? 'bg-black border-white/5 text-slate-500'
                          : 'bg-white border-slate-200 text-slate-500'
                          }`}
                      />
                    </div>
                  </div>
                ))}

                {/* ADD NEW METRIC Button */}
                <button
                  onClick={addSoftSkill}
                  className={`min-h-[120px] border-2 border-dashed rounded-xl flex flex-col items-center justify-center gap-2 transition-all ${isDark
                    ? 'border-white/10 bg-white/5 hover:border-blue-500/30 hover:bg-blue-500/10 text-white/60 hover:text-blue-400'
                    : 'border-slate-300 bg-slate-50 hover:border-blue-400 hover:bg-blue-50/50 text-slate-400 hover:text-blue-600'
                    }`}
                >
                  <Plus size={24} strokeWidth={2.5} />
                  <span className="text-[10px] font-black uppercase tracking-widest">
                    ADD NEW METRIC
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* SECTION 4: RECOGNITION & ENGAGEMENT */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 lg:gap-10 mt-8 md:mt-12 min-w-0 w-full max-w-full">
          {/* Gamification Column */}
          <div className="space-y-6 min-w-0 w-full max-w-full">
            <div className="flex items-center gap-2 px-1">
              <Trophy size={16} className={isDark ? 'text-blue-500' : 'text-blue-600'} />
              <h3 className={`text-[11px] font-black uppercase tracking-[0.25em] ${isDark ? 'text-slate-500' : 'text-slate-400'
                }`}>4. Recognition Rules</h3>
            </div>

            <div className="space-y-4 w-full max-w-full">
              {/* Badge Definition */}
              <div className={`p-4 md:p-6 rounded-xl md:rounded-[2.25rem] border space-y-4 md:space-y-5 shadow-xl w-full max-w-full ${isDark
                ? 'bg-[#0a0a0a] border-white/[0.05]'
                : 'bg-white border-slate-200'
                }`}>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className={`w-8 h-8 rounded-xl flex items-center justify-center border ${isDark
                      ? 'bg-indigo-500/10 text-indigo-400 border-indigo-500/20'
                      : 'bg-indigo-100 text-indigo-600 border-indigo-200'
                      }`}>
                      <Medal size={16} />
                    </div>
                    <p className={`text-[13px] font-black uppercase tracking-wider ${isDark ? 'text-white' : 'text-slate-900'
                      }`}>Badge Ranges</p>
                  </div>
                  <button className={`text-[10px] font-black uppercase tracking-widest transition-colors ${isDark
                    ? 'text-blue-500 hover:text-blue-400'
                    : 'text-blue-600 hover:text-blue-700'
                    }`}>
                    Manage Icons
                  </button>
                </div>

                <div className="space-y-3">
                  {goalsSettings.badgeRanges.map((range, index) => (
                    <div key={index} className={`flex items-center justify-between gap-4 p-3 rounded-2xl border ${isDark
                      ? 'bg-white/[0.02] border-white/[0.03]'
                      : 'bg-slate-50 border-slate-100'
                      }`}>
                      <div className="flex items-center gap-3">
                        <div className={`w-6 h-6 rounded-lg flex items-center justify-center border relative overflow-hidden group ${isDark
                          ? 'bg-white/5 border-white/10 text-slate-700 hover:bg-white/10'
                          : 'bg-slate-100 border-slate-200 text-slate-400 hover:bg-slate-200'
                          }`}>
                          {range.icon?.url ? (
                            <>
                              <img
                                src={range.icon.url}
                                alt={range.label}
                                className="w-full h-full object-cover"
                              />
                              <button
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  removeBadgeIcon(index);
                                }}
                                className="absolute inset-0 bg-black/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity z-10"
                                title="Remove Icon"
                              >
                                <X size={10} className="text-white" strokeWidth={3} />
                              </button>
                            </>
                          ) : (
                            <label className="cursor-pointer">
                              <ImagePlus size={12} />
                              <input
                                type="file"
                                accept="image/*"
                                className="hidden"
                                onChange={async (e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    // Validate file type
                                    if (!file.type.startsWith('image/')) {
                                      toast.error('Please upload an image file only', { id: 'badge-icon-upload' });
                                      return;
                                    }

                                    // Validate file size (max 5MB)
                                    if (file.size > 5 * 1024 * 1024) {
                                      toast.error('File size must be less than 5MB', { id: 'badge-icon-upload' });
                                      return;
                                    }

                                    try {
                                      await uploadBadgeIcon(index, file);
                                    } catch (error) {
                                      console.error('Error uploading badge icon:', error);
                                    }
                                  }
                                }}
                              />
                            </label>
                          )}
                        </div>
                        <label className={`text-[10px] font-black uppercase tracking-widest ${isDark ? 'text-slate-400' : 'text-slate-500'
                          }`}>{range.label}</label>
                      </div>
                      <div className="flex items-center gap-2">
                        {range.lessThan ? (
                          <span className={`text-[9px] font-black ${isDark ? 'text-slate-700' : 'text-slate-400'
                            }`}>LT</span>
                        ) : (
                          <>
                            <ConfigProvider
                              theme={{
                                token: {
                                  borderRadius: 8,
                                  controlHeight: 24,
                                  colorBgContainer: isDark ? '#000000' : '#ffffff',
                                  colorBorder: isDark ? 'rgba(255, 255, 255, 0.05)' : '#e2e8f0',
                                  colorText: isDark ? '#ffffff' : '#1e293b',
                                  fontSize: 10,
                                  fontFamily: 'inherit',
                                  fontWeight: 900,
                                },
                              }}
                            >
                              <InputNumber
                                value={range.min}
                                onChange={(value) => updateBadgeRange(index, { min: value || 0 })}
                                step={0.1}
                                min={0}
                                max={10}
                                className="w-12 text-center"
                                controls={false}
                                parser={(value) => value.replace(/[^0-9.]/g, '')}
                                onKeyPress={(event) => {
                                  if (!/[0-9.]/.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                            </ConfigProvider>
                            <span className={`text-[8px] font-black ${isDark ? 'text-slate-800' : 'text-slate-400'
                              }`}>TO</span>
                          </>
                        )}
                        <ConfigProvider
                          theme={{
                            token: {
                              borderRadius: 8,
                              controlHeight: 24,
                              colorBgContainer: isDark ? '#000000' : '#ffffff',
                              colorBorder: isDark ? 'rgba(255, 255, 255, 0.05)' : '#e2e8f0',
                              colorText: isDark ? '#ffffff' : '#1e293b',
                              fontSize: 10,
                              fontFamily: 'inherit',
                              fontWeight: 900,
                            },
                          }}
                        >
                          <InputNumber
                            value={range.max}
                            onChange={(value) => updateBadgeRange(index, { max: value || 10 })}
                            step={0.1}
                            min={0}
                            max={10}
                            className="w-12 text-center"
                            controls={false}
                            parser={(value) => value.replace(/[^0-9.]/g, '')}
                            onKeyPress={(event) => {
                              if (!/[0-9.]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                          />
                        </ConfigProvider>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Streak Rule */}
              <div className={`p-6 rounded-[2.25rem] border space-y-4 shadow-xl w-full max-w-full ${isDark
                ? 'bg-[#0a0a0a] border-white/[0.05]'
                : 'bg-white border-slate-200'
                }`}>
                <div className="flex items-center gap-3">
                  <div className={`w-8 h-8 rounded-xl flex items-center justify-center border ${isDark
                    ? 'bg-orange-500/10 text-orange-400 border-orange-500/20'
                    : 'bg-orange-100 text-orange-600 border-orange-200'
                    }`}>
                    <Flame size={16} />
                  </div>
                  <p className={`text-[13px] font-black uppercase tracking-wider ${isDark ? 'text-white' : 'text-slate-900'
                    }`}>Streak Points</p>
                </div>
                <div className="flex items-center gap-4">
                  <div className={`w-10 h-10 rounded-2xl flex items-center justify-center border transition-colors relative overflow-hidden group ${isDark
                    ? 'bg-white/5 border-white/10 text-slate-600 hover:text-white'
                    : 'bg-slate-100 border-slate-200 text-slate-400 hover:text-slate-600'
                    }`}>
                    {goalsSettings.streakPoints?.icon?.url ? (
                      <>
                        <img
                          src={goalsSettings.streakPoints.icon.url}
                          alt="Streak Icon"
                          className="w-full h-full object-cover"
                        />
                        <button
                          onClick={() => removeStreakIcon()}
                          className="absolute inset-0 bg-black/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity z-10"
                          title="Remove Icon"
                        >
                          <X size={16} className="text-white" strokeWidth={3} />
                        </button>
                      </>
                    ) : (
                      <label className="cursor-pointer">
                        <ImagePlus size={18} />
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (file) {
                              // Validate file type
                              if (!file.type.startsWith('image/')) {
                                toast.error('Please upload an image file only', { id: 'streak-icon-upload' });
                                return;
                              }

                              // Validate file size (max 5MB)
                              if (file.size > 5 * 1024 * 1024) {
                                toast.error('File size must be less than 5MB', { id: 'streak-icon-upload' });
                                return;
                              }

                              try {
                                await uploadStreakIcon(file);
                              } catch (error) {
                                console.error('Error uploading streak icon:', error);
                              }
                            }
                          }}
                        />
                      </label>
                    )}
                  </div>
                  <div className={`flex-1 flex items-center gap-3 p-3 rounded-2xl border ${isDark
                    ? 'bg-black border-white/[0.05]'
                    : 'bg-slate-50 border-slate-200'
                    }`}>
                    <ConfigProvider
                      theme={{
                        token: {
                          borderRadius: 0,
                          controlHeight: 40,
                          colorBgContainer: 'transparent',
                          colorBorder: 'transparent',
                          colorText: isDark ? '#ffffff' : '#1e293b',
                          fontSize: 14,
                          fontFamily: 'inherit',
                          fontWeight: 900,
                        },
                      }}
                    >
                      <InputNumber
                        value={goalsSettings.streakPoints.months}
                        onChange={(value) => updateSettings({
                          streakPoints: {
                            ...goalsSettings.streakPoints,
                            months: value || 1
                          }
                        })}
                        min={1}
                        className="w-10 text-center"
                        controls={false}
                        parser={(value) => value.replace(/\D/g, '')}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </ConfigProvider>
                    <span className={`text-[9px] font-black uppercase tracking-widest ${isDark ? 'text-slate-600' : 'text-slate-400'
                      }`}>Mo =</span>
                    <ConfigProvider
                      theme={{
                        token: {
                          borderRadius: 0,
                          controlHeight: 40,
                          colorBgContainer: 'transparent',
                          colorBorder: 'transparent',
                          colorText: isDark ? '#ffffff' : '#1e293b',
                          fontSize: 14,
                          fontFamily: 'inherit',
                          fontWeight: 900,
                        },
                      }}
                    >
                      <InputNumber
                        value={goalsSettings.streakPoints.points}
                        onChange={(value) => updateSettings({
                          streakPoints: {
                            ...goalsSettings.streakPoints,
                            points: value || 1
                          }
                        })}
                        min={1}
                        className="w-10 text-center"
                        controls={false}
                        parser={(value) => value.replace(/\D/g, '')}
                        onKeyPress={(event) => {
                          if (!/[0-9]/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                      />
                    </ConfigProvider>
                    <span className={`text-[9px] font-black uppercase tracking-widest ${isDark ? 'text-slate-600' : 'text-slate-400'
                      }`}>Pt</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Notifications Column */}
          <div className="space-y-6 min-w-0 w-full max-w-full">
            <div className="flex items-center gap-2 px-1">
              <Bell size={16} className={isDark ? 'text-blue-500' : 'text-blue-600'} />
              <h3 className={`text-[11px] font-black uppercase tracking-[0.25em] ${isDark ? 'text-slate-500' : 'text-slate-400'
                }`}>5. Engagement Alerts</h3>
            </div>

            <div className={`p-4 rounded-[2.5rem] border shadow-xl overflow-visible w-full max-w-full ${isDark
              ? 'bg-[#0a0a0a] border-white/[0.05]'
              : 'bg-white border-slate-200'
              }`}>
              <div className="space-y-1">
                <SettingItem
                  icon={TargetIcon}
                  title="Goal Deadlines"
                  description="Alert employees before submission ends"
                  enabled={goalsSettings.goalDeadlinesAlert}
                  onToggle={(checked) => updateSettings({ goalDeadlinesAlert: checked })}
                />
                <SettingItem
                  icon={ShieldCheck}
                  title="Review Reminders"
                  description="Alert managers for pending reviews"
                  enabled={goalsSettings.reviewRemindersAlert}
                  onToggle={(checked) => updateSettings({ reviewRemindersAlert: checked })}
                />
                <SettingItem
                  icon={Award}
                  title="Badge Milestones"
                  description="Congratulate users on rank upgrades"
                  enabled={goalsSettings.badgeMilestonesAlert}
                  onToggle={(checked) => updateSettings({ badgeMilestonesAlert: checked })}
                />
              </div>

              <div className={`p-8 pt-6 border-t space-y-4 ${isDark
                ? 'bg-white/[0.01] border-white/[0.05]'
                : 'bg-slate-50 border-slate-200'
                }`}>
                <div className="flex items-center gap-3">
                  <div className={`w-8 h-8 rounded-xl flex items-center justify-center border ${isDark
                    ? 'bg-indigo-500/10 text-indigo-400 border-indigo-500/20'
                    : 'bg-indigo-100 text-indigo-600 border-indigo-200'
                    }`}>
                    <Clock size={16} />
                  </div>
                  <p className={`text-[12px] font-black uppercase tracking-widest ${isDark ? 'text-white' : 'text-slate-900'
                    }`}>Lead Time Configuration</p>
                </div>
                <div className={`flex items-center gap-4 p-4 rounded-2xl border transition-colors ${isDark
                  ? 'bg-black border-white/[0.05] hover:border-indigo-500/20'
                  : 'bg-white border-slate-200 hover:border-indigo-300'
                  }`}>
                  <ConfigProvider
                    theme={{
                      token: {
                        borderRadius: 12,
                        controlHeight: 48,
                        colorBgContainer: isDark ? 'rgba(255, 255, 255, 0.05)' : '#ffffff',
                        colorBorder: isDark ? 'rgba(255, 255, 255, 0.1)' : '#e2e8f0',
                        colorText: isDark ? '#ffffff' : '#1e293b',
                        fontSize: 14,
                        fontFamily: 'inherit',
                        fontWeight: 900,
                      },
                    }}
                  >
                    <InputNumber
                      value={goalsSettings.reminderLeadTime}
                      onChange={(value) => updateSettings({ reminderLeadTime: value || 3 })}
                      min={1}
                      max={30}
                      className="w-14 text-center"
                      controls={false}
                      parser={(value) => value.replace(/\D/g, '')}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                  </ConfigProvider>
                  <div className="flex flex-col">
                    <span className={`text-[11px] font-black uppercase tracking-widest ${isDark ? 'text-slate-100' : 'text-slate-700'
                      }`}>REMINDER LEAD TIME</span>
                    <span className={`text-[9px] font-bold uppercase tracking-tight ${isDark ? 'text-slate-600' : 'text-slate-400'
                      }`}>DAYS BEFORE DEADLINE EXPIRY</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* FOOTER ACTION */}
        <div className={`mt-8 md:mt-12 p-4 md:p-6 lg:p-8 border rounded-2xl md:rounded-[3rem] flex flex-col md:flex-row items-center justify-between gap-4 md:gap-6 ${isDark
          ? 'bg-blue-600/5 border-blue-500/10'
          : 'bg-blue-50 border-blue-200'
          }`}>
          <div className="flex items-center gap-5 text-left">
            <div className={`w-12 h-12 rounded-2xl flex items-center justify-center shadow-sm border ${isDark
              ? 'bg-blue-500/10 text-blue-500 border-blue-500/20'
              : 'bg-blue-100 text-blue-600 border-blue-200'
              }`}>
              <Info size={24} />
            </div>
            <div>
              <p className={`text-sm font-bold ${isDark ? 'text-white' : 'text-slate-900'
                }`}>Global Policy Update</p>
              <p className={`text-[11px] font-black uppercase tracking-widest leading-relaxed max-w-md ${isDark ? 'text-slate-500' : 'text-slate-600'
                }`}>Applying changes will instantly update cycle schedules and module access for all organization users.</p>
            </div>
          </div>
          <button
            onClick={handleSave}
            disabled={savingGoalsSettings}
            className={`bg-blue-600 hover:bg-blue-500 !text-white px-10 py-4 rounded-2xl text-[12px] font-black uppercase tracking-[0.15em] flex items-center gap-3 transition-all duration-300 active:scale-95 shadow-[0_20px_40px_-15px_rgba(37,99,235,0.4)] ${savingGoalsSettings ? 'opacity-50 cursor-not-allowed' : ''
              }`}
          >
            <Save size={18} strokeWidth={2.5} />
            {savingGoalsSettings ? 'Saving...' : 'Save Goal Policy'}
          </button>
        </div>
      </div>
    );
  };

  const renderContent = () => {
    switch (activeSection) {
      case 'organization':
        return renderOrganizationProfile();
      case 'security':
        return renderSecurityLogin();
      case 'team':
        return renderTeamStructure();
      case 'billing':
        return renderBilling();
      case 'goals_settings':
        return isS5Organisation(user) ? renderGoalsSettings() : renderOrganizationProfile();
      default:
        return renderOrganizationProfile();
    }
  };

  // Plan Selection Modal
  const renderPlanModal = () => {
    if (!showPlanModal) return null;

    const plans = [
      {
        name: 'Startup',
        price: { month: 3, year: 36 },
        description: 'Perfect for small teams getting started',
        features: [
          'Up to 10 team members',
          'Basic AI insights',
          'Email support',
          'Basic analytics dashboard',
          'Mobile app access'
        ]
      },
      {
        name: 'Growth',
        price: { month: 5, year: 60 },
        description: 'Ideal for growing teams',
        features: [
          'Up to 10 team members',
          'Basic AI insights',
          'Email support',
          'Basic analytics dashboard',
          'Mobile app access'
        ]
      },
      {
        name: 'Enterprise',
        price: { month: 7, year: 84 },
        description: 'For large organizations',
        features: [
          'Up to 10 team members',
          'Basic AI insights',
          'Email support',
          'Basic analytics dashboard',
          'Mobile app access'
        ]
      }
    ];

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-gray-900 border border-white/10 rounded-lg p-6 max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-semibold text-white">Select a Plan</h2>
            <button
              onClick={() => setShowPlanModal(false)}
              className="text-gray-400 hover:text-white"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          {/* Info for cancelled subscriptions */}
          {billing.cancelAtPeriodEnd && (
            <div className="mb-6 p-4 bg-blue-600/20 border border-blue-600/30 rounded-md">
              <div className="flex items-center space-x-2">
                <span className="text-blue-400">ℹ️</span>
                <span className="text-blue-300 text-sm">
                  Your subscription is set to cancel on {billing.nextBilling.date}.
                  You can still change your plan or resume your subscription.
                </span>
              </div>
            </div>
          )}

          {/* Billing Interval Toggle */}
          <div className="flex items-center justify-center mb-6">
            <div className="bg-white/5 border border-white/10 rounded-lg p-1">
              {BILLING_INTERVALS.map((opt) => (
                <button
                  key={opt.key}
                  onClick={() => setBillingInterval(opt.key)}
                  className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${billingInterval === opt.key
                    ? 'bg-blue-600 !text-white'
                    : 'text-gray-400 hover:text-white'
                    }`}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>

          {/* Plans Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            {plans.map((plan) => (
              <div
                key={plan.name}
                className={`p-6 border rounded-lg cursor-pointer transition-colors ${selectedPlan?.name === plan.name
                  ? 'border-blue-500 bg-blue-500/10'
                  : 'border-white/10 bg-white/5 hover:border-white/20'
                  }`}
                onClick={() => {
                  setSelectedPlan(plan);
                  setPlanConfirmed(false); // Reset confirmation when new plan is selected
                }}
              >
                <div className="text-center mb-4">
                  <h3 className="text-lg font-semibold text-white mb-2">{plan.name}</h3>
                  <div className="text-3xl font-bold text-white mb-1">
                    ${plan.price.month * getIntervalMonths(billingInterval)}
                  </div>
                  <div className="text-sm text-gray-400">
                    /{billingInterval === 'monthly' ? 'month' : `${getIntervalMonths(billingInterval)} months`}
                  </div>
                  <p className="text-sm text-gray-400 mt-2">{plan.description}</p>
                </div>

                <ul className="space-y-2 mb-6">
                  {plan.features.map((feature, index) => (
                    <li key={index} className="flex items-center text-sm text-gray-300">
                      <Check className="h-4 w-4 text-green-400 mr-2 flex-shrink-0" />
                      {feature}
                    </li>
                  ))}
                </ul>

                <button
                  className={`w-full py-2 px-4 rounded-md font-medium transition-colors ${selectedPlan?.name === plan.name
                    ? 'bg-blue-600 !text-white'
                    : 'bg-white/10 text-white hover:bg-white/20'
                    }`}
                >
                  {selectedPlan?.name === plan.name ? 'Selected' : 'Choose Plan'}
                </button>
              </div>
            ))}
          </div>

          {/* Payment Method Warning */}
          {(!billing.paymentMethods || billing.paymentMethods.length === 0) && (
            <div className="mt-4 p-3 bg-yellow-600/20 border border-yellow-600/30 rounded-md">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-2">
                  <span className="text-yellow-400">⚠️</span>
                  <span className="text-yellow-300 text-sm">
                    Payment method required to start a plan.
                  </span>
                </div>
                <button
                  onClick={() => {
                    setShowPlanModal(false);
                    setTimeout(() => {
                      handleAddPaymentMethod();
                    }, 100);
                  }}
                  className="px-3 py-1 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 text-sm"
                >
                  Add Card Now
                </button>
              </div>
            </div>
          )}

          {/* Action Buttons */}
          <div className="flex justify-end space-x-3">
            <button
              onClick={() => {
                setShowPlanModal(false);
                setSelectedPlan(null);
                setPlanConfirmed(false);
              }}
              className="px-4 py-2 text-gray-400 hover:text-white"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                if (selectedPlan) {
                  setPlanConfirmed(true);
                  toast.success(`${selectedPlan.name} plan confirmed! Click "Buy Plan" to proceed.`);
                }
              }}
              disabled={!selectedPlan || planConfirmed}
              className={`px-6 py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed ${!selectedPlan
                ? 'bg-gray-600 text-gray-300 cursor-not-allowed'
                : planConfirmed
                  ? 'bg-green-600 text-white'
                  : 'bg-green-600 text-white hover:bg-green-700'
                }`}
            >
              {planConfirmed ? `${selectedPlan?.name} Confirmed` : (selectedPlan ? `Confirm ${selectedPlan.name}` : 'Select Plan')}
            </button>
            <button
              onClick={handleCreateSubscription}
              disabled={!selectedPlan || !planConfirmed || billingLoading || (!billing.paymentMethods || billing.paymentMethods.length === 0)}
              className={`px-6 py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed ${(!billing.paymentMethods || billing.paymentMethods.length === 0) || !planConfirmed
                ? 'bg-gray-600 text-gray-300 cursor-not-allowed'
                : 'bg-blue-600 !text-white hover:bg-blue-700'
                }`}
            >
              {billingLoading ? 'Processing...' :
                (!billing.paymentMethods || billing.paymentMethods.length === 0) ? 'Add Payment Method First' :
                  !planConfirmed ? 'Confirm Plan First' : 'Buy Plan'}
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Handle Downgrade Confirmation
  const handleDowngradeConfirm = async () => {
    if (!pendingDowngrade) return;

    try {
      setDowngradeProcessingPlan(pendingDowngrade.plan);
      setShowDowngradeConfirmModal(false);
      toast.loading(`Downgrading to ${pendingDowngrade.name}...`, { id: 'downgrade-loading' });

      const currentSlots = billing.paidMemberSlots || 1;
      const memberCount = currentSlots - 1;

      // Try Razorpay first for Razorpay users
      if (billing.paymentGateway === 'razorpay') {
        try {
          const rzpRes = await api.post('/api/v1/public/razorpay-billing/organization-subscription-checkout', {
            userId: user?.id, plan: pendingDowngrade.plan, memberCount,
          });
          if (rzpRes.data?.success && (rzpRes.data?.data?.subscriptionId || rzpRes.data?.data?.orderId)) {
            toast.dismiss('downgrade-loading');
            const rzpData = rzpRes.data.data;
            openRazorpayCheckout({
              razorpayKeyId: rzpData.razorpayKeyId, amount: rzpData.amount,
              currency: rzpData.currency, orderId: rzpData.orderId,
              subscriptionId: rzpData.subscriptionId,
              customerName: rzpData.customerName, customerEmail: rzpData.customerEmail,
              notes: rzpData.notes, description: `TeamGrid ${pendingDowngrade.name} Downgrade`,
              onSuccess: async (pr) => {
                try {
                  await api.post('/api/v1/public/razorpay-billing/verify-payment', {
                    razorpay_order_id: pr.razorpay_order_id, razorpay_payment_id: pr.razorpay_payment_id,
                    razorpay_signature: pr.razorpay_signature, razorpay_subscription_id: pr.razorpay_subscription_id,
                    userId: user?.id,
                    organizationId: rzpData.notes.organizationId, plan: pendingDowngrade.plan,
                    memberCount, totalSeats: rzpData.totalSeats, type: rzpData.billingType === 'one_time' ? 'one_time_payment' : 'organization_subscription',
                  });
                  toast.success('Downgrade successful!');
                  setTimeout(() => { window.location.href = '/dashboard/settings?section=billing&payment=success'; }, 100);
                } catch { toast.error('Payment verification failed'); setDowngradeProcessingPlan(null); }
              },
              onFailure: () => { toast.error('Payment failed'); setDowngradeProcessingPlan(null); },
              onDismiss: () => { setDowngradeProcessingPlan(null); },
            });
            setPendingDowngrade(null);
            return;
          }
        } catch { /* fall through to Stripe */ }
      }

      const response = await api.post('/api/v1/public/billing/organization-subscription-checkout', {
        userId: user?.id,
        plan: pendingDowngrade.plan,
        memberCount: memberCount
      });

      if (response.data.success) {
        toast.dismiss('downgrade-loading');
        window.location.href = response.data.data.url;
      } else {
        toast.error(response.data.message || 'Failed to start downgrade');
        setDowngradeProcessingPlan(null);
      }
    } catch (error) {
      toast.dismiss('downgrade-loading');
      toast.error(error.response?.data?.message || 'Failed to downgrade plan');
      setDowngradeProcessingPlan(null);
    } finally {
      setPendingDowngrade(null);
    }
  };

  // Downgrade Confirmation Modal
  const renderDowngradeConfirmModal = () => {
    if (!showDowngradeConfirmModal || !pendingDowngrade) return null;

    const currentSlots = billing.paidMemberSlots || 1;
    const totalAmount = currentSlots * pendingDowngrade.price;
    const currentPlanAmount = billing.orgPlanAmount || 0;
    const currentTotalAmount = currentSlots * currentPlanAmount;

    return (
      <Modal
        open={showDowngradeConfirmModal}
        onCancel={() => {
          setShowDowngradeConfirmModal(false);
          setPendingDowngrade(null);
        }}
        footer={null}
        closable={true}
        width={600}
        className="downgrade-confirm-modal"
        styles={{
          mask: { backgroundColor: isDark ? 'rgba(0, 0, 0, 0.75)' : 'rgba(0, 0, 0, 0.5)', backdropFilter: 'blur(8px)' },
          content: { backgroundColor: 'transparent', boxShadow: 'none', padding: 0 }
        }}
      >
        <AnimatePresence>
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ duration: 0.3 }}
            className={`${isDark
              ? 'bg-gradient-to-br from-zinc-900/95 via-zinc-800/95 to-zinc-900/95 border border-orange-500/30'
              : 'bg-white border border-orange-200 shadow-xl'
              } rounded-2xl p-6 backdrop-blur-xl`}
          >
            {/* Header */}
            <motion.div
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 }}
              className="text-center mb-6"
            >
              <div className="flex items-center justify-center mb-4">
                <div className={`w-16 h-16 rounded-full flex items-center justify-center border-2 ${isDark ? 'bg-gradient-to-br from-orange-500/20 to-orange-600/15 border-orange-500/30' : 'bg-orange-100 border-orange-300'
                  }`}>
                  <AlertTriangle className={`w-8 h-8 ${isDark ? 'text-orange-400' : 'text-orange-600'}`} />
                </div>
              </div>
              <Title level={3} className={`!mb-0 !text-2xl !font-bold ${isDark ? '!text-white' : '!text-slate-900'}`}>
                Confirm Downgrade
              </Title>
              <Paragraph className={`!text-base !mb-0 !mt-2 ${isDark ? '!text-gray-400' : '!text-slate-600'}`}>
                Are you sure you want to downgrade your plan?
              </Paragraph>
            </motion.div>

            {/* Warning Card */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2 }}
              className="mb-6"
            >
              <div className={`p-5 rounded-xl border-2 shadow-lg ${isDark ? 'bg-gradient-to-br from-orange-950/80 via-orange-900/70 to-amber-950/80 border-orange-500/40 backdrop-blur-sm' : 'bg-orange-50 border-orange-300'
                }`}>
                <div className="flex items-start space-x-4">
                  <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 border ${isDark ? 'bg-orange-500/20 border-orange-400/30' : 'bg-orange-100 border-orange-300'
                    }`}>
                    <AlertTriangle className={`w-6 h-6 ${isDark ? 'text-orange-300' : 'text-orange-600'}`} />
                  </div>
                  <div className="flex-1">
                    <h4 className={`font-bold text-lg mb-3 ${isDark ? 'text-orange-200' : 'text-orange-700'}`}>Important Notice</h4>
                    <div className="space-y-2.5">
                      <div className="flex items-start space-x-2">
                        <span className={`font-bold text-base mt-0.5 ${isDark ? 'text-orange-400' : 'text-orange-600'}`}>•</span>
                        <Text className={`text-sm leading-relaxed ${isDark ? 'text-white' : 'text-slate-700'}`}>
                          You will lose access to <span className={`font-bold ${isDark ? 'text-orange-300' : 'text-orange-600'}`}>Org Intelligence</span> feature
                        </Text>
                      </div>
                      <div className="flex items-start space-x-2">
                        <span className={`font-bold text-base mt-0.5 ${isDark ? 'text-orange-400' : 'text-orange-600'}`}>•</span>
                        <Text className={`text-sm leading-relaxed ${isDark ? 'text-white' : 'text-slate-700'}`}>
                          All other features will remain available
                        </Text>
                      </div>
                      <div className="flex items-start space-x-2">
                        <span className={`font-bold text-base mt-0.5 ${isDark ? 'text-orange-400' : 'text-orange-600'}`}>•</span>
                        <Text className={`text-sm leading-relaxed ${isDark ? 'text-white' : 'text-slate-700'}`}>
                          Your current <span className={`font-bold ${isDark ? 'text-orange-300' : 'text-orange-600'}`}>{currentSlots}</span> slots will be maintained
                        </Text>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Plan Comparison */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="mb-6"
            >
              <AntCard
                className={isDark ? "border-white/10 bg-white/5" : "border-gray-200 bg-gray-50"}
                style={{ borderRadius: '12px' }}
              >
                <Space direction="vertical" size="middle" className="w-full">
                  <div className="flex justify-between items-center">
                    <Text className={`text-sm ${isDark ? 'text-gray-400' : 'text-slate-600'}`}>Current Plan:</Text>
                    <Badge
                      color="purple"
                      text={<span className={`text-sm font-semibold ${isDark ? 'text-white' : 'text-slate-900'}`}>Premium</span>}
                    />
                  </div>
                  <Divider className={`!my-2 ${isDark ? '!border-white/10' : '!border-gray-200'}`} />
                  <div className="flex justify-between items-center">
                    <Text className={`text-sm ${isDark ? 'text-gray-400' : 'text-slate-600'}`}>New Plan:</Text>
                    <Badge
                      color="blue"
                      text={<span className={`text-sm font-semibold ${isDark ? 'text-white' : 'text-slate-900'}`}>{pendingDowngrade.name}</span>}
                    />
                  </div>
                  <Divider className={`!my-2 ${isDark ? '!border-white/10' : '!border-gray-200'}`} />
                  <div className="flex justify-between items-center">
                    <Text className={`text-sm ${isDark ? 'text-gray-400' : 'text-slate-600'}`}>Total Slots:</Text>
                    <Text className={`font-semibold text-base ${isDark ? 'text-white' : 'text-slate-900'}`}>{currentSlots} slots</Text>
                  </div>
                  <Divider className={`!my-2 ${isDark ? '!border-white/10' : '!border-gray-200'}`} />
                  <div className="flex justify-between items-center">
                    <Text className={`text-sm ${isDark ? 'text-gray-400' : 'text-slate-600'}`}>Current Monthly Cost:</Text>
                    <Text className={`font-semibold text-base ${isDark ? 'text-white' : 'text-slate-900'}`}>{symbol}{currentTotalAmount.toFixed(2)}/month</Text>
                  </div>
                  <Divider className={`!my-2 ${isDark ? '!border-orange-500/30' : '!border-orange-200'}`} />
                  <div className={`flex justify-between items-center p-3 rounded-lg border ${isDark ? 'bg-gradient-to-r from-green-500/10 to-emerald-500/10 border-green-500/20' : 'bg-green-50 border-green-200'
                    }`}>
                    <Text className={`font-semibold text-base ${isDark ? 'text-green-300' : 'text-green-700'}`}>New Monthly Cost:</Text>
                    <Text className={`font-bold text-xl ${isDark ? 'text-green-400' : 'text-green-600'}`}>{symbol}{totalAmount.toFixed(2)}/month</Text>
                  </div>
                  <div className="flex justify-between items-center mt-2">
                    <Text className={`text-xs ${isDark ? 'text-gray-400' : 'text-slate-600'}`}>You'll save:</Text>
                    <Text className={`font-semibold text-sm ${isDark ? 'text-green-400' : 'text-green-600'}`}>
                      {symbol}{(currentTotalAmount - totalAmount).toFixed(2)}/month
                    </Text>
                  </div>
                </Space>
              </AntCard>
            </motion.div>

            {/* Action Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.4 }}
              className="flex space-x-3"
            >
              <AntButton
                size="large"
                onClick={() => {
                  setShowDowngradeConfirmModal(false);
                  setPendingDowngrade(null);
                }}
                disabled={downgradeProcessingPlan !== null}
                className={`flex-1 ${isDark
                  ? 'bg-white/10 hover:bg-white/20 border-white/20 text-white'
                  : 'bg-gray-100 hover:bg-gray-200 border-gray-300 text-gray-800'
                  }`}
                style={{ height: '48px', borderRadius: '8px' }}
              >
                Cancel
              </AntButton>
              <AntButton
                type="primary"
                size="large"
                onClick={handleDowngradeConfirm}
                disabled={downgradeProcessingPlan !== null}
                loading={downgradeProcessingPlan !== null}
                className="flex-1 bg-orange-600 hover:bg-orange-700 border-orange-600"
                style={{ height: '48px', borderRadius: '8px' }}
                icon={<TrendingDown className="w-4 h-4" />}
              >
                {downgradeProcessingPlan ? 'Processing...' : 'Confirm Downgrade'}
              </AntButton>
            </motion.div>

            <Text className={`text-xs block text-center mt-4 ${isDark ? 'text-gray-400' : 'text-slate-600'}`}>
              ⚠️ This action cannot be undone. You'll need to upgrade again to regain premium features.
            </Text>
          </motion.div>
        </AnimatePresence>
      </Modal>
    );
  };

  // Payment Method Modal
  const renderPaymentModal = () => {
    if (!showPaymentModal) return null;

    return (
      <CardForm
        onSuccess={() => {
          setShowPaymentModal(false);
          fetchPaymentMethods();
        }}
        onCancel={() => setShowPaymentModal(false)}
        user={user}
      />
    );
  };

  return (
    <PageAnimationWrapper>
      <div className="w-full px-6 py-6 min-w-0 overflow-visible">
        {/* Header Section */}
        <div className="mb-6">
          <div className="flex items-center justify-between">
            <div className="flex-1">
              <div className="flex items-center space-x-3 mb-2">
                <h1 className={`text-2xl font-bold ${theme === 'dark' ? 'text-white' : 'text-gray-900'}`}>Settings</h1>
                <div className="group relative">
                  <Lightbulb className="h-4 w-4 text-yellow-400 cursor-help" />
                  <div className={`absolute left-0 top-6 border rounded-lg p-3 text-xs w-72 opacity-0 group-hover:opacity-100 transition-opacity z-50 shadow-xl ${theme === 'dark'
                    ? 'bg-black/90 border-white/20 text-white'
                    : 'bg-white/95 border-gray-200 text-gray-900'
                    }`}>
                    <div className="font-semibold text-yellow-400 mb-2">⚙️ Settings Overview</div>
                    <p>Manage your account and application settings. Configure organization profile, billing, security, and team structure settings.</p>
                  </div>
                </div>
              </div>
              <p className={`text-sm ${theme === 'dark' ? 'text-gray-400' : 'text-gray-600'}`}>
                Manage your account and application settings. Configure organization, billing, security, and team structure settings.
              </p>
            </div>
            <div className="hidden lg:flex items-center space-x-4">
              <div className="text-right">
                <div className="text-sm font-medium text-white">{new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</div>
                <div className="text-xs text-gray-400 uppercase tracking-wider">{new Date().toLocaleDateString('en-US', { weekday: 'long' })}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          {/* Sidebar Navigation - Fixed */}
          <div className="lg:w-64 lg:flex-shrink-0">
            <div className="lg:sticky lg:top-6 lg:self-start">
              <div className="bg-white/5 border border-white/10 rounded-lg p-4">
                <nav className="space-y-2">
                  {navigation.map((item) => {
                    const Icon = item.icon;
                    return (
                      <button
                        key={item.id}
                        onClick={() => handleSectionChange(item.id)}
                        className={`w-full flex items-center space-x-3 px-3 py-2 rounded-md text-sm transition-colors ${activeSection === item.id
                          ? 'bg-white/10 text-white'
                          : 'text-gray-400 hover:text-white hover:bg-white/5'
                          }`}
                      >
                        <Icon className="h-4 w-4" />
                        <span>{item.label}</span>
                      </button>
                    );
                  })}
                </nav>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-1 lg:min-h-screen min-w-0">
            <div className="bg-white/5 border border-white/10 rounded-lg p-6 min-w-0 overflow-visible">
              {renderContent()}
            </div>
          </div>
        </div>
      </div>

      {/* Modals */}
      {renderPlanModal()}
      {renderPaymentModal()}
      {renderDowngradeConfirmModal()}
      {renderUnsavedChangesModal()}
      <DeleteStructureConfirmModal
        visible={deleteStructureConfirm.visible}
        type={deleteStructureConfirm.type}
        positionName={deleteStructureConfirm.positionName}
        affectedMembers={deleteStructureConfirm.affectedMembers}
        loading={deleteStructureConfirm.loading}
        isDark={isDark}
        onCancel={() => setDeleteStructureConfirm(prev => ({ ...prev, visible: false }))}
        onConfirm={confirmDeleteStructure}
      />
    </PageAnimationWrapper>
  );
};

export default Settings;
